// Web CRM (Business plane) — Settings / Integrations / Surveys / AI Metrics / Solution Bank /
// WebRTC call UI / Trial banner static-UI translations. Merged into the shared flat per-language
// lookup at load time (see translations.js). STATIC UI CHROME ONLY; English default + fallback.
// 10-language parity: every language carries the identical `st.*` key set.

const settingsMiscTranslations = {
  en: {
    'st.active': 'Active',
    'st.inactive': 'Inactive',
    'st.enabled': 'Enabled',
    'st.disabled': 'Disabled',
    'st.integrations': 'Integrations',
    'st.saveChanges': 'Save Changes',
    'st.savingEllipsis': 'Saving…',
    'st.settings.loading': 'Loading settings…',
    'st.settings.unavailable': 'Workspace settings are temporarily unavailable. Please retry.',
    'st.settings.noWorkspace': 'Your account is not linked to a workspace yet, so settings cannot load. Contact your administrator if this is unexpected.',
    'st.settings.manageWorkspace': 'Manage your workspace',
    'st.settings.reset': 'Reset',
    'st.settings.tab.general': 'General',
    'st.settings.tab.notifications': 'Notifications',
    'st.settings.tab.ai': 'AI Settings',
    'st.settings.tab.security': 'Security',
    'st.settings.tab.users': 'User Management',
    'st.settings.displayName': 'Workspace Display Name',
    'st.settings.timezone': 'Workspace Timezone',
    'st.settings.timezonePh': 'e.g. America/New_York',
    'st.settings.aiDefaultLang': 'AI Default Language',
    'st.settings.aiLangHelp': "Language the AI replies in when the customer's language can't be detected. Does not change the web UI language.",
    'st.settings.archiveDays': 'Archive records after N days (0 = keep all)',
    'st.settings.archiveHelp': 'Soft-archives old conversations/tickets (never hard-deletes). Enforcement runs only when enabled by your administrator.',
    'st.settings.callRecording': 'Call Audio Recording',
    'st.settings.callRecordingDesc': 'Records audio for outbound, transfer, and conference calls.',
    'st.settings.callRecordingNote': 'Inbound AI-assistant calls generate operational transcripts required for service context, escalation, and ticket creation (always retained, separate from audio recording).',
    'st.settings.emailNotif': 'Email Notifications',
    'st.settings.emailNotifDesc': 'Operational follow-up emails to customers',
    'st.settings.smsNotif': 'SMS Notifications',
    'st.settings.smsNotifDesc': 'Operational follow-up SMS to customers (carrier charges may apply)',
    'st.settings.transactionalNote': 'Transactional messages (OTP, invites, billing, security) are always sent and are not affected by these preferences.',
    'st.settings.aiAutoRes': 'AI Auto-Resolution',
    'st.settings.aiAutoResDesc': 'When off, the AI escalates to a human instead of auto-resolving.',
    'st.settings.saveAi': 'Save AI Settings',
    'st.settings.manageAutoRules': 'Manage Auto-Resolution Rules & Thresholds',
    'st.settings.securityCompliance': 'Security & Compliance',
    'st.settings.auditLogging': 'Audit Logging',
    'st.settings.auditActive': 'Active ({count} events)',
    'st.settings.auditNone': 'No recorded activity',
    'st.settings.compliance': 'Compliance Attestations',
    'st.settings.notPublished': 'Not published',
    'st.settings.manageTeam': 'Manage team members and roles.',
    'st.settings.manageUsers': 'Manage Users',
    'st.settings.teamMembers': 'Team Members',
    'st.settings.inviteReview': 'Invite staff and review your team.',
    'st.settings.addUser': 'Add User',
    'st.settings.inviteStaffMember': 'Invite Staff Member',
    'st.settings.onboardingEmail': 'An onboarding email will be sent.',
    'st.settings.email': 'Email',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': 'Role',
    'st.settings.sending': 'Sending…',
    'st.settings.sendInvite': 'Send Invitation',
    'st.settings.noTeamMembers': 'No team members found',
    'st.settings.staffRole': 'staff',
    'st.settings.toast.saved': 'Settings saved',
    'st.settings.toast.savedDesc': 'Workspace settings updated.',
    'st.settings.toast.saveFailed': 'Save failed',
    'st.settings.toast.aiSaved': 'AI settings saved',
    'st.settings.toast.aiSavedDesc': 'Auto-resolution preference updated.',
    'st.settings.toast.invalidEmail': 'Invalid email',
    'st.settings.toast.invalidEmailDesc': 'Enter a valid email address.',
    'st.settings.toast.inviteSent': 'Invitation sent',
    'st.settings.toast.inviteSentDesc': 'Invite sent to {email}.',
    'st.settings.toast.inviteFailed': 'Invite failed',
    'st.settings.inviteNotSent': 'Invite was not sent',
    'st.settings.errLoadSettings': 'Failed to load settings ({status})',
    'st.settings.errSaveFailed': 'Save failed ({status})',
    'st.settings.errInviteFailed': 'Invite failed ({status})',
    'st.integ.planBadge': '{tier} plan',
    'st.integ.desc': 'Connect channels, CRMs, monitoring and automation. {allowed}/{total} available on your plan.',
    'st.integ.unlimited': 'Unlimited active integrations.',
    'st.integ.upTo': 'Up to {cap} active ({enabled}/{cap}).',
    'st.integ.notRegistered': 'Not registered',
    'st.integ.notRegisteredDesc': 'Complete subscription before configuring integrations.',
    'st.integ.saved': 'Saved',
    'st.integ.savedDesc': '{name} updated.',
    'st.integ.saveFailed': 'Save failed',
    'st.integ.upgrade': 'Upgrade',
    'st.integ.configured': 'Configured',
    'st.integ.needsCreds': 'Needs credentials',
    'st.integ.available': 'Available to configure',
    'st.integ.enable': 'Enable {name}',
    'st.integ.noExecNote': 'Saving stores your configuration securely. Live workflow execution isn’t enabled for this connector yet.',
    'st.integ.higherPlan': 'Available on a higher plan. Upgrade in Billing to enable {name}.',
    'st.hub.subtitle': "Your tenant's connectors",
    'st.hub.planTag': '{tier} plan',
    'st.hub.refreshStatus': 'Refresh Status',
    'st.hub.exportData': 'Export Data',
    'st.hub.addIntegration': 'Add Integration',
    'st.hub.scopeNote': 'Tenant-scoped integrations only. Platform infrastructure and platform-level governance are managed by Servisfy and are not shown here.',
    'st.hub.none': 'No integrations configured for this tenant.',
    'st.hub.configureInSettings': 'Configure in Settings → Integrations',
    'st.hub.connectorNote': 'Tenant connector. Credentials are managed securely and are not shown here.',
    'st.hub.syncNote': 'Sync & connector test are not available for this connector yet.',
    'st.hub.configure': 'Configure',
    'st.hub.webhooks': 'Webhooks',
    'st.hub.webhooksNote': 'Webhook management is not configured for this tenant.',
    'st.hub.errLoad': 'Failed to load integrations ({status})',
    'st.survey.qtype.multiple_choice': 'Multiple Choice',
    'st.survey.qtype.text': 'Text Response',
    'st.survey.qtype.rating': 'Rating Scale',
    'st.survey.qtype.yes_no': 'Yes/No',
    'st.survey.loadFail': 'Could not load surveys',
    'st.survey.loadFailDesc': 'Please retry, or contact your administrator if this persists.',
    'st.survey.missingInfo': 'Missing information',
    'st.survey.missingInfoDesc': 'A title and at least one question are required.',
    'st.survey.notAllowed': 'Not allowed',
    'st.survey.notAllowedEdit': 'Only a Manager or Administrator can edit surveys.',
    'st.survey.updated': 'Survey updated',
    'st.survey.updatedDesc': 'Your changes were saved.',
    'st.survey.updateFail': 'Update failed',
    'st.survey.updateFailDesc': 'Could not save the survey. Please try again.',
    'st.survey.notAllowedStatus': 'Only a Manager or Administrator can change survey status.',
    'st.survey.statusFail': 'Could not update status',
    'st.survey.notAllowedResults': 'Only a Manager or Administrator can view results.',
    'st.survey.resultsFail': 'Could not load results',
    'st.survey.manage': 'Manage Surveys ({count})',
    'st.survey.loading': 'Loading surveys…',
    'st.survey.empty': 'No surveys yet. Create one above to get started.',
    'st.survey.qCount': '{count} Q',
    'st.survey.responses': '{count} responses',
    'st.survey.results': 'Results',
    'st.survey.toggleActive': 'Toggle active',
    'st.survey.editTitle': 'Edit Survey',
    'st.survey.editDesc': 'Update survey details and questions. Saved via the tenant-scoped survey API.',
    'st.survey.fTitle': 'Title *',
    'st.survey.fDesc': 'Description',
    'st.survey.fType': 'Type',
    'st.survey.paid': 'Paid',
    'st.survey.unpaid': 'Unpaid',
    'st.survey.fReward': 'Reward',
    'st.survey.fDeadline': 'Deadline',
    'st.survey.questions': 'Questions ({count})',
    'st.survey.addQuestion': 'Add Question',
    'st.survey.questionPh': 'Question text',
    'st.survey.optionPh': 'Option {n}',
    'st.survey.addOption': 'Add Option',
    'st.survey.required': 'Required',
    'st.survey.resultsTitle': 'Survey Results',
    'st.survey.loadingResults': 'Loading results…',
    'st.survey.totalResponses': '{count} total response(s)',
    'st.survey.downloadCsv': 'Download CSV',
    'st.survey.average': 'Average:',
    'st.survey.noResults': 'No results available.',
    'st.voice.loading': 'Loading voice metrics...',
    'st.voice.loadError': 'Failed to load voice metrics',
    'st.voice.aiCalls': 'AI Calls',
    'st.voice.aiResolved': 'AI Resolved',
    'st.voice.ncalls': '{count} calls',
    'st.voice.escalationRate': 'Escalation Rate',
    'st.voice.avgDuration': 'Avg Duration',
    'st.voice.perCall': 'Per call',
    'st.voice.csat': 'Voice CSAT',
    'st.voice.totalAiCalls': 'Total AI Calls',
    'st.voice.aiResRate': 'AI Resolution Rate',
    'st.voice.callsResolvedByAi': '{count} calls resolved by AI',
    'st.voice.nEscalated': '{count} escalated',
    'st.voice.avgCallDuration': 'Avg Call Duration',
    'st.voice.nRatings': '{count} ratings',
    'st.voice.noRatings': 'No ratings yet',
    'st.voice.aiHandled': 'AI Handled',
    'st.voice.noHumanTransfer': 'No human transfer',
    'st.voice.pendingCallbacks': 'Pending Callbacks',
    'st.voice.overdueCallbacks': 'Overdue Callbacks',
    'st.voice.past5minSla': 'Past 5-min SLA',
    'st.voice.avgResTime': 'Avg Resolution Time',
    'st.voice.operatorAssignments': 'Operator Assignments',
    'st.voice.operatorResolutions': 'Operator Resolutions',
    'st.voice.noData': 'No voice call data yet. Voice calls will appear here once processed.',
    'st.aim.loading': 'Loading AI Metrics...',
    'st.aim.loadError': 'Failed to load AI metrics',
    'st.aim.subtitle': 'Monitor AI-driven auto-resolution and escalation metrics',
    'st.aim.excellent': 'Excellent',
    'st.aim.good': 'Good',
    'st.aim.needsImprovement': 'Needs Improvement',
    'st.aim.totalConversations': 'Total Conversations',
    'st.aim.aiProcessedChats': 'AI-processed chats',
    'st.aim.autoResRate': 'Auto-Resolution Rate',
    'st.aim.nResolved': '{count} resolved',
    'st.aim.escalationRate': 'Escalation Rate',
    'st.aim.nEscalated': '{count} escalated',
    'st.aim.avgConfidence': 'Avg Confidence',
    'st.aim.intentAccuracy': 'Intent accuracy',
    'st.aim.languageDistribution': 'Language Distribution',
    'st.aim.convByLanguage': 'Conversations by language',
    'st.aim.noLanguageData': 'No language data available',
    'st.aim.intentDistribution': 'Intent Distribution',
    'st.aim.customerIntents': 'Customer intents identified by AI',
    'st.aim.noIntentData': 'No intent data available',
    'st.aim.escalationBreakdown': 'Escalation Breakdown',
    'st.aim.escalationByLevel': 'Escalations by level (Operator → Manager → Admin)',
    'st.aim.aiVoiceAnalytics': 'AI Voice Analytics',
    'st.aim.totalVoiceCalls': 'Total Voice Calls',
    'st.aim.allInboundCalls': 'All inbound calls',
    'st.aim.aiHandled': 'AI Handled',
    'st.aim.noHumanTransfer': 'No human transfer',
    'st.aim.aiResolved': 'AI Resolved',
    'st.aim.confirmedResolved': 'Confirmed resolved',
    'st.aim.humanEscalated': 'Human Escalated',
    'st.aim.escalationRatePct': '{rate}% escalation rate',
    'st.aim.pendingCallbacks': 'Pending Callbacks',
    'st.aim.awaitingCallback': 'Awaiting callback',
    'st.aim.overdueCallbacks': 'Overdue Callbacks',
    'st.aim.pastSlaDeadline': 'Past SLA deadline',
    'st.aim.avgCallDuration': 'Avg Call Duration',
    'st.aim.minutesPerCall': 'Minutes per call',
    'st.aim.avgResTime': 'Avg Resolution Time',
    'st.aim.createResolve': 'Create → resolve',
    'st.aim.slaBreaches': 'Callback SLA Breaches',
    'st.aim.slaBreachesNote': 'Callbacks that exceeded the 5-minute SLA',
    'st.sbm.untitled': 'Untitled solution',
    'st.sbm.approved': 'Solution Approved',
    'st.sbm.approvedDesc': 'Solution is now available for AI reuse.',
    'st.sbm.approvalFailed': 'Approval Failed',
    'st.sbm.rejected': 'Solution Rejected',
    'st.sbm.rejectedDesc': 'Solution will not be used by AI.',
    'st.sbm.rejectionFailed': 'Rejection Failed',
    'st.sbm.missingInfo': 'Missing Information',
    'st.sbm.missingInfoDesc': 'Please fill in title, description and resolution steps.',
    'st.sbm.noBusiness': 'No Business Selected',
    'st.sbm.noBusinessDesc': 'Cannot submit — no active business context.',
    'st.sbm.updated': 'Solution Updated',
    'st.sbm.updatedDesc': 'Changes saved successfully.',
    'st.sbm.submitted': 'Solution Submitted',
    'st.sbm.submittedDesc': 'Solution submitted for management approval. Status: pending_approval.',
    'st.sbm.submitFailed': 'Submit Failed',
    'st.sbm.networkError': 'Network error',
    'st.sbm.confirmDelete': 'Delete "{title}"? This cannot be undone.',
    'st.sbm.deleted': 'Solution Deleted',
    'st.sbm.deletedDesc': 'Solution permanently removed.',
    'st.sbm.deleteFailed': 'Delete Failed',
    'st.sbm.title': 'Solution Bank Management',
    'st.sbm.subtitle': 'Create and manage AI-powered solutions for common issues',
    'st.sbm.editSolution': 'Edit Solution',
    'st.sbm.structure': 'Solution Structure',
    'st.sbm.fTitle': 'Solution Title *',
    'st.sbm.fTitlePh': 'Brief, descriptive title for this solution',
    'st.sbm.fDesc': 'Problem Description *',
    'st.sbm.fDescPh': 'Describe the problem this solution addresses',
    'st.sbm.fCategory': 'Issue Category *',
    'st.sbm.categoryPh': 'Select issue category',
    'st.sbm.fType': 'Issue Type *',
    'st.sbm.typePh': 'Select issue type',
    'st.sbm.fDifficulty': 'Difficulty Level *',
    'st.sbm.difficultyPh': 'Select difficulty level',
    'st.sbm.diffLow': 'Low - Simple, quick resolution',
    'st.sbm.diffMedium': 'Medium - Moderate complexity',
    'st.sbm.diffHigh': 'High - Complex, technical solution',
    'st.sbm.fTags': 'Tags *',
    'st.sbm.tagsPh': 'Keywords separated by commas',
    'st.sbm.tagsHelp': 'Keywords customers might use (e.g., login, password, reset)',
    'st.sbm.fResolution': 'Resolution Steps *',
    'st.sbm.resolutionPh': 'Enter each step on a new line:\nStep 1: Navigate to login page\nStep 2: Click forgot password\nStep 3: Enter email address\netc...',
    'st.sbm.resolutionHelp': 'Write clear, step-by-step instructions. Each step should be on a new line.',
    'st.sbm.updateSolution': 'Update Solution',
    'st.sbm.addSolution': 'Add Solution',
    'st.sbm.pendingApprovals': 'Pending Approvals',
    'st.sbm.nPending': '{count} pending',
    'st.sbm.uncategorized': 'Uncategorized',
    'st.sbm.submittedOn': 'Submitted {date}',
    'st.sbm.noSolutions': 'No Solutions Created',
    'st.sbm.noSolutionsDesc': 'Start building your knowledge base by adding your first solution',
    'st.sbm.addFirst': 'Add First Solution',
    'st.sbm.successRate': '{rate}% Success Rate',
    'st.sbm.uses': '{count} Uses',
    'st.sbm.keywords': 'Keywords',
    'st.sbm.resolutionSteps': 'Resolution Steps',
    'st.sbm.lastUpdated': 'Last updated: {date}',
    'st.sbm.addedBy': 'Added by: {name}',
    'st.sbm.unknown': 'Unknown',
    'st.conf.tapEnableAudio': 'Tap to enable audio',
    'st.conf.inviting': 'Inviting…',
    'st.conf.noAnswer': 'No answer',
    'st.conf.declined': 'Declined',
    'st.conf.reconnecting': 'Reconnecting…',
    'st.conf.lost': 'Lost',
    'st.conf.connected': 'Connected',
    'st.conf.noAudio': 'No audio',
    'st.conf.connectingAudio': 'Connecting audio…',
    'st.conf.connecting': 'Connecting…',
    'st.conf.audioConference': 'Audio Conference',
    'st.conf.invitingYou': '{host} is inviting you to an audio conference.',
    'st.conf.decline': 'Decline',
    'st.conf.accept': 'Accept',
    'st.conf.host': 'Host',
    'st.conf.participant': 'Participant',
    'st.conf.you': 'You',
    'st.conf.muted': '(muted)',
    'st.conf.unmute': 'Unmute',
    'st.conf.mute': 'Mute',
    'st.conf.noOneYet': 'No one else yet — invite a teammate below.',
    'st.conf.removeFromConf': 'Remove from conference',
    'st.conf.addTeammate': '+ Add online teammate…',
    'st.conf.noStaffOnline': 'No other staff currently online to add.',
    'st.conf.endConference': 'End conference',
    'st.conf.leave': 'Leave',
    'st.call.userFallback': 'User {id}',
    'st.call.shareVideoOnlyMsg': 'Screen share is available on video calls.',
    'st.call.shareCouldNotStart': 'Screen share could not start.',
    'st.call.onHold': 'On Hold • {dur}',
    'st.call.connected': 'Connected • {dur}',
    'st.call.connecting': 'Connecting...',
    'st.call.video': 'Video',
    'st.call.tapEnableCallAudio': '🔊 Tap to enable call audio',
    'st.call.callDuration': 'Call duration: {dur}',
    'st.call.resume': 'Resume call',
    'st.call.hold': 'Hold call',
    'st.call.sharingScreen': 'Sharing screen',
    'st.call.shareScreen': 'Share screen',
    'st.call.shareVideoOnly': 'Screen share is available on video calls',
    'st.call.endCall': 'End call',
    'st.call.callVolume': 'Call volume',
    'st.trial.errResolveTenant': 'Could not resolve tenant',
    'st.trial.errPortalUnavailable': 'Portal unavailable',
    'st.trial.stripeFail': 'Could not open Stripe portal',
    'st.trial.stripeFailDesc': '{message}. Redirecting to billing page.',
    'st.trial.frozenHeadline': 'Your subscription is paused — account is in read-only mode',
    'st.trial.frozenSub': 'Reactivate now to unlock new tickets, conversations and team management.',
    'st.trial.reactivate': 'Reactivate',
    'st.trial.nDays': '{count} days',
    'st.trial.nHours': '{count} hours',
    'st.trial.nHour': '{count} hour',
    'st.trial.pastDueHeadline': 'Payment failed — update your card before {remainder}',
    'st.trial.pastDueSub': "We'll retry automatically (attempt {attempt} of {max}). Your account stays active during the grace period.",
    'st.trial.openingStripe': 'Opening Stripe…',
    'st.trial.updatePayment': 'Update Payment Method',
    'st.trial.expiredHeadline': 'Your trial has ended',
    'st.trial.expiredSub': 'Upgrade now to keep your team and customers connected.',
    'st.trial.upgradeNow': 'Upgrade now',
    'st.trial.urgentHeadlineOne': 'Only {count} hour left in your trial',
    'st.trial.urgentHeadline': 'Only {count} hours left in your trial',
    'st.trial.soonSub': 'Pick a plan now to keep all features and data after your trial ends.',
    'st.trial.soonHeadline': '{count} days left in your trial',
    'st.trial.dismiss': 'Dismiss',
  },
  es: {
    'st.active': 'Activo',
    'st.inactive': 'Inactivo',
    'st.enabled': 'Habilitado',
    'st.disabled': 'Deshabilitado',
    'st.integrations': 'Integraciones',
    'st.saveChanges': 'Guardar cambios',
    'st.savingEllipsis': 'Guardando…',
    'st.settings.loading': 'Cargando ajustes…',
    'st.settings.unavailable': 'Los ajustes del espacio de trabajo no están disponibles temporalmente. Vuelve a intentarlo.',
    'st.settings.noWorkspace': 'Tu cuenta aún no está vinculada a un espacio de trabajo, por lo que los ajustes no se pueden cargar. Contacta con tu administrador si esto no es lo esperado.',
    'st.settings.manageWorkspace': 'Gestiona tu espacio de trabajo',
    'st.settings.reset': 'Restablecer',
    'st.settings.tab.general': 'General',
    'st.settings.tab.notifications': 'Notificaciones',
    'st.settings.tab.ai': 'Ajustes de IA',
    'st.settings.tab.security': 'Seguridad',
    'st.settings.tab.users': 'Gestión de usuarios',
    'st.settings.displayName': 'Nombre visible del espacio de trabajo',
    'st.settings.timezone': 'Zona horaria del espacio de trabajo',
    'st.settings.timezonePh': 'p. ej. America/New_York',
    'st.settings.aiDefaultLang': 'Idioma predeterminado de la IA',
    'st.settings.aiLangHelp': 'Idioma en el que responde la IA cuando no se puede detectar el idioma del cliente. No cambia el idioma de la interfaz web.',
    'st.settings.archiveDays': 'Archivar registros después de N días (0 = conservar todo)',
    'st.settings.archiveHelp': 'Archiva de forma temporal conversaciones/tickets antiguos (nunca los elimina de forma permanente). La aplicación de esta regla solo se ejecuta cuando la habilita tu administrador.',
    'st.settings.callRecording': 'Grabación de audio de llamadas',
    'st.settings.callRecordingDesc': 'Graba el audio de las llamadas salientes, de transferencia y de conferencia.',
    'st.settings.callRecordingNote': 'Las llamadas entrantes con el asistente de IA generan transcripciones operativas necesarias para el contexto del servicio, la escalación y la creación de tickets (siempre se conservan, independientemente de la grabación de audio).',
    'st.settings.emailNotif': 'Notificaciones por correo electrónico',
    'st.settings.emailNotifDesc': 'Correos de seguimiento operativo a los clientes',
    'st.settings.smsNotif': 'Notificaciones por SMS',
    'st.settings.smsNotifDesc': 'SMS de seguimiento operativo a los clientes (pueden aplicarse cargos del operador)',
    'st.settings.transactionalNote': 'Los mensajes transaccionales (OTP, invitaciones, facturación, seguridad) siempre se envían y no se ven afectados por estas preferencias.',
    'st.settings.aiAutoRes': 'Resolución automática por IA',
    'st.settings.aiAutoResDesc': 'Cuando está desactivada, la IA escala a un agente humano en lugar de resolver automáticamente.',
    'st.settings.saveAi': 'Guardar ajustes de IA',
    'st.settings.manageAutoRules': 'Gestionar reglas y umbrales de resolución automática',
    'st.settings.securityCompliance': 'Seguridad y cumplimiento',
    'st.settings.auditLogging': 'Registro de auditoría',
    'st.settings.auditActive': 'Activo ({count} eventos)',
    'st.settings.auditNone': 'Sin actividad registrada',
    'st.settings.compliance': 'Certificaciones de cumplimiento',
    'st.settings.notPublished': 'No publicado',
    'st.settings.manageTeam': 'Gestiona los miembros del equipo y sus roles.',
    'st.settings.manageUsers': 'Gestionar usuarios',
    'st.settings.teamMembers': 'Miembros del equipo',
    'st.settings.inviteReview': 'Invita al personal y revisa tu equipo.',
    'st.settings.addUser': 'Añadir usuario',
    'st.settings.inviteStaffMember': 'Invitar a un miembro del personal',
    'st.settings.onboardingEmail': 'Se enviará un correo de incorporación.',
    'st.settings.email': 'Correo electrónico',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': 'Rol',
    'st.settings.sending': 'Enviando…',
    'st.settings.sendInvite': 'Enviar invitación',
    'st.settings.noTeamMembers': 'No se encontraron miembros del equipo',
    'st.settings.staffRole': 'personal',
    'st.settings.toast.saved': 'Ajustes guardados',
    'st.settings.toast.savedDesc': 'Ajustes del espacio de trabajo actualizados.',
    'st.settings.toast.saveFailed': 'Error al guardar',
    'st.settings.toast.aiSaved': 'Ajustes de IA guardados',
    'st.settings.toast.aiSavedDesc': 'Preferencia de resolución automática actualizada.',
    'st.settings.toast.invalidEmail': 'Correo no válido',
    'st.settings.toast.invalidEmailDesc': 'Introduce una dirección de correo válida.',
    'st.settings.toast.inviteSent': 'Invitación enviada',
    'st.settings.toast.inviteSentDesc': 'Invitación enviada a {email}.',
    'st.settings.toast.inviteFailed': 'Error en la invitación',
    'st.settings.inviteNotSent': 'La invitación no se envió',
    'st.settings.errLoadSettings': 'Error al cargar los ajustes ({status})',
    'st.settings.errSaveFailed': 'Error al guardar ({status})',
    'st.settings.errInviteFailed': 'Error en la invitación ({status})',
    'st.integ.planBadge': 'Plan {tier}',
    'st.integ.desc': 'Conecta canales, CRM, monitoreo y automatización. {allowed}/{total} disponibles en tu plan.',
    'st.integ.unlimited': 'Integraciones activas ilimitadas.',
    'st.integ.upTo': 'Hasta {cap} activas ({enabled}/{cap}).',
    'st.integ.notRegistered': 'No registrado',
    'st.integ.notRegisteredDesc': 'Completa la suscripción antes de configurar las integraciones.',
    'st.integ.saved': 'Guardado',
    'st.integ.savedDesc': '{name} actualizado.',
    'st.integ.saveFailed': 'Error al guardar',
    'st.integ.upgrade': 'Mejorar plan',
    'st.integ.configured': 'Configurado',
    'st.integ.needsCreds': 'Requiere credenciales',
    'st.integ.available': 'Disponible para configurar',
    'st.integ.enable': 'Habilitar {name}',
    'st.integ.noExecNote': 'Al guardar, tu configuración se almacena de forma segura. La ejecución de flujos de trabajo en vivo aún no está habilitada para este conector.',
    'st.integ.higherPlan': 'Disponible en un plan superior. Mejora tu plan en Facturación para habilitar {name}.',
    'st.hub.subtitle': 'Los conectores de tu organización',
    'st.hub.planTag': 'Plan {tier}',
    'st.hub.refreshStatus': 'Actualizar estado',
    'st.hub.exportData': 'Exportar datos',
    'st.hub.addIntegration': 'Añadir integración',
    'st.hub.scopeNote': 'Solo integraciones del ámbito de la organización. La infraestructura de la plataforma y la gobernanza a nivel de plataforma las gestiona Servisfy y no se muestran aquí.',
    'st.hub.none': 'No hay integraciones configuradas para esta organización.',
    'st.hub.configureInSettings': 'Configurar en Ajustes → Integraciones',
    'st.hub.connectorNote': 'Conector de la organización. Las credenciales se gestionan de forma segura y no se muestran aquí.',
    'st.hub.syncNote': 'La sincronización y la prueba del conector aún no están disponibles para este conector.',
    'st.hub.configure': 'Configurar',
    'st.hub.webhooks': 'Webhooks',
    'st.hub.webhooksNote': 'La gestión de webhooks no está configurada para esta organización.',
    'st.hub.errLoad': 'Error al cargar las integraciones ({status})',
    'st.survey.qtype.multiple_choice': 'Opción múltiple',
    'st.survey.qtype.text': 'Respuesta de texto',
    'st.survey.qtype.rating': 'Escala de valoración',
    'st.survey.qtype.yes_no': 'Sí/No',
    'st.survey.loadFail': 'No se pudieron cargar las encuestas',
    'st.survey.loadFailDesc': 'Vuelve a intentarlo o contacta con tu administrador si el problema continúa.',
    'st.survey.missingInfo': 'Falta información',
    'st.survey.missingInfoDesc': 'Se requiere un título y al menos una pregunta.',
    'st.survey.notAllowed': 'No permitido',
    'st.survey.notAllowedEdit': 'Solo un Gerente o Administrador puede editar encuestas.',
    'st.survey.updated': 'Encuesta actualizada',
    'st.survey.updatedDesc': 'Tus cambios se guardaron.',
    'st.survey.updateFail': 'Error al actualizar',
    'st.survey.updateFailDesc': 'No se pudo guardar la encuesta. Inténtalo de nuevo.',
    'st.survey.notAllowedStatus': 'Solo un Gerente o Administrador puede cambiar el estado de la encuesta.',
    'st.survey.statusFail': 'No se pudo actualizar el estado',
    'st.survey.notAllowedResults': 'Solo un Gerente o Administrador puede ver los resultados.',
    'st.survey.resultsFail': 'No se pudieron cargar los resultados',
    'st.survey.manage': 'Gestionar encuestas ({count})',
    'st.survey.loading': 'Cargando encuestas…',
    'st.survey.empty': 'Aún no hay encuestas. Crea una arriba para empezar.',
    'st.survey.qCount': '{count} P',
    'st.survey.responses': '{count} respuestas',
    'st.survey.results': 'Resultados',
    'st.survey.toggleActive': 'Activar/desactivar',
    'st.survey.editTitle': 'Editar encuesta',
    'st.survey.editDesc': 'Actualiza los detalles y las preguntas de la encuesta. Se guarda mediante la API de encuestas del ámbito de la organización.',
    'st.survey.fTitle': 'Título *',
    'st.survey.fDesc': 'Descripción',
    'st.survey.fType': 'Tipo',
    'st.survey.paid': 'Remunerada',
    'st.survey.unpaid': 'No remunerada',
    'st.survey.fReward': 'Recompensa',
    'st.survey.fDeadline': 'Fecha límite',
    'st.survey.questions': 'Preguntas ({count})',
    'st.survey.addQuestion': 'Añadir pregunta',
    'st.survey.questionPh': 'Texto de la pregunta',
    'st.survey.optionPh': 'Opción {n}',
    'st.survey.addOption': 'Añadir opción',
    'st.survey.required': 'Obligatoria',
    'st.survey.resultsTitle': 'Resultados de la encuesta',
    'st.survey.loadingResults': 'Cargando resultados…',
    'st.survey.totalResponses': '{count} respuesta(s) en total',
    'st.survey.downloadCsv': 'Descargar CSV',
    'st.survey.average': 'Promedio:',
    'st.survey.noResults': 'No hay resultados disponibles.',
    'st.voice.loading': 'Cargando métricas de voz...',
    'st.voice.loadError': 'Error al cargar las métricas de voz',
    'st.voice.aiCalls': 'Llamadas de IA',
    'st.voice.aiResolved': 'Resueltas por IA',
    'st.voice.ncalls': '{count} llamadas',
    'st.voice.escalationRate': 'Tasa de escalación',
    'st.voice.avgDuration': 'Duración media',
    'st.voice.perCall': 'Por llamada',
    'st.voice.csat': 'CSAT de voz',
    'st.voice.totalAiCalls': 'Total de llamadas de IA',
    'st.voice.aiResRate': 'Tasa de resolución por IA',
    'st.voice.callsResolvedByAi': '{count} llamadas resueltas por IA',
    'st.voice.nEscalated': '{count} escaladas',
    'st.voice.avgCallDuration': 'Duración media de llamada',
    'st.voice.nRatings': '{count} valoraciones',
    'st.voice.noRatings': 'Aún no hay valoraciones',
    'st.voice.aiHandled': 'Gestionadas por IA',
    'st.voice.noHumanTransfer': 'Sin transferencia a humano',
    'st.voice.pendingCallbacks': 'Devoluciones de llamada pendientes',
    'st.voice.overdueCallbacks': 'Devoluciones de llamada vencidas',
    'st.voice.past5minSla': 'SLA de 5 min superado',
    'st.voice.avgResTime': 'Tiempo medio de resolución',
    'st.voice.operatorAssignments': 'Asignaciones a operadores',
    'st.voice.operatorResolutions': 'Resoluciones de operadores',
    'st.voice.noData': 'Aún no hay datos de llamadas de voz. Las llamadas de voz aparecerán aquí una vez procesadas.',
    'st.aim.loading': 'Cargando métricas de IA...',
    'st.aim.loadError': 'Error al cargar las métricas de IA',
    'st.aim.subtitle': 'Supervisa las métricas de resolución automática y escalación impulsadas por IA',
    'st.aim.excellent': 'Excelente',
    'st.aim.good': 'Bueno',
    'st.aim.needsImprovement': 'Necesita mejorar',
    'st.aim.totalConversations': 'Total de conversaciones',
    'st.aim.aiProcessedChats': 'Chats procesados por IA',
    'st.aim.autoResRate': 'Tasa de resolución automática',
    'st.aim.nResolved': '{count} resueltas',
    'st.aim.escalationRate': 'Tasa de escalación',
    'st.aim.nEscalated': '{count} escaladas',
    'st.aim.avgConfidence': 'Confianza media',
    'st.aim.intentAccuracy': 'Precisión de intención',
    'st.aim.languageDistribution': 'Distribución por idioma',
    'st.aim.convByLanguage': 'Conversaciones por idioma',
    'st.aim.noLanguageData': 'No hay datos de idioma disponibles',
    'st.aim.intentDistribution': 'Distribución de intenciones',
    'st.aim.customerIntents': 'Intenciones de los clientes identificadas por la IA',
    'st.aim.noIntentData': 'No hay datos de intención disponibles',
    'st.aim.escalationBreakdown': 'Desglose de escalaciones',
    'st.aim.escalationByLevel': 'Escalaciones por nivel (Operador → Gerente → Administrador)',
    'st.aim.aiVoiceAnalytics': 'Analítica de voz con IA',
    'st.aim.totalVoiceCalls': 'Total de llamadas de voz',
    'st.aim.allInboundCalls': 'Todas las llamadas entrantes',
    'st.aim.aiHandled': 'Gestionadas por IA',
    'st.aim.noHumanTransfer': 'Sin transferencia a humano',
    'st.aim.aiResolved': 'Resueltas por IA',
    'st.aim.confirmedResolved': 'Resolución confirmada',
    'st.aim.humanEscalated': 'Escaladas a humano',
    'st.aim.escalationRatePct': '{rate}% de tasa de escalación',
    'st.aim.pendingCallbacks': 'Devoluciones de llamada pendientes',
    'st.aim.awaitingCallback': 'A la espera de devolución',
    'st.aim.overdueCallbacks': 'Devoluciones de llamada vencidas',
    'st.aim.pastSlaDeadline': 'Plazo del SLA superado',
    'st.aim.avgCallDuration': 'Duración media de llamada',
    'st.aim.minutesPerCall': 'Minutos por llamada',
    'st.aim.avgResTime': 'Tiempo medio de resolución',
    'st.aim.createResolve': 'Crear → resolver',
    'st.aim.slaBreaches': 'Incumplimientos de SLA de devolución',
    'st.aim.slaBreachesNote': 'Devoluciones de llamada que superaron el SLA de 5 minutos',
    'st.sbm.untitled': 'Solución sin título',
    'st.sbm.approved': 'Solución aprobada',
    'st.sbm.approvedDesc': 'La solución ya está disponible para su reutilización por la IA.',
    'st.sbm.approvalFailed': 'Error de aprobación',
    'st.sbm.rejected': 'Solución rechazada',
    'st.sbm.rejectedDesc': 'La IA no utilizará esta solución.',
    'st.sbm.rejectionFailed': 'Error de rechazo',
    'st.sbm.missingInfo': 'Falta información',
    'st.sbm.missingInfoDesc': 'Rellena el título, la descripción y los pasos de resolución.',
    'st.sbm.noBusiness': 'No se ha seleccionado ningún negocio',
    'st.sbm.noBusinessDesc': 'No se puede enviar: no hay un contexto de negocio activo.',
    'st.sbm.updated': 'Solución actualizada',
    'st.sbm.updatedDesc': 'Cambios guardados correctamente.',
    'st.sbm.submitted': 'Solución enviada',
    'st.sbm.submittedDesc': 'Solución enviada para aprobación de la gerencia. Estado: pending_approval.',
    'st.sbm.submitFailed': 'Error al enviar',
    'st.sbm.networkError': 'Error de red',
    'st.sbm.confirmDelete': '¿Eliminar "{title}"? Esta acción no se puede deshacer.',
    'st.sbm.deleted': 'Solución eliminada',
    'st.sbm.deletedDesc': 'Solución eliminada de forma permanente.',
    'st.sbm.deleteFailed': 'Error al eliminar',
    'st.sbm.title': 'Gestión del banco de soluciones',
    'st.sbm.subtitle': 'Crea y gestiona soluciones impulsadas por IA para problemas comunes',
    'st.sbm.editSolution': 'Editar solución',
    'st.sbm.structure': 'Estructura de la solución',
    'st.sbm.fTitle': 'Título de la solución *',
    'st.sbm.fTitlePh': 'Título breve y descriptivo para esta solución',
    'st.sbm.fDesc': 'Descripción del problema *',
    'st.sbm.fDescPh': 'Describe el problema que resuelve esta solución',
    'st.sbm.fCategory': 'Categoría del problema *',
    'st.sbm.categoryPh': 'Selecciona la categoría del problema',
    'st.sbm.fType': 'Tipo de problema *',
    'st.sbm.typePh': 'Selecciona el tipo de problema',
    'st.sbm.fDifficulty': 'Nivel de dificultad *',
    'st.sbm.difficultyPh': 'Selecciona el nivel de dificultad',
    'st.sbm.diffLow': 'Baja - Resolución simple y rápida',
    'st.sbm.diffMedium': 'Media - Complejidad moderada',
    'st.sbm.diffHigh': 'Alta - Solución compleja y técnica',
    'st.sbm.fTags': 'Etiquetas *',
    'st.sbm.tagsPh': 'Palabras clave separadas por comas',
    'st.sbm.tagsHelp': 'Palabras clave que los clientes podrían usar (p. ej., inicio de sesión, contraseña, restablecer)',
    'st.sbm.fResolution': 'Pasos de resolución *',
    'st.sbm.resolutionPh': 'Introduce cada paso en una línea nueva:\nPaso 1: Ve a la página de inicio de sesión\nPaso 2: Haz clic en ¿olvidaste tu contraseña?\nPaso 3: Introduce la dirección de correo\netc...',
    'st.sbm.resolutionHelp': 'Escribe instrucciones claras, paso a paso. Cada paso debe ir en una línea nueva.',
    'st.sbm.updateSolution': 'Actualizar solución',
    'st.sbm.addSolution': 'Añadir solución',
    'st.sbm.pendingApprovals': 'Aprobaciones pendientes',
    'st.sbm.nPending': '{count} pendientes',
    'st.sbm.uncategorized': 'Sin categoría',
    'st.sbm.submittedOn': 'Enviada el {date}',
    'st.sbm.noSolutions': 'No se han creado soluciones',
    'st.sbm.noSolutionsDesc': 'Empieza a construir tu base de conocimiento añadiendo tu primera solución',
    'st.sbm.addFirst': 'Añadir primera solución',
    'st.sbm.successRate': '{rate}% de tasa de éxito',
    'st.sbm.uses': '{count} usos',
    'st.sbm.keywords': 'Palabras clave',
    'st.sbm.resolutionSteps': 'Pasos de resolución',
    'st.sbm.lastUpdated': 'Última actualización: {date}',
    'st.sbm.addedBy': 'Añadida por: {name}',
    'st.sbm.unknown': 'Desconocido',
    'st.conf.tapEnableAudio': 'Toca para activar el audio',
    'st.conf.inviting': 'Invitando…',
    'st.conf.noAnswer': 'Sin respuesta',
    'st.conf.declined': 'Rechazada',
    'st.conf.reconnecting': 'Reconectando…',
    'st.conf.lost': 'Perdida',
    'st.conf.connected': 'Conectado',
    'st.conf.noAudio': 'Sin audio',
    'st.conf.connectingAudio': 'Conectando audio…',
    'st.conf.connecting': 'Conectando…',
    'st.conf.audioConference': 'Audioconferencia',
    'st.conf.invitingYou': '{host} te invita a una audioconferencia.',
    'st.conf.decline': 'Rechazar',
    'st.conf.accept': 'Aceptar',
    'st.conf.host': 'Anfitrión',
    'st.conf.participant': 'Participante',
    'st.conf.you': 'Tú',
    'st.conf.muted': '(silenciado)',
    'st.conf.unmute': 'Activar micrófono',
    'st.conf.mute': 'Silenciar',
    'st.conf.noOneYet': 'Aún no hay nadie más: invita a un compañero abajo.',
    'st.conf.removeFromConf': 'Quitar de la conferencia',
    'st.conf.addTeammate': '+ Añadir compañero en línea…',
    'st.conf.noStaffOnline': 'No hay más personal en línea para añadir.',
    'st.conf.endConference': 'Finalizar conferencia',
    'st.conf.leave': 'Salir',
    'st.call.userFallback': 'Usuario {id}',
    'st.call.shareVideoOnlyMsg': 'Compartir pantalla está disponible en las videollamadas.',
    'st.call.shareCouldNotStart': 'No se pudo iniciar la compartición de pantalla.',
    'st.call.onHold': 'En espera • {dur}',
    'st.call.connected': 'Conectado • {dur}',
    'st.call.connecting': 'Conectando...',
    'st.call.video': 'Vídeo',
    'st.call.tapEnableCallAudio': '🔊 Toca para activar el audio de la llamada',
    'st.call.callDuration': 'Duración de la llamada: {dur}',
    'st.call.resume': 'Reanudar llamada',
    'st.call.hold': 'Poner en espera',
    'st.call.sharingScreen': 'Compartiendo pantalla',
    'st.call.shareScreen': 'Compartir pantalla',
    'st.call.shareVideoOnly': 'Compartir pantalla está disponible en las videollamadas',
    'st.call.endCall': 'Finalizar llamada',
    'st.call.callVolume': 'Volumen de la llamada',
    'st.trial.errResolveTenant': 'No se pudo resolver la organización',
    'st.trial.errPortalUnavailable': 'Portal no disponible',
    'st.trial.stripeFail': 'No se pudo abrir el portal de Stripe',
    'st.trial.stripeFailDesc': '{message}. Redirigiendo a la página de facturación.',
    'st.trial.frozenHeadline': 'Tu suscripción está en pausa: la cuenta está en modo de solo lectura',
    'st.trial.frozenSub': 'Reactívala ahora para desbloquear nuevos tickets, conversaciones y la gestión del equipo.',
    'st.trial.reactivate': 'Reactivar',
    'st.trial.nDays': '{count} días',
    'st.trial.nHours': '{count} horas',
    'st.trial.nHour': '{count} hora',
    'st.trial.pastDueHeadline': 'Pago fallido: actualiza tu tarjeta antes de {remainder}',
    'st.trial.pastDueSub': 'Lo reintentaremos automáticamente (intento {attempt} de {max}). Tu cuenta permanece activa durante el periodo de gracia.',
    'st.trial.openingStripe': 'Abriendo Stripe…',
    'st.trial.updatePayment': 'Actualizar método de pago',
    'st.trial.expiredHeadline': 'Tu prueba ha finalizado',
    'st.trial.expiredSub': 'Mejora tu plan ahora para mantener conectados a tu equipo y a tus clientes.',
    'st.trial.upgradeNow': 'Mejorar ahora',
    'st.trial.urgentHeadlineOne': 'Solo queda {count} hora de prueba',
    'st.trial.urgentHeadline': 'Solo quedan {count} horas de prueba',
    'st.trial.soonSub': 'Elige un plan ahora para conservar todas las funciones y datos cuando termine tu prueba.',
    'st.trial.soonHeadline': 'Quedan {count} días de prueba',
    'st.trial.dismiss': 'Descartar',
  },
  fr: {
    'st.active': 'Actif',
    'st.inactive': 'Inactif',
    'st.enabled': 'Activé',
    'st.disabled': 'Désactivé',
    'st.integrations': 'Intégrations',
    'st.saveChanges': 'Enregistrer les modifications',
    'st.savingEllipsis': 'Enregistrement…',
    'st.settings.loading': 'Chargement des paramètres…',
    'st.settings.unavailable': "Les paramètres de l'espace de travail sont temporairement indisponibles. Veuillez réessayer.",
    'st.settings.noWorkspace': "Votre compte n'est pas encore lié à un espace de travail, les paramètres ne peuvent donc pas se charger. Contactez votre administrateur si cela est inattendu.",
    'st.settings.manageWorkspace': 'Gérez votre espace de travail',
    'st.settings.reset': 'Réinitialiser',
    'st.settings.tab.general': 'Général',
    'st.settings.tab.notifications': 'Notifications',
    'st.settings.tab.ai': "Paramètres de l'IA",
    'st.settings.tab.security': 'Sécurité',
    'st.settings.tab.users': 'Gestion des utilisateurs',
    'st.settings.displayName': "Nom d'affichage de l'espace de travail",
    'st.settings.timezone': "Fuseau horaire de l'espace de travail",
    'st.settings.timezonePh': 'ex. America/New_York',
    'st.settings.aiDefaultLang': "Langue par défaut de l'IA",
    'st.settings.aiLangHelp': "Langue dans laquelle l'IA répond lorsque la langue du client ne peut pas être détectée. Ne change pas la langue de l'interface web.",
    'st.settings.archiveDays': 'Archiver les enregistrements après N jours (0 = tout conserver)',
    'st.settings.archiveHelp': "Archive de façon réversible les anciennes conversations/tickets (jamais de suppression définitive). L'application ne s'exécute que si elle est activée par votre administrateur.",
    'st.settings.callRecording': "Enregistrement audio des appels",
    'st.settings.callRecordingDesc': "Enregistre l'audio des appels sortants, de transfert et de conférence.",
    'st.settings.callRecordingNote': "Les appels entrants avec l'assistant IA génèrent des transcriptions opérationnelles requises pour le contexte du service, l'escalade et la création de tickets (toujours conservées, indépendamment de l'enregistrement audio).",
    'st.settings.emailNotif': 'Notifications par e-mail',
    'st.settings.emailNotifDesc': 'E-mails de suivi opérationnel aux clients',
    'st.settings.smsNotif': 'Notifications par SMS',
    'st.settings.smsNotifDesc': "SMS de suivi opérationnel aux clients (des frais d'opérateur peuvent s'appliquer)",
    'st.settings.transactionalNote': "Les messages transactionnels (OTP, invitations, facturation, sécurité) sont toujours envoyés et ne sont pas affectés par ces préférences.",
    'st.settings.aiAutoRes': 'Résolution automatique par IA',
    'st.settings.aiAutoResDesc': "Lorsqu'elle est désactivée, l'IA transfère à un agent humain au lieu de résoudre automatiquement.",
    'st.settings.saveAi': "Enregistrer les paramètres de l'IA",
    'st.settings.manageAutoRules': 'Gérer les règles et seuils de résolution automatique',
    'st.settings.securityCompliance': 'Sécurité et conformité',
    'st.settings.auditLogging': "Journal d'audit",
    'st.settings.auditActive': 'Actif ({count} événements)',
    'st.settings.auditNone': 'Aucune activité enregistrée',
    'st.settings.compliance': 'Attestations de conformité',
    'st.settings.notPublished': 'Non publié',
    'st.settings.manageTeam': "Gérez les membres de l'équipe et leurs rôles.",
    'st.settings.manageUsers': 'Gérer les utilisateurs',
    'st.settings.teamMembers': "Membres de l'équipe",
    'st.settings.inviteReview': 'Invitez du personnel et passez votre équipe en revue.',
    'st.settings.addUser': 'Ajouter un utilisateur',
    'st.settings.inviteStaffMember': 'Inviter un membre du personnel',
    'st.settings.onboardingEmail': "Un e-mail d'intégration sera envoyé.",
    'st.settings.email': 'E-mail',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': 'Rôle',
    'st.settings.sending': 'Envoi…',
    'st.settings.sendInvite': "Envoyer l'invitation",
    'st.settings.noTeamMembers': "Aucun membre d'équipe trouvé",
    'st.settings.staffRole': 'personnel',
    'st.settings.toast.saved': 'Paramètres enregistrés',
    'st.settings.toast.savedDesc': "Paramètres de l'espace de travail mis à jour.",
    'st.settings.toast.saveFailed': "Échec de l'enregistrement",
    'st.settings.toast.aiSaved': "Paramètres de l'IA enregistrés",
    'st.settings.toast.aiSavedDesc': 'Préférence de résolution automatique mise à jour.',
    'st.settings.toast.invalidEmail': 'E-mail invalide',
    'st.settings.toast.invalidEmailDesc': 'Saisissez une adresse e-mail valide.',
    'st.settings.toast.inviteSent': 'Invitation envoyée',
    'st.settings.toast.inviteSentDesc': 'Invitation envoyée à {email}.',
    'st.settings.toast.inviteFailed': "Échec de l'invitation",
    'st.settings.inviteNotSent': "L'invitation n'a pas été envoyée",
    'st.settings.errLoadSettings': 'Échec du chargement des paramètres ({status})',
    'st.settings.errSaveFailed': "Échec de l'enregistrement ({status})",
    'st.settings.errInviteFailed': "Échec de l'invitation ({status})",
    'st.integ.planBadge': 'Forfait {tier}',
    'st.integ.desc': 'Connectez des canaux, des CRM, la surveillance et l\'automatisation. {allowed}/{total} disponibles sur votre forfait.',
    'st.integ.unlimited': 'Intégrations actives illimitées.',
    'st.integ.upTo': "Jusqu'à {cap} actives ({enabled}/{cap}).",
    'st.integ.notRegistered': 'Non enregistré',
    'st.integ.notRegisteredDesc': "Finalisez l'abonnement avant de configurer les intégrations.",
    'st.integ.saved': 'Enregistré',
    'st.integ.savedDesc': '{name} mis à jour.',
    'st.integ.saveFailed': "Échec de l'enregistrement",
    'st.integ.upgrade': 'Passer à un forfait supérieur',
    'st.integ.configured': 'Configuré',
    'st.integ.needsCreds': 'Identifiants requis',
    'st.integ.available': 'Disponible à configurer',
    'st.integ.enable': 'Activer {name}',
    'st.integ.noExecNote': "L'enregistrement stocke votre configuration en toute sécurité. L'exécution des flux de travail en direct n'est pas encore activée pour ce connecteur.",
    'st.integ.higherPlan': 'Disponible sur un forfait supérieur. Effectuez une mise à niveau dans Facturation pour activer {name}.',
    'st.hub.subtitle': 'Les connecteurs de votre organisation',
    'st.hub.planTag': 'Forfait {tier}',
    'st.hub.refreshStatus': "Actualiser l'état",
    'st.hub.exportData': 'Exporter les données',
    'st.hub.addIntegration': 'Ajouter une intégration',
    'st.hub.scopeNote': "Intégrations limitées à l'organisation uniquement. L'infrastructure de la plateforme et la gouvernance au niveau de la plateforme sont gérées par Servisfy et ne sont pas affichées ici.",
    'st.hub.none': 'Aucune intégration configurée pour cette organisation.',
    'st.hub.configureInSettings': 'Configurer dans Paramètres → Intégrations',
    'st.hub.connectorNote': "Connecteur de l'organisation. Les identifiants sont gérés en toute sécurité et ne sont pas affichés ici.",
    'st.hub.syncNote': "La synchronisation et le test du connecteur ne sont pas encore disponibles pour ce connecteur.",
    'st.hub.configure': 'Configurer',
    'st.hub.webhooks': 'Webhooks',
    'st.hub.webhooksNote': "La gestion des webhooks n'est pas configurée pour cette organisation.",
    'st.hub.errLoad': 'Échec du chargement des intégrations ({status})',
    'st.survey.qtype.multiple_choice': 'Choix multiple',
    'st.survey.qtype.text': 'Réponse texte',
    'st.survey.qtype.rating': "Échelle d'évaluation",
    'st.survey.qtype.yes_no': 'Oui/Non',
    'st.survey.loadFail': 'Impossible de charger les enquêtes',
    'st.survey.loadFailDesc': 'Veuillez réessayer ou contacter votre administrateur si le problème persiste.',
    'st.survey.missingInfo': 'Informations manquantes',
    'st.survey.missingInfoDesc': 'Un titre et au moins une question sont requis.',
    'st.survey.notAllowed': 'Non autorisé',
    'st.survey.notAllowedEdit': 'Seul un responsable ou un administrateur peut modifier les enquêtes.',
    'st.survey.updated': 'Enquête mise à jour',
    'st.survey.updatedDesc': 'Vos modifications ont été enregistrées.',
    'st.survey.updateFail': 'Échec de la mise à jour',
    'st.survey.updateFailDesc': "Impossible d'enregistrer l'enquête. Veuillez réessayer.",
    'st.survey.notAllowedStatus': "Seul un responsable ou un administrateur peut modifier l'état de l'enquête.",
    'st.survey.statusFail': "Impossible de mettre à jour l'état",
    'st.survey.notAllowedResults': 'Seul un responsable ou un administrateur peut consulter les résultats.',
    'st.survey.resultsFail': 'Impossible de charger les résultats',
    'st.survey.manage': 'Gérer les enquêtes ({count})',
    'st.survey.loading': 'Chargement des enquêtes…',
    'st.survey.empty': 'Aucune enquête pour le moment. Créez-en une ci-dessus pour commencer.',
    'st.survey.qCount': '{count} Q',
    'st.survey.responses': '{count} réponses',
    'st.survey.results': 'Résultats',
    'st.survey.toggleActive': "Activer/désactiver",
    'st.survey.editTitle': "Modifier l'enquête",
    'st.survey.editDesc': "Mettez à jour les détails et les questions de l'enquête. Enregistré via l'API d'enquête limitée à l'organisation.",
    'st.survey.fTitle': 'Titre *',
    'st.survey.fDesc': 'Description',
    'st.survey.fType': 'Type',
    'st.survey.paid': 'Rémunérée',
    'st.survey.unpaid': 'Non rémunérée',
    'st.survey.fReward': 'Récompense',
    'st.survey.fDeadline': 'Date limite',
    'st.survey.questions': 'Questions ({count})',
    'st.survey.addQuestion': 'Ajouter une question',
    'st.survey.questionPh': 'Texte de la question',
    'st.survey.optionPh': 'Option {n}',
    'st.survey.addOption': 'Ajouter une option',
    'st.survey.required': 'Obligatoire',
    'st.survey.resultsTitle': "Résultats de l'enquête",
    'st.survey.loadingResults': 'Chargement des résultats…',
    'st.survey.totalResponses': '{count} réponse(s) au total',
    'st.survey.downloadCsv': 'Télécharger le CSV',
    'st.survey.average': 'Moyenne :',
    'st.survey.noResults': 'Aucun résultat disponible.',
    'st.voice.loading': 'Chargement des métriques vocales...',
    'st.voice.loadError': 'Échec du chargement des métriques vocales',
    'st.voice.aiCalls': 'Appels IA',
    'st.voice.aiResolved': 'Résolus par IA',
    'st.voice.ncalls': '{count} appels',
    'st.voice.escalationRate': "Taux d'escalade",
    'st.voice.avgDuration': 'Durée moyenne',
    'st.voice.perCall': 'Par appel',
    'st.voice.csat': 'CSAT vocal',
    'st.voice.totalAiCalls': "Total des appels IA",
    'st.voice.aiResRate': 'Taux de résolution par IA',
    'st.voice.callsResolvedByAi': '{count} appels résolus par IA',
    'st.voice.nEscalated': '{count} escaladés',
    'st.voice.avgCallDuration': "Durée moyenne d'appel",
    'st.voice.nRatings': '{count} évaluations',
    'st.voice.noRatings': 'Aucune évaluation pour le moment',
    'st.voice.aiHandled': 'Gérés par IA',
    'st.voice.noHumanTransfer': 'Aucun transfert humain',
    'st.voice.pendingCallbacks': 'Rappels en attente',
    'st.voice.overdueCallbacks': 'Rappels en retard',
    'st.voice.past5minSla': 'SLA de 5 min dépassé',
    'st.voice.avgResTime': 'Temps moyen de résolution',
    'st.voice.operatorAssignments': "Affectations d'opérateurs",
    'st.voice.operatorResolutions': "Résolutions d'opérateurs",
    'st.voice.noData': "Aucune donnée d'appel vocal pour le moment. Les appels vocaux apparaîtront ici une fois traités.",
    'st.aim.loading': "Chargement des métriques d'IA...",
    'st.aim.loadError': "Échec du chargement des métriques d'IA",
    'st.aim.subtitle': "Surveillez les métriques de résolution automatique et d'escalade pilotées par l'IA",
    'st.aim.excellent': 'Excellent',
    'st.aim.good': 'Bon',
    'st.aim.needsImprovement': 'À améliorer',
    'st.aim.totalConversations': 'Total des conversations',
    'st.aim.aiProcessedChats': "Discussions traitées par l'IA",
    'st.aim.autoResRate': 'Taux de résolution automatique',
    'st.aim.nResolved': '{count} résolues',
    'st.aim.escalationRate': "Taux d'escalade",
    'st.aim.nEscalated': '{count} escaladées',
    'st.aim.avgConfidence': 'Confiance moyenne',
    'st.aim.intentAccuracy': "Précision de l'intention",
    'st.aim.languageDistribution': 'Répartition par langue',
    'st.aim.convByLanguage': 'Conversations par langue',
    'st.aim.noLanguageData': 'Aucune donnée de langue disponible',
    'st.aim.intentDistribution': 'Répartition des intentions',
    'st.aim.customerIntents': "Intentions des clients identifiées par l'IA",
    'st.aim.noIntentData': "Aucune donnée d'intention disponible",
    'st.aim.escalationBreakdown': 'Détail des escalades',
    'st.aim.escalationByLevel': 'Escalades par niveau (Opérateur → Responsable → Administrateur)',
    'st.aim.aiVoiceAnalytics': "Analyse vocale par IA",
    'st.aim.totalVoiceCalls': 'Total des appels vocaux',
    'st.aim.allInboundCalls': 'Tous les appels entrants',
    'st.aim.aiHandled': 'Gérés par IA',
    'st.aim.noHumanTransfer': 'Aucun transfert humain',
    'st.aim.aiResolved': 'Résolus par IA',
    'st.aim.confirmedResolved': 'Résolution confirmée',
    'st.aim.humanEscalated': 'Escaladés à un humain',
    'st.aim.escalationRatePct': "{rate}% de taux d'escalade",
    'st.aim.pendingCallbacks': 'Rappels en attente',
    'st.aim.awaitingCallback': 'En attente de rappel',
    'st.aim.overdueCallbacks': 'Rappels en retard',
    'st.aim.pastSlaDeadline': 'Échéance du SLA dépassée',
    'st.aim.avgCallDuration': "Durée moyenne d'appel",
    'st.aim.minutesPerCall': 'Minutes par appel',
    'st.aim.avgResTime': 'Temps moyen de résolution',
    'st.aim.createResolve': 'Créer → résoudre',
    'st.aim.slaBreaches': 'Dépassements du SLA de rappel',
    'st.aim.slaBreachesNote': 'Rappels ayant dépassé le SLA de 5 minutes',
    'st.sbm.untitled': 'Solution sans titre',
    'st.sbm.approved': 'Solution approuvée',
    'st.sbm.approvedDesc': "La solution est désormais disponible pour être réutilisée par l'IA.",
    'st.sbm.approvalFailed': "Échec de l'approbation",
    'st.sbm.rejected': 'Solution rejetée',
    'st.sbm.rejectedDesc': "La solution ne sera pas utilisée par l'IA.",
    'st.sbm.rejectionFailed': 'Échec du rejet',
    'st.sbm.missingInfo': 'Informations manquantes',
    'st.sbm.missingInfoDesc': 'Veuillez renseigner le titre, la description et les étapes de résolution.',
    'st.sbm.noBusiness': 'Aucune entreprise sélectionnée',
    'st.sbm.noBusinessDesc': "Impossible d'envoyer : aucun contexte d'entreprise actif.",
    'st.sbm.updated': 'Solution mise à jour',
    'st.sbm.updatedDesc': 'Modifications enregistrées avec succès.',
    'st.sbm.submitted': 'Solution envoyée',
    'st.sbm.submittedDesc': "Solution envoyée pour approbation par la direction. État : pending_approval.",
    'st.sbm.submitFailed': "Échec de l'envoi",
    'st.sbm.networkError': 'Erreur réseau',
    'st.sbm.confirmDelete': 'Supprimer « {title} » ? Cette action est irréversible.',
    'st.sbm.deleted': 'Solution supprimée',
    'st.sbm.deletedDesc': 'Solution supprimée définitivement.',
    'st.sbm.deleteFailed': 'Échec de la suppression',
    'st.sbm.title': 'Gestion de la banque de solutions',
    'st.sbm.subtitle': "Créez et gérez des solutions optimisées par l'IA pour les problèmes courants",
    'st.sbm.editSolution': 'Modifier la solution',
    'st.sbm.structure': 'Structure de la solution',
    'st.sbm.fTitle': 'Titre de la solution *',
    'st.sbm.fTitlePh': 'Titre bref et descriptif pour cette solution',
    'st.sbm.fDesc': 'Description du problème *',
    'st.sbm.fDescPh': 'Décrivez le problème que résout cette solution',
    'st.sbm.fCategory': 'Catégorie du problème *',
    'st.sbm.categoryPh': 'Sélectionnez la catégorie du problème',
    'st.sbm.fType': 'Type de problème *',
    'st.sbm.typePh': 'Sélectionnez le type de problème',
    'st.sbm.fDifficulty': 'Niveau de difficulté *',
    'st.sbm.difficultyPh': 'Sélectionnez le niveau de difficulté',
    'st.sbm.diffLow': 'Faible - Résolution simple et rapide',
    'st.sbm.diffMedium': 'Moyenne - Complexité modérée',
    'st.sbm.diffHigh': 'Élevée - Solution complexe et technique',
    'st.sbm.fTags': 'Étiquettes *',
    'st.sbm.tagsPh': 'Mots-clés séparés par des virgules',
    'st.sbm.tagsHelp': 'Mots-clés que les clients pourraient utiliser (ex. connexion, mot de passe, réinitialiser)',
    'st.sbm.fResolution': 'Étapes de résolution *',
    'st.sbm.resolutionPh': "Saisissez chaque étape sur une nouvelle ligne :\nÉtape 1 : Accédez à la page de connexion\nÉtape 2 : Cliquez sur mot de passe oublié\nÉtape 3 : Saisissez l'adresse e-mail\netc...",
    'st.sbm.resolutionHelp': 'Rédigez des instructions claires, étape par étape. Chaque étape doit figurer sur une nouvelle ligne.',
    'st.sbm.updateSolution': 'Mettre à jour la solution',
    'st.sbm.addSolution': 'Ajouter une solution',
    'st.sbm.pendingApprovals': 'Approbations en attente',
    'st.sbm.nPending': '{count} en attente',
    'st.sbm.uncategorized': 'Non catégorisé',
    'st.sbm.submittedOn': 'Envoyée le {date}',
    'st.sbm.noSolutions': 'Aucune solution créée',
    'st.sbm.noSolutionsDesc': 'Commencez à construire votre base de connaissances en ajoutant votre première solution',
    'st.sbm.addFirst': 'Ajouter la première solution',
    'st.sbm.successRate': '{rate}% de taux de réussite',
    'st.sbm.uses': '{count} utilisations',
    'st.sbm.keywords': 'Mots-clés',
    'st.sbm.resolutionSteps': 'Étapes de résolution',
    'st.sbm.lastUpdated': 'Dernière mise à jour : {date}',
    'st.sbm.addedBy': 'Ajoutée par : {name}',
    'st.sbm.unknown': 'Inconnu',
    'st.conf.tapEnableAudio': "Touchez pour activer l'audio",
    'st.conf.inviting': 'Invitation…',
    'st.conf.noAnswer': 'Pas de réponse',
    'st.conf.declined': 'Refusé',
    'st.conf.reconnecting': 'Reconnexion…',
    'st.conf.lost': 'Perdu',
    'st.conf.connected': 'Connecté',
    'st.conf.noAudio': 'Pas de son',
    'st.conf.connectingAudio': "Connexion audio…",
    'st.conf.connecting': 'Connexion…',
    'st.conf.audioConference': 'Conférence audio',
    'st.conf.invitingYou': '{host} vous invite à une conférence audio.',
    'st.conf.decline': 'Refuser',
    'st.conf.accept': 'Accepter',
    'st.conf.host': 'Hôte',
    'st.conf.participant': 'Participant',
    'st.conf.you': 'Vous',
    'st.conf.muted': '(coupé)',
    'st.conf.unmute': 'Réactiver le micro',
    'st.conf.mute': 'Couper le micro',
    'st.conf.noOneYet': "Personne d'autre pour l'instant — invitez un collègue ci-dessous.",
    'st.conf.removeFromConf': 'Retirer de la conférence',
    'st.conf.addTeammate': '+ Ajouter un collègue en ligne…',
    'st.conf.noStaffOnline': "Aucun autre membre du personnel en ligne à ajouter.",
    'st.conf.endConference': 'Terminer la conférence',
    'st.conf.leave': 'Quitter',
    'st.call.userFallback': 'Utilisateur {id}',
    'st.call.shareVideoOnlyMsg': "Le partage d'écran est disponible lors des appels vidéo.",
    'st.call.shareCouldNotStart': "Le partage d'écran n'a pas pu démarrer.",
    'st.call.onHold': 'En attente • {dur}',
    'st.call.connected': 'Connecté • {dur}',
    'st.call.connecting': 'Connexion...',
    'st.call.video': 'Vidéo',
    'st.call.tapEnableCallAudio': "🔊 Touchez pour activer l'audio de l'appel",
    'st.call.callDuration': "Durée de l'appel : {dur}",
    'st.call.resume': "Reprendre l'appel",
    'st.call.hold': "Mettre l'appel en attente",
    'st.call.sharingScreen': "Partage d'écran en cours",
    'st.call.shareScreen': "Partager l'écran",
    'st.call.shareVideoOnly': "Le partage d'écran est disponible lors des appels vidéo",
    'st.call.endCall': "Terminer l'appel",
    'st.call.callVolume': "Volume de l'appel",
    'st.trial.errResolveTenant': "Impossible de résoudre l'organisation",
    'st.trial.errPortalUnavailable': 'Portail indisponible',
    'st.trial.stripeFail': "Impossible d'ouvrir le portail Stripe",
    'st.trial.stripeFailDesc': '{message}. Redirection vers la page de facturation.',
    'st.trial.frozenHeadline': 'Votre abonnement est en pause — le compte est en lecture seule',
    'st.trial.frozenSub': "Réactivez-le maintenant pour débloquer les nouveaux tickets, conversations et la gestion d'équipe.",
    'st.trial.reactivate': 'Réactiver',
    'st.trial.nDays': '{count} jours',
    'st.trial.nHours': '{count} heures',
    'st.trial.nHour': '{count} heure',
    'st.trial.pastDueHeadline': 'Paiement échoué — mettez votre carte à jour avant {remainder}',
    'st.trial.pastDueSub': "Nous réessaierons automatiquement (tentative {attempt} sur {max}). Votre compte reste actif pendant la période de grâce.",
    'st.trial.openingStripe': 'Ouverture de Stripe…',
    'st.trial.updatePayment': 'Mettre à jour le moyen de paiement',
    'st.trial.expiredHeadline': "Votre essai est terminé",
    'st.trial.expiredSub': 'Effectuez une mise à niveau maintenant pour garder votre équipe et vos clients connectés.',
    'st.trial.upgradeNow': 'Mettre à niveau',
    'st.trial.urgentHeadlineOne': "Il ne reste que {count} heure d'essai",
    'st.trial.urgentHeadline': "Il ne reste que {count} heures d'essai",
    'st.trial.soonSub': 'Choisissez un forfait maintenant pour conserver toutes les fonctionnalités et données après la fin de votre essai.',
    'st.trial.soonHeadline': "{count} jours restants dans votre essai",
    'st.trial.dismiss': 'Ignorer',
  },
  pt: {
    'st.active': 'Ativo',
    'st.inactive': 'Inativo',
    'st.enabled': 'Ativado',
    'st.disabled': 'Desativado',
    'st.integrations': 'Integrações',
    'st.saveChanges': 'Salvar alterações',
    'st.savingEllipsis': 'Salvando…',
    'st.settings.loading': 'Carregando configurações…',
    'st.settings.unavailable': 'As configurações do espaço de trabalho estão temporariamente indisponíveis. Tente novamente.',
    'st.settings.noWorkspace': 'Sua conta ainda não está vinculada a um espaço de trabalho, por isso as configurações não podem ser carregadas. Entre em contato com seu administrador se isso for inesperado.',
    'st.settings.manageWorkspace': 'Gerencie seu espaço de trabalho',
    'st.settings.reset': 'Redefinir',
    'st.settings.tab.general': 'Geral',
    'st.settings.tab.notifications': 'Notificações',
    'st.settings.tab.ai': 'Configurações de IA',
    'st.settings.tab.security': 'Segurança',
    'st.settings.tab.users': 'Gerenciamento de usuários',
    'st.settings.displayName': 'Nome de exibição do espaço de trabalho',
    'st.settings.timezone': 'Fuso horário do espaço de trabalho',
    'st.settings.timezonePh': 'ex. America/New_York',
    'st.settings.aiDefaultLang': 'Idioma padrão da IA',
    'st.settings.aiLangHelp': 'Idioma em que a IA responde quando não é possível detectar o idioma do cliente. Não altera o idioma da interface web.',
    'st.settings.archiveDays': 'Arquivar registros após N dias (0 = manter tudo)',
    'st.settings.archiveHelp': 'Arquiva de forma reversível conversas/tickets antigos (nunca exclui de forma permanente). A aplicação só é executada quando habilitada pelo seu administrador.',
    'st.settings.callRecording': 'Gravação de áudio de chamadas',
    'st.settings.callRecordingDesc': 'Grava o áudio de chamadas de saída, de transferência e de conferência.',
    'st.settings.callRecordingNote': 'As chamadas recebidas com o assistente de IA geram transcrições operacionais necessárias para o contexto do serviço, escalonamento e criação de tickets (sempre retidas, independentemente da gravação de áudio).',
    'st.settings.emailNotif': 'Notificações por e-mail',
    'st.settings.emailNotifDesc': 'E-mails de acompanhamento operacional aos clientes',
    'st.settings.smsNotif': 'Notificações por SMS',
    'st.settings.smsNotifDesc': 'SMS de acompanhamento operacional aos clientes (podem ser aplicadas tarifas da operadora)',
    'st.settings.transactionalNote': 'As mensagens transacionais (OTP, convites, cobrança, segurança) são sempre enviadas e não são afetadas por estas preferências.',
    'st.settings.aiAutoRes': 'Resolução automática por IA',
    'st.settings.aiAutoResDesc': 'Quando desativada, a IA escalona para um humano em vez de resolver automaticamente.',
    'st.settings.saveAi': 'Salvar configurações de IA',
    'st.settings.manageAutoRules': 'Gerenciar regras e limites de resolução automática',
    'st.settings.securityCompliance': 'Segurança e conformidade',
    'st.settings.auditLogging': 'Registro de auditoria',
    'st.settings.auditActive': 'Ativo ({count} eventos)',
    'st.settings.auditNone': 'Nenhuma atividade registrada',
    'st.settings.compliance': 'Atestados de conformidade',
    'st.settings.notPublished': 'Não publicado',
    'st.settings.manageTeam': 'Gerencie os membros da equipe e suas funções.',
    'st.settings.manageUsers': 'Gerenciar usuários',
    'st.settings.teamMembers': 'Membros da equipe',
    'st.settings.inviteReview': 'Convide a equipe e revise seu time.',
    'st.settings.addUser': 'Adicionar usuário',
    'st.settings.inviteStaffMember': 'Convidar membro da equipe',
    'st.settings.onboardingEmail': 'Um e-mail de integração será enviado.',
    'st.settings.email': 'E-mail',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': 'Função',
    'st.settings.sending': 'Enviando…',
    'st.settings.sendInvite': 'Enviar convite',
    'st.settings.noTeamMembers': 'Nenhum membro da equipe encontrado',
    'st.settings.staffRole': 'funcionário',
    'st.settings.toast.saved': 'Configurações salvas',
    'st.settings.toast.savedDesc': 'Configurações do espaço de trabalho atualizadas.',
    'st.settings.toast.saveFailed': 'Falha ao salvar',
    'st.settings.toast.aiSaved': 'Configurações de IA salvas',
    'st.settings.toast.aiSavedDesc': 'Preferência de resolução automática atualizada.',
    'st.settings.toast.invalidEmail': 'E-mail inválido',
    'st.settings.toast.invalidEmailDesc': 'Digite um endereço de e-mail válido.',
    'st.settings.toast.inviteSent': 'Convite enviado',
    'st.settings.toast.inviteSentDesc': 'Convite enviado para {email}.',
    'st.settings.toast.inviteFailed': 'Falha no convite',
    'st.settings.inviteNotSent': 'O convite não foi enviado',
    'st.settings.errLoadSettings': 'Falha ao carregar as configurações ({status})',
    'st.settings.errSaveFailed': 'Falha ao salvar ({status})',
    'st.settings.errInviteFailed': 'Falha no convite ({status})',
    'st.integ.planBadge': 'Plano {tier}',
    'st.integ.desc': 'Conecte canais, CRMs, monitoramento e automação. {allowed}/{total} disponíveis no seu plano.',
    'st.integ.unlimited': 'Integrações ativas ilimitadas.',
    'st.integ.upTo': 'Até {cap} ativas ({enabled}/{cap}).',
    'st.integ.notRegistered': 'Não registrado',
    'st.integ.notRegisteredDesc': 'Conclua a assinatura antes de configurar as integrações.',
    'st.integ.saved': 'Salvo',
    'st.integ.savedDesc': '{name} atualizado.',
    'st.integ.saveFailed': 'Falha ao salvar',
    'st.integ.upgrade': 'Fazer upgrade',
    'st.integ.configured': 'Configurado',
    'st.integ.needsCreds': 'Requer credenciais',
    'st.integ.available': 'Disponível para configurar',
    'st.integ.enable': 'Ativar {name}',
    'st.integ.noExecNote': 'Ao salvar, sua configuração é armazenada com segurança. A execução de fluxos de trabalho ao vivo ainda não está ativada para este conector.',
    'st.integ.higherPlan': 'Disponível em um plano superior. Faça upgrade em Cobrança para ativar {name}.',
    'st.hub.subtitle': 'Os conectores da sua organização',
    'st.hub.planTag': 'Plano {tier}',
    'st.hub.refreshStatus': 'Atualizar status',
    'st.hub.exportData': 'Exportar dados',
    'st.hub.addIntegration': 'Adicionar integração',
    'st.hub.scopeNote': 'Apenas integrações no escopo da organização. A infraestrutura da plataforma e a governança em nível de plataforma são gerenciadas pela Servisfy e não são exibidas aqui.',
    'st.hub.none': 'Nenhuma integração configurada para esta organização.',
    'st.hub.configureInSettings': 'Configurar em Configurações → Integrações',
    'st.hub.connectorNote': 'Conector da organização. As credenciais são gerenciadas com segurança e não são exibidas aqui.',
    'st.hub.syncNote': 'A sincronização e o teste do conector ainda não estão disponíveis para este conector.',
    'st.hub.configure': 'Configurar',
    'st.hub.webhooks': 'Webhooks',
    'st.hub.webhooksNote': 'O gerenciamento de webhooks não está configurado para esta organização.',
    'st.hub.errLoad': 'Falha ao carregar as integrações ({status})',
    'st.survey.qtype.multiple_choice': 'Múltipla escolha',
    'st.survey.qtype.text': 'Resposta de texto',
    'st.survey.qtype.rating': 'Escala de avaliação',
    'st.survey.qtype.yes_no': 'Sim/Não',
    'st.survey.loadFail': 'Não foi possível carregar as pesquisas',
    'st.survey.loadFailDesc': 'Tente novamente ou entre em contato com seu administrador se o problema persistir.',
    'st.survey.missingInfo': 'Informações ausentes',
    'st.survey.missingInfoDesc': 'É necessário um título e pelo menos uma pergunta.',
    'st.survey.notAllowed': 'Não permitido',
    'st.survey.notAllowedEdit': 'Apenas um Gerente ou Administrador pode editar pesquisas.',
    'st.survey.updated': 'Pesquisa atualizada',
    'st.survey.updatedDesc': 'Suas alterações foram salvas.',
    'st.survey.updateFail': 'Falha na atualização',
    'st.survey.updateFailDesc': 'Não foi possível salvar a pesquisa. Tente novamente.',
    'st.survey.notAllowedStatus': 'Apenas um Gerente ou Administrador pode alterar o status da pesquisa.',
    'st.survey.statusFail': 'Não foi possível atualizar o status',
    'st.survey.notAllowedResults': 'Apenas um Gerente ou Administrador pode ver os resultados.',
    'st.survey.resultsFail': 'Não foi possível carregar os resultados',
    'st.survey.manage': 'Gerenciar pesquisas ({count})',
    'st.survey.loading': 'Carregando pesquisas…',
    'st.survey.empty': 'Ainda não há pesquisas. Crie uma acima para começar.',
    'st.survey.qCount': '{count} P',
    'st.survey.responses': '{count} respostas',
    'st.survey.results': 'Resultados',
    'st.survey.toggleActive': 'Ativar/desativar',
    'st.survey.editTitle': 'Editar pesquisa',
    'st.survey.editDesc': 'Atualize os detalhes e as perguntas da pesquisa. Salvo pela API de pesquisas no escopo da organização.',
    'st.survey.fTitle': 'Título *',
    'st.survey.fDesc': 'Descrição',
    'st.survey.fType': 'Tipo',
    'st.survey.paid': 'Remunerada',
    'st.survey.unpaid': 'Não remunerada',
    'st.survey.fReward': 'Recompensa',
    'st.survey.fDeadline': 'Prazo',
    'st.survey.questions': 'Perguntas ({count})',
    'st.survey.addQuestion': 'Adicionar pergunta',
    'st.survey.questionPh': 'Texto da pergunta',
    'st.survey.optionPh': 'Opção {n}',
    'st.survey.addOption': 'Adicionar opção',
    'st.survey.required': 'Obrigatória',
    'st.survey.resultsTitle': 'Resultados da pesquisa',
    'st.survey.loadingResults': 'Carregando resultados…',
    'st.survey.totalResponses': '{count} resposta(s) no total',
    'st.survey.downloadCsv': 'Baixar CSV',
    'st.survey.average': 'Média:',
    'st.survey.noResults': 'Nenhum resultado disponível.',
    'st.voice.loading': 'Carregando métricas de voz...',
    'st.voice.loadError': 'Falha ao carregar as métricas de voz',
    'st.voice.aiCalls': 'Chamadas de IA',
    'st.voice.aiResolved': 'Resolvidas por IA',
    'st.voice.ncalls': '{count} chamadas',
    'st.voice.escalationRate': 'Taxa de escalonamento',
    'st.voice.avgDuration': 'Duração média',
    'st.voice.perCall': 'Por chamada',
    'st.voice.csat': 'CSAT de voz',
    'st.voice.totalAiCalls': 'Total de chamadas de IA',
    'st.voice.aiResRate': 'Taxa de resolução por IA',
    'st.voice.callsResolvedByAi': '{count} chamadas resolvidas pela IA',
    'st.voice.nEscalated': '{count} escalonadas',
    'st.voice.avgCallDuration': 'Duração média da chamada',
    'st.voice.nRatings': '{count} avaliações',
    'st.voice.noRatings': 'Ainda não há avaliações',
    'st.voice.aiHandled': 'Atendidas pela IA',
    'st.voice.noHumanTransfer': 'Sem transferência para humano',
    'st.voice.pendingCallbacks': 'Retornos de chamada pendentes',
    'st.voice.overdueCallbacks': 'Retornos de chamada atrasados',
    'st.voice.past5minSla': 'SLA de 5 min excedido',
    'st.voice.avgResTime': 'Tempo médio de resolução',
    'st.voice.operatorAssignments': 'Atribuições a operadores',
    'st.voice.operatorResolutions': 'Resoluções de operadores',
    'st.voice.noData': 'Ainda não há dados de chamadas de voz. As chamadas de voz aparecerão aqui após serem processadas.',
    'st.aim.loading': 'Carregando métricas de IA...',
    'st.aim.loadError': 'Falha ao carregar as métricas de IA',
    'st.aim.subtitle': 'Monitore as métricas de resolução automática e escalonamento impulsionadas por IA',
    'st.aim.excellent': 'Excelente',
    'st.aim.good': 'Bom',
    'st.aim.needsImprovement': 'Precisa melhorar',
    'st.aim.totalConversations': 'Total de conversas',
    'st.aim.aiProcessedChats': 'Chats processados por IA',
    'st.aim.autoResRate': 'Taxa de resolução automática',
    'st.aim.nResolved': '{count} resolvidas',
    'st.aim.escalationRate': 'Taxa de escalonamento',
    'st.aim.nEscalated': '{count} escalonadas',
    'st.aim.avgConfidence': 'Confiança média',
    'st.aim.intentAccuracy': 'Precisão da intenção',
    'st.aim.languageDistribution': 'Distribuição por idioma',
    'st.aim.convByLanguage': 'Conversas por idioma',
    'st.aim.noLanguageData': 'Nenhum dado de idioma disponível',
    'st.aim.intentDistribution': 'Distribuição de intenções',
    'st.aim.customerIntents': 'Intenções dos clientes identificadas pela IA',
    'st.aim.noIntentData': 'Nenhum dado de intenção disponível',
    'st.aim.escalationBreakdown': 'Detalhamento de escalonamentos',
    'st.aim.escalationByLevel': 'Escalonamentos por nível (Operador → Gerente → Administrador)',
    'st.aim.aiVoiceAnalytics': 'Análise de voz com IA',
    'st.aim.totalVoiceCalls': 'Total de chamadas de voz',
    'st.aim.allInboundCalls': 'Todas as chamadas recebidas',
    'st.aim.aiHandled': 'Atendidas pela IA',
    'st.aim.noHumanTransfer': 'Sem transferência para humano',
    'st.aim.aiResolved': 'Resolvidas por IA',
    'st.aim.confirmedResolved': 'Resolução confirmada',
    'st.aim.humanEscalated': 'Escalonadas para humano',
    'st.aim.escalationRatePct': '{rate}% de taxa de escalonamento',
    'st.aim.pendingCallbacks': 'Retornos de chamada pendentes',
    'st.aim.awaitingCallback': 'Aguardando retorno',
    'st.aim.overdueCallbacks': 'Retornos de chamada atrasados',
    'st.aim.pastSlaDeadline': 'Prazo do SLA excedido',
    'st.aim.avgCallDuration': 'Duração média da chamada',
    'st.aim.minutesPerCall': 'Minutos por chamada',
    'st.aim.avgResTime': 'Tempo médio de resolução',
    'st.aim.createResolve': 'Criar → resolver',
    'st.aim.slaBreaches': 'Violações de SLA de retorno',
    'st.aim.slaBreachesNote': 'Retornos de chamada que excederam o SLA de 5 minutos',
    'st.sbm.untitled': 'Solução sem título',
    'st.sbm.approved': 'Solução aprovada',
    'st.sbm.approvedDesc': 'A solução agora está disponível para reutilização pela IA.',
    'st.sbm.approvalFailed': 'Falha na aprovação',
    'st.sbm.rejected': 'Solução rejeitada',
    'st.sbm.rejectedDesc': 'A solução não será usada pela IA.',
    'st.sbm.rejectionFailed': 'Falha na rejeição',
    'st.sbm.missingInfo': 'Informações ausentes',
    'st.sbm.missingInfoDesc': 'Preencha o título, a descrição e as etapas de resolução.',
    'st.sbm.noBusiness': 'Nenhum negócio selecionado',
    'st.sbm.noBusinessDesc': 'Não é possível enviar — nenhum contexto de negócio ativo.',
    'st.sbm.updated': 'Solução atualizada',
    'st.sbm.updatedDesc': 'Alterações salvas com sucesso.',
    'st.sbm.submitted': 'Solução enviada',
    'st.sbm.submittedDesc': 'Solução enviada para aprovação da gerência. Status: pending_approval.',
    'st.sbm.submitFailed': 'Falha no envio',
    'st.sbm.networkError': 'Erro de rede',
    'st.sbm.confirmDelete': 'Excluir "{title}"? Isso não pode ser desfeito.',
    'st.sbm.deleted': 'Solução excluída',
    'st.sbm.deletedDesc': 'Solução removida permanentemente.',
    'st.sbm.deleteFailed': 'Falha ao excluir',
    'st.sbm.title': 'Gerenciamento do banco de soluções',
    'st.sbm.subtitle': 'Crie e gerencie soluções com tecnologia de IA para problemas comuns',
    'st.sbm.editSolution': 'Editar solução',
    'st.sbm.structure': 'Estrutura da solução',
    'st.sbm.fTitle': 'Título da solução *',
    'st.sbm.fTitlePh': 'Título breve e descritivo para esta solução',
    'st.sbm.fDesc': 'Descrição do problema *',
    'st.sbm.fDescPh': 'Descreva o problema que esta solução resolve',
    'st.sbm.fCategory': 'Categoria do problema *',
    'st.sbm.categoryPh': 'Selecione a categoria do problema',
    'st.sbm.fType': 'Tipo de problema *',
    'st.sbm.typePh': 'Selecione o tipo de problema',
    'st.sbm.fDifficulty': 'Nível de dificuldade *',
    'st.sbm.difficultyPh': 'Selecione o nível de dificuldade',
    'st.sbm.diffLow': 'Baixa - Resolução simples e rápida',
    'st.sbm.diffMedium': 'Média - Complexidade moderada',
    'st.sbm.diffHigh': 'Alta - Solução complexa e técnica',
    'st.sbm.fTags': 'Etiquetas *',
    'st.sbm.tagsPh': 'Palavras-chave separadas por vírgulas',
    'st.sbm.tagsHelp': 'Palavras-chave que os clientes podem usar (ex.: login, senha, redefinir)',
    'st.sbm.fResolution': 'Etapas de resolução *',
    'st.sbm.resolutionPh': 'Digite cada etapa em uma nova linha:\nEtapa 1: Acesse a página de login\nEtapa 2: Clique em esqueci a senha\nEtapa 3: Digite o endereço de e-mail\netc...',
    'st.sbm.resolutionHelp': 'Escreva instruções claras, passo a passo. Cada etapa deve estar em uma nova linha.',
    'st.sbm.updateSolution': 'Atualizar solução',
    'st.sbm.addSolution': 'Adicionar solução',
    'st.sbm.pendingApprovals': 'Aprovações pendentes',
    'st.sbm.nPending': '{count} pendentes',
    'st.sbm.uncategorized': 'Sem categoria',
    'st.sbm.submittedOn': 'Enviada em {date}',
    'st.sbm.noSolutions': 'Nenhuma solução criada',
    'st.sbm.noSolutionsDesc': 'Comece a construir sua base de conhecimento adicionando sua primeira solução',
    'st.sbm.addFirst': 'Adicionar primeira solução',
    'st.sbm.successRate': '{rate}% de taxa de sucesso',
    'st.sbm.uses': '{count} usos',
    'st.sbm.keywords': 'Palavras-chave',
    'st.sbm.resolutionSteps': 'Etapas de resolução',
    'st.sbm.lastUpdated': 'Última atualização: {date}',
    'st.sbm.addedBy': 'Adicionada por: {name}',
    'st.sbm.unknown': 'Desconhecido',
    'st.conf.tapEnableAudio': 'Toque para ativar o áudio',
    'st.conf.inviting': 'Convidando…',
    'st.conf.noAnswer': 'Sem resposta',
    'st.conf.declined': 'Recusada',
    'st.conf.reconnecting': 'Reconectando…',
    'st.conf.lost': 'Perdida',
    'st.conf.connected': 'Conectado',
    'st.conf.noAudio': 'Sem áudio',
    'st.conf.connectingAudio': 'Conectando áudio…',
    'st.conf.connecting': 'Conectando…',
    'st.conf.audioConference': 'Áudioconferência',
    'st.conf.invitingYou': '{host} está convidando você para uma áudioconferência.',
    'st.conf.decline': 'Recusar',
    'st.conf.accept': 'Aceitar',
    'st.conf.host': 'Anfitrião',
    'st.conf.participant': 'Participante',
    'st.conf.you': 'Você',
    'st.conf.muted': '(sem som)',
    'st.conf.unmute': 'Ativar microfone',
    'st.conf.mute': 'Silenciar',
    'st.conf.noOneYet': 'Ainda não há mais ninguém — convide um colega abaixo.',
    'st.conf.removeFromConf': 'Remover da conferência',
    'st.conf.addTeammate': '+ Adicionar colega on-line…',
    'st.conf.noStaffOnline': 'Nenhum outro membro da equipe on-line para adicionar.',
    'st.conf.endConference': 'Encerrar conferência',
    'st.conf.leave': 'Sair',
    'st.call.userFallback': 'Usuário {id}',
    'st.call.shareVideoOnlyMsg': 'O compartilhamento de tela está disponível em chamadas de vídeo.',
    'st.call.shareCouldNotStart': 'Não foi possível iniciar o compartilhamento de tela.',
    'st.call.onHold': 'Em espera • {dur}',
    'st.call.connected': 'Conectado • {dur}',
    'st.call.connecting': 'Conectando...',
    'st.call.video': 'Vídeo',
    'st.call.tapEnableCallAudio': '🔊 Toque para ativar o áudio da chamada',
    'st.call.callDuration': 'Duração da chamada: {dur}',
    'st.call.resume': 'Retomar chamada',
    'st.call.hold': 'Colocar chamada em espera',
    'st.call.sharingScreen': 'Compartilhando tela',
    'st.call.shareScreen': 'Compartilhar tela',
    'st.call.shareVideoOnly': 'O compartilhamento de tela está disponível em chamadas de vídeo',
    'st.call.endCall': 'Encerrar chamada',
    'st.call.callVolume': 'Volume da chamada',
    'st.trial.errResolveTenant': 'Não foi possível resolver a organização',
    'st.trial.errPortalUnavailable': 'Portal indisponível',
    'st.trial.stripeFail': 'Não foi possível abrir o portal do Stripe',
    'st.trial.stripeFailDesc': '{message}. Redirecionando para a página de cobrança.',
    'st.trial.frozenHeadline': 'Sua assinatura está pausada — a conta está em modo somente leitura',
    'st.trial.frozenSub': 'Reative agora para desbloquear novos tickets, conversas e o gerenciamento da equipe.',
    'st.trial.reactivate': 'Reativar',
    'st.trial.nDays': '{count} dias',
    'st.trial.nHours': '{count} horas',
    'st.trial.nHour': '{count} hora',
    'st.trial.pastDueHeadline': 'Falha no pagamento — atualize seu cartão antes de {remainder}',
    'st.trial.pastDueSub': 'Tentaremos novamente automaticamente (tentativa {attempt} de {max}). Sua conta permanece ativa durante o período de carência.',
    'st.trial.openingStripe': 'Abrindo o Stripe…',
    'st.trial.updatePayment': 'Atualizar forma de pagamento',
    'st.trial.expiredHeadline': 'Seu período de avaliação terminou',
    'st.trial.expiredSub': 'Faça upgrade agora para manter sua equipe e seus clientes conectados.',
    'st.trial.upgradeNow': 'Fazer upgrade agora',
    'st.trial.urgentHeadlineOne': 'Resta apenas {count} hora no seu período de avaliação',
    'st.trial.urgentHeadline': 'Restam apenas {count} horas no seu período de avaliação',
    'st.trial.soonSub': 'Escolha um plano agora para manter todos os recursos e dados após o término do período de avaliação.',
    'st.trial.soonHeadline': 'Restam {count} dias no seu período de avaliação',
    'st.trial.dismiss': 'Dispensar',
  },
  de: {
    'st.active': 'Aktiv',
    'st.inactive': 'Inaktiv',
    'st.enabled': 'Aktiviert',
    'st.disabled': 'Deaktiviert',
    'st.integrations': 'Integrationen',
    'st.saveChanges': 'Änderungen speichern',
    'st.savingEllipsis': 'Wird gespeichert…',
    'st.settings.loading': 'Einstellungen werden geladen…',
    'st.settings.unavailable': 'Die Workspace-Einstellungen sind vorübergehend nicht verfügbar. Bitte versuche es erneut.',
    'st.settings.noWorkspace': 'Dein Konto ist noch mit keinem Workspace verknüpft, daher können die Einstellungen nicht geladen werden. Wende dich an deinen Administrator, falls dies unerwartet ist.',
    'st.settings.manageWorkspace': 'Verwalte deinen Workspace',
    'st.settings.reset': 'Zurücksetzen',
    'st.settings.tab.general': 'Allgemein',
    'st.settings.tab.notifications': 'Benachrichtigungen',
    'st.settings.tab.ai': 'KI-Einstellungen',
    'st.settings.tab.security': 'Sicherheit',
    'st.settings.tab.users': 'Benutzerverwaltung',
    'st.settings.displayName': 'Anzeigename des Workspace',
    'st.settings.timezone': 'Zeitzone des Workspace',
    'st.settings.timezonePh': 'z. B. America/New_York',
    'st.settings.aiDefaultLang': 'Standardsprache der KI',
    'st.settings.aiLangHelp': 'Sprache, in der die KI antwortet, wenn die Sprache des Kunden nicht erkannt werden kann. Ändert nicht die Sprache der Weboberfläche.',
    'st.settings.archiveDays': 'Datensätze nach N Tagen archivieren (0 = alle behalten)',
    'st.settings.archiveHelp': 'Archiviert alte Konversationen/Tickets vorläufig (löscht sie nie endgültig). Die Durchsetzung erfolgt nur, wenn sie von deinem Administrator aktiviert wurde.',
    'st.settings.callRecording': 'Audioaufzeichnung von Anrufen',
    'st.settings.callRecordingDesc': 'Zeichnet das Audio von ausgehenden Anrufen, Weiterleitungen und Konferenzanrufen auf.',
    'st.settings.callRecordingNote': 'Eingehende Anrufe mit dem KI-Assistenten erzeugen operative Transkripte, die für den Servicekontext, die Eskalation und die Ticketerstellung erforderlich sind (werden immer aufbewahrt, unabhängig von der Audioaufzeichnung).',
    'st.settings.emailNotif': 'E-Mail-Benachrichtigungen',
    'st.settings.emailNotifDesc': 'Operative Follow-up-E-Mails an Kunden',
    'st.settings.smsNotif': 'SMS-Benachrichtigungen',
    'st.settings.smsNotifDesc': 'Operative Follow-up-SMS an Kunden (es können Gebühren des Mobilfunkanbieters anfallen)',
    'st.settings.transactionalNote': 'Transaktionsnachrichten (OTP, Einladungen, Abrechnung, Sicherheit) werden immer gesendet und sind von diesen Einstellungen nicht betroffen.',
    'st.settings.aiAutoRes': 'Automatische KI-Lösung',
    'st.settings.aiAutoResDesc': 'Wenn deaktiviert, eskaliert die KI an einen Menschen, anstatt automatisch zu lösen.',
    'st.settings.saveAi': 'KI-Einstellungen speichern',
    'st.settings.manageAutoRules': 'Regeln und Schwellenwerte für automatische Lösung verwalten',
    'st.settings.securityCompliance': 'Sicherheit und Compliance',
    'st.settings.auditLogging': 'Audit-Protokollierung',
    'st.settings.auditActive': 'Aktiv ({count} Ereignisse)',
    'st.settings.auditNone': 'Keine aufgezeichnete Aktivität',
    'st.settings.compliance': 'Compliance-Nachweise',
    'st.settings.notPublished': 'Nicht veröffentlicht',
    'st.settings.manageTeam': 'Verwalte Teammitglieder und Rollen.',
    'st.settings.manageUsers': 'Benutzer verwalten',
    'st.settings.teamMembers': 'Teammitglieder',
    'st.settings.inviteReview': 'Lade Mitarbeiter ein und überprüfe dein Team.',
    'st.settings.addUser': 'Benutzer hinzufügen',
    'st.settings.inviteStaffMember': 'Mitarbeiter einladen',
    'st.settings.onboardingEmail': 'Eine Onboarding-E-Mail wird gesendet.',
    'st.settings.email': 'E-Mail',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': 'Rolle',
    'st.settings.sending': 'Wird gesendet…',
    'st.settings.sendInvite': 'Einladung senden',
    'st.settings.noTeamMembers': 'Keine Teammitglieder gefunden',
    'st.settings.staffRole': 'Mitarbeiter',
    'st.settings.toast.saved': 'Einstellungen gespeichert',
    'st.settings.toast.savedDesc': 'Workspace-Einstellungen aktualisiert.',
    'st.settings.toast.saveFailed': 'Speichern fehlgeschlagen',
    'st.settings.toast.aiSaved': 'KI-Einstellungen gespeichert',
    'st.settings.toast.aiSavedDesc': 'Einstellung für automatische Lösung aktualisiert.',
    'st.settings.toast.invalidEmail': 'Ungültige E-Mail',
    'st.settings.toast.invalidEmailDesc': 'Gib eine gültige E-Mail-Adresse ein.',
    'st.settings.toast.inviteSent': 'Einladung gesendet',
    'st.settings.toast.inviteSentDesc': 'Einladung an {email} gesendet.',
    'st.settings.toast.inviteFailed': 'Einladung fehlgeschlagen',
    'st.settings.inviteNotSent': 'Die Einladung wurde nicht gesendet',
    'st.settings.errLoadSettings': 'Laden der Einstellungen fehlgeschlagen ({status})',
    'st.settings.errSaveFailed': 'Speichern fehlgeschlagen ({status})',
    'st.settings.errInviteFailed': 'Einladung fehlgeschlagen ({status})',
    'st.integ.planBadge': 'Tarif {tier}',
    'st.integ.desc': 'Verbinde Kanäle, CRMs, Monitoring und Automatisierung. {allowed}/{total} in deinem Tarif verfügbar.',
    'st.integ.unlimited': 'Unbegrenzte aktive Integrationen.',
    'st.integ.upTo': 'Bis zu {cap} aktiv ({enabled}/{cap}).',
    'st.integ.notRegistered': 'Nicht registriert',
    'st.integ.notRegisteredDesc': 'Schließe das Abonnement ab, bevor du Integrationen konfigurierst.',
    'st.integ.saved': 'Gespeichert',
    'st.integ.savedDesc': '{name} aktualisiert.',
    'st.integ.saveFailed': 'Speichern fehlgeschlagen',
    'st.integ.upgrade': 'Upgrade',
    'st.integ.configured': 'Konfiguriert',
    'st.integ.needsCreds': 'Zugangsdaten erforderlich',
    'st.integ.available': 'Zur Konfiguration verfügbar',
    'st.integ.enable': '{name} aktivieren',
    'st.integ.noExecNote': 'Beim Speichern wird deine Konfiguration sicher gespeichert. Die Live-Workflow-Ausführung ist für diesen Connector noch nicht aktiviert.',
    'st.integ.higherPlan': 'In einem höheren Tarif verfügbar. Führe in der Abrechnung ein Upgrade durch, um {name} zu aktivieren.',
    'st.hub.subtitle': 'Die Connectoren deiner Organisation',
    'st.hub.planTag': 'Tarif {tier}',
    'st.hub.refreshStatus': 'Status aktualisieren',
    'st.hub.exportData': 'Daten exportieren',
    'st.hub.addIntegration': 'Integration hinzufügen',
    'st.hub.scopeNote': 'Nur organisationsbezogene Integrationen. Plattforminfrastruktur und plattformweite Governance werden von Servisfy verwaltet und hier nicht angezeigt.',
    'st.hub.none': 'Für diese Organisation sind keine Integrationen konfiguriert.',
    'st.hub.configureInSettings': 'In Einstellungen → Integrationen konfigurieren',
    'st.hub.connectorNote': 'Organisations-Connector. Zugangsdaten werden sicher verwaltet und hier nicht angezeigt.',
    'st.hub.syncNote': 'Synchronisierung und Connector-Test sind für diesen Connector noch nicht verfügbar.',
    'st.hub.configure': 'Konfigurieren',
    'st.hub.webhooks': 'Webhooks',
    'st.hub.webhooksNote': 'Die Webhook-Verwaltung ist für diese Organisation nicht konfiguriert.',
    'st.hub.errLoad': 'Laden der Integrationen fehlgeschlagen ({status})',
    'st.survey.qtype.multiple_choice': 'Multiple Choice',
    'st.survey.qtype.text': 'Textantwort',
    'st.survey.qtype.rating': 'Bewertungsskala',
    'st.survey.qtype.yes_no': 'Ja/Nein',
    'st.survey.loadFail': 'Umfragen konnten nicht geladen werden',
    'st.survey.loadFailDesc': 'Bitte versuche es erneut oder wende dich an deinen Administrator, falls das Problem weiterhin besteht.',
    'st.survey.missingInfo': 'Fehlende Informationen',
    'st.survey.missingInfoDesc': 'Ein Titel und mindestens eine Frage sind erforderlich.',
    'st.survey.notAllowed': 'Nicht erlaubt',
    'st.survey.notAllowedEdit': 'Nur ein Manager oder Administrator kann Umfragen bearbeiten.',
    'st.survey.updated': 'Umfrage aktualisiert',
    'st.survey.updatedDesc': 'Deine Änderungen wurden gespeichert.',
    'st.survey.updateFail': 'Aktualisierung fehlgeschlagen',
    'st.survey.updateFailDesc': 'Die Umfrage konnte nicht gespeichert werden. Bitte versuche es erneut.',
    'st.survey.notAllowedStatus': 'Nur ein Manager oder Administrator kann den Umfragestatus ändern.',
    'st.survey.statusFail': 'Status konnte nicht aktualisiert werden',
    'st.survey.notAllowedResults': 'Nur ein Manager oder Administrator kann die Ergebnisse ansehen.',
    'st.survey.resultsFail': 'Ergebnisse konnten nicht geladen werden',
    'st.survey.manage': 'Umfragen verwalten ({count})',
    'st.survey.loading': 'Umfragen werden geladen…',
    'st.survey.empty': 'Noch keine Umfragen. Erstelle oben eine, um zu beginnen.',
    'st.survey.qCount': '{count} F',
    'st.survey.responses': '{count} Antworten',
    'st.survey.results': 'Ergebnisse',
    'st.survey.toggleActive': 'Aktiv umschalten',
    'st.survey.editTitle': 'Umfrage bearbeiten',
    'st.survey.editDesc': 'Aktualisiere Details und Fragen der Umfrage. Gespeichert über die organisationsbezogene Umfrage-API.',
    'st.survey.fTitle': 'Titel *',
    'st.survey.fDesc': 'Beschreibung',
    'st.survey.fType': 'Typ',
    'st.survey.paid': 'Vergütet',
    'st.survey.unpaid': 'Unvergütet',
    'st.survey.fReward': 'Belohnung',
    'st.survey.fDeadline': 'Frist',
    'st.survey.questions': 'Fragen ({count})',
    'st.survey.addQuestion': 'Frage hinzufügen',
    'st.survey.questionPh': 'Fragetext',
    'st.survey.optionPh': 'Option {n}',
    'st.survey.addOption': 'Option hinzufügen',
    'st.survey.required': 'Erforderlich',
    'st.survey.resultsTitle': 'Umfrageergebnisse',
    'st.survey.loadingResults': 'Ergebnisse werden geladen…',
    'st.survey.totalResponses': '{count} Antwort(en) insgesamt',
    'st.survey.downloadCsv': 'CSV herunterladen',
    'st.survey.average': 'Durchschnitt:',
    'st.survey.noResults': 'Keine Ergebnisse verfügbar.',
    'st.voice.loading': 'Sprachmetriken werden geladen...',
    'st.voice.loadError': 'Laden der Sprachmetriken fehlgeschlagen',
    'st.voice.aiCalls': 'KI-Anrufe',
    'st.voice.aiResolved': 'Von KI gelöst',
    'st.voice.ncalls': '{count} Anrufe',
    'st.voice.escalationRate': 'Eskalationsrate',
    'st.voice.avgDuration': 'Durchschn. Dauer',
    'st.voice.perCall': 'Pro Anruf',
    'st.voice.csat': 'Sprach-CSAT',
    'st.voice.totalAiCalls': 'KI-Anrufe gesamt',
    'st.voice.aiResRate': 'KI-Lösungsrate',
    'st.voice.callsResolvedByAi': '{count} von KI gelöste Anrufe',
    'st.voice.nEscalated': '{count} eskaliert',
    'st.voice.avgCallDuration': 'Durchschn. Anrufdauer',
    'st.voice.nRatings': '{count} Bewertungen',
    'st.voice.noRatings': 'Noch keine Bewertungen',
    'st.voice.aiHandled': 'Von KI bearbeitet',
    'st.voice.noHumanTransfer': 'Keine Weiterleitung an Menschen',
    'st.voice.pendingCallbacks': 'Ausstehende Rückrufe',
    'st.voice.overdueCallbacks': 'Überfällige Rückrufe',
    'st.voice.past5minSla': '5-Min-SLA überschritten',
    'st.voice.avgResTime': 'Durchschn. Lösungszeit',
    'st.voice.operatorAssignments': 'Operator-Zuweisungen',
    'st.voice.operatorResolutions': 'Operator-Lösungen',
    'st.voice.noData': 'Noch keine Sprachanrufdaten. Sprachanrufe erscheinen hier, sobald sie verarbeitet wurden.',
    'st.aim.loading': 'KI-Metriken werden geladen...',
    'st.aim.loadError': 'Laden der KI-Metriken fehlgeschlagen',
    'st.aim.subtitle': 'Überwache KI-gesteuerte Metriken zu automatischer Lösung und Eskalation',
    'st.aim.excellent': 'Ausgezeichnet',
    'st.aim.good': 'Gut',
    'st.aim.needsImprovement': 'Verbesserungsbedarf',
    'st.aim.totalConversations': 'Konversationen gesamt',
    'st.aim.aiProcessedChats': 'Von KI verarbeitete Chats',
    'st.aim.autoResRate': 'Rate der automatischen Lösung',
    'st.aim.nResolved': '{count} gelöst',
    'st.aim.escalationRate': 'Eskalationsrate',
    'st.aim.nEscalated': '{count} eskaliert',
    'st.aim.avgConfidence': 'Durchschn. Konfidenz',
    'st.aim.intentAccuracy': 'Absichtsgenauigkeit',
    'st.aim.languageDistribution': 'Sprachverteilung',
    'st.aim.convByLanguage': 'Konversationen nach Sprache',
    'st.aim.noLanguageData': 'Keine Sprachdaten verfügbar',
    'st.aim.intentDistribution': 'Absichtsverteilung',
    'st.aim.customerIntents': 'Von der KI erkannte Kundenabsichten',
    'st.aim.noIntentData': 'Keine Absichtsdaten verfügbar',
    'st.aim.escalationBreakdown': 'Eskalationsaufschlüsselung',
    'st.aim.escalationByLevel': 'Eskalationen nach Ebene (Operator → Manager → Administrator)',
    'st.aim.aiVoiceAnalytics': 'KI-Sprachanalyse',
    'st.aim.totalVoiceCalls': 'Sprachanrufe gesamt',
    'st.aim.allInboundCalls': 'Alle eingehenden Anrufe',
    'st.aim.aiHandled': 'Von KI bearbeitet',
    'st.aim.noHumanTransfer': 'Keine Weiterleitung an Menschen',
    'st.aim.aiResolved': 'Von KI gelöst',
    'st.aim.confirmedResolved': 'Lösung bestätigt',
    'st.aim.humanEscalated': 'An Menschen eskaliert',
    'st.aim.escalationRatePct': '{rate}% Eskalationsrate',
    'st.aim.pendingCallbacks': 'Ausstehende Rückrufe',
    'st.aim.awaitingCallback': 'Warten auf Rückruf',
    'st.aim.overdueCallbacks': 'Überfällige Rückrufe',
    'st.aim.pastSlaDeadline': 'SLA-Frist überschritten',
    'st.aim.avgCallDuration': 'Durchschn. Anrufdauer',
    'st.aim.minutesPerCall': 'Minuten pro Anruf',
    'st.aim.avgResTime': 'Durchschn. Lösungszeit',
    'st.aim.createResolve': 'Erstellen → lösen',
    'st.aim.slaBreaches': 'Rückruf-SLA-Verstöße',
    'st.aim.slaBreachesNote': 'Rückrufe, die das 5-Minuten-SLA überschritten haben',
    'st.sbm.untitled': 'Lösung ohne Titel',
    'st.sbm.approved': 'Lösung genehmigt',
    'st.sbm.approvedDesc': 'Die Lösung steht nun zur Wiederverwendung durch die KI zur Verfügung.',
    'st.sbm.approvalFailed': 'Genehmigung fehlgeschlagen',
    'st.sbm.rejected': 'Lösung abgelehnt',
    'st.sbm.rejectedDesc': 'Die Lösung wird von der KI nicht verwendet.',
    'st.sbm.rejectionFailed': 'Ablehnung fehlgeschlagen',
    'st.sbm.missingInfo': 'Fehlende Informationen',
    'st.sbm.missingInfoDesc': 'Bitte fülle Titel, Beschreibung und Lösungsschritte aus.',
    'st.sbm.noBusiness': 'Kein Unternehmen ausgewählt',
    'st.sbm.noBusinessDesc': 'Senden nicht möglich — kein aktiver Unternehmenskontext.',
    'st.sbm.updated': 'Lösung aktualisiert',
    'st.sbm.updatedDesc': 'Änderungen erfolgreich gespeichert.',
    'st.sbm.submitted': 'Lösung eingereicht',
    'st.sbm.submittedDesc': 'Lösung zur Genehmigung durch das Management eingereicht. Status: pending_approval.',
    'st.sbm.submitFailed': 'Einreichen fehlgeschlagen',
    'st.sbm.networkError': 'Netzwerkfehler',
    'st.sbm.confirmDelete': '"{title}" löschen? Dies kann nicht rückgängig gemacht werden.',
    'st.sbm.deleted': 'Lösung gelöscht',
    'st.sbm.deletedDesc': 'Lösung dauerhaft entfernt.',
    'st.sbm.deleteFailed': 'Löschen fehlgeschlagen',
    'st.sbm.title': 'Lösungsbank-Verwaltung',
    'st.sbm.subtitle': 'Erstelle und verwalte KI-gestützte Lösungen für häufige Probleme',
    'st.sbm.editSolution': 'Lösung bearbeiten',
    'st.sbm.structure': 'Lösungsstruktur',
    'st.sbm.fTitle': 'Lösungstitel *',
    'st.sbm.fTitlePh': 'Kurzer, aussagekräftiger Titel für diese Lösung',
    'st.sbm.fDesc': 'Problembeschreibung *',
    'st.sbm.fDescPh': 'Beschreibe das Problem, das diese Lösung behandelt',
    'st.sbm.fCategory': 'Problemkategorie *',
    'st.sbm.categoryPh': 'Problemkategorie auswählen',
    'st.sbm.fType': 'Problemtyp *',
    'st.sbm.typePh': 'Problemtyp auswählen',
    'st.sbm.fDifficulty': 'Schwierigkeitsgrad *',
    'st.sbm.difficultyPh': 'Schwierigkeitsgrad auswählen',
    'st.sbm.diffLow': 'Niedrig - Einfache, schnelle Lösung',
    'st.sbm.diffMedium': 'Mittel - Moderate Komplexität',
    'st.sbm.diffHigh': 'Hoch - Komplexe, technische Lösung',
    'st.sbm.fTags': 'Tags *',
    'st.sbm.tagsPh': 'Schlüsselwörter durch Kommas getrennt',
    'st.sbm.tagsHelp': 'Schlüsselwörter, die Kunden verwenden könnten (z. B. Anmeldung, Passwort, Zurücksetzen)',
    'st.sbm.fResolution': 'Lösungsschritte *',
    'st.sbm.resolutionPh': 'Gib jeden Schritt in einer neuen Zeile ein:\nSchritt 1: Zur Anmeldeseite navigieren\nSchritt 2: Auf "Passwort vergessen" klicken\nSchritt 3: E-Mail-Adresse eingeben\nusw...',
    'st.sbm.resolutionHelp': 'Schreibe klare Schritt-für-Schritt-Anweisungen. Jeder Schritt sollte in einer neuen Zeile stehen.',
    'st.sbm.updateSolution': 'Lösung aktualisieren',
    'st.sbm.addSolution': 'Lösung hinzufügen',
    'st.sbm.pendingApprovals': 'Ausstehende Genehmigungen',
    'st.sbm.nPending': '{count} ausstehend',
    'st.sbm.uncategorized': 'Nicht kategorisiert',
    'st.sbm.submittedOn': 'Eingereicht am {date}',
    'st.sbm.noSolutions': 'Keine Lösungen erstellt',
    'st.sbm.noSolutionsDesc': 'Beginne mit dem Aufbau deiner Wissensdatenbank, indem du deine erste Lösung hinzufügst',
    'st.sbm.addFirst': 'Erste Lösung hinzufügen',
    'st.sbm.successRate': '{rate}% Erfolgsquote',
    'st.sbm.uses': '{count} Verwendungen',
    'st.sbm.keywords': 'Schlüsselwörter',
    'st.sbm.resolutionSteps': 'Lösungsschritte',
    'st.sbm.lastUpdated': 'Zuletzt aktualisiert: {date}',
    'st.sbm.addedBy': 'Hinzugefügt von: {name}',
    'st.sbm.unknown': 'Unbekannt',
    'st.conf.tapEnableAudio': 'Tippen, um Audio zu aktivieren',
    'st.conf.inviting': 'Einladung läuft…',
    'st.conf.noAnswer': 'Keine Antwort',
    'st.conf.declined': 'Abgelehnt',
    'st.conf.reconnecting': 'Erneute Verbindung…',
    'st.conf.lost': 'Verloren',
    'st.conf.connected': 'Verbunden',
    'st.conf.noAudio': 'Kein Audio',
    'st.conf.connectingAudio': 'Audio wird verbunden…',
    'st.conf.connecting': 'Verbindung…',
    'st.conf.audioConference': 'Audiokonferenz',
    'st.conf.invitingYou': '{host} lädt dich zu einer Audiokonferenz ein.',
    'st.conf.decline': 'Ablehnen',
    'st.conf.accept': 'Annehmen',
    'st.conf.host': 'Host',
    'st.conf.participant': 'Teilnehmer',
    'st.conf.you': 'Du',
    'st.conf.muted': '(stumm)',
    'st.conf.unmute': 'Stummschaltung aufheben',
    'st.conf.mute': 'Stummschalten',
    'st.conf.noOneYet': 'Noch niemand sonst — lade unten einen Kollegen ein.',
    'st.conf.removeFromConf': 'Aus der Konferenz entfernen',
    'st.conf.addTeammate': '+ Online-Kollegen hinzufügen…',
    'st.conf.noStaffOnline': 'Derzeit sind keine weiteren Mitarbeiter online, die hinzugefügt werden könnten.',
    'st.conf.endConference': 'Konferenz beenden',
    'st.conf.leave': 'Verlassen',
    'st.call.userFallback': 'Benutzer {id}',
    'st.call.shareVideoOnlyMsg': 'Bildschirmfreigabe ist bei Videoanrufen verfügbar.',
    'st.call.shareCouldNotStart': 'Bildschirmfreigabe konnte nicht gestartet werden.',
    'st.call.onHold': 'Gehalten • {dur}',
    'st.call.connected': 'Verbunden • {dur}',
    'st.call.connecting': 'Verbindung...',
    'st.call.video': 'Video',
    'st.call.tapEnableCallAudio': '🔊 Tippen, um das Anruf-Audio zu aktivieren',
    'st.call.callDuration': 'Anrufdauer: {dur}',
    'st.call.resume': 'Anruf fortsetzen',
    'st.call.hold': 'Anruf halten',
    'st.call.sharingScreen': 'Bildschirm wird geteilt',
    'st.call.shareScreen': 'Bildschirm teilen',
    'st.call.shareVideoOnly': 'Bildschirmfreigabe ist bei Videoanrufen verfügbar',
    'st.call.endCall': 'Anruf beenden',
    'st.call.callVolume': 'Anruflautstärke',
    'st.trial.errResolveTenant': 'Organisation konnte nicht aufgelöst werden',
    'st.trial.errPortalUnavailable': 'Portal nicht verfügbar',
    'st.trial.stripeFail': 'Stripe-Portal konnte nicht geöffnet werden',
    'st.trial.stripeFailDesc': '{message}. Weiterleitung zur Abrechnungsseite.',
    'st.trial.frozenHeadline': 'Dein Abonnement ist pausiert — das Konto befindet sich im schreibgeschützten Modus',
    'st.trial.frozenSub': 'Reaktiviere jetzt, um neue Tickets, Konversationen und die Teamverwaltung freizuschalten.',
    'st.trial.reactivate': 'Reaktivieren',
    'st.trial.nDays': '{count} Tage',
    'st.trial.nHours': '{count} Stunden',
    'st.trial.nHour': '{count} Stunde',
    'st.trial.pastDueHeadline': 'Zahlung fehlgeschlagen — aktualisiere deine Karte vor {remainder}',
    'st.trial.pastDueSub': 'Wir versuchen es automatisch erneut (Versuch {attempt} von {max}). Dein Konto bleibt während der Kulanzfrist aktiv.',
    'st.trial.openingStripe': 'Stripe wird geöffnet…',
    'st.trial.updatePayment': 'Zahlungsmethode aktualisieren',
    'st.trial.expiredHeadline': 'Deine Testphase ist beendet',
    'st.trial.expiredSub': 'Führe jetzt ein Upgrade durch, um dein Team und deine Kunden verbunden zu halten.',
    'st.trial.upgradeNow': 'Jetzt upgraden',
    'st.trial.urgentHeadlineOne': 'Nur noch {count} Stunde in deiner Testphase',
    'st.trial.urgentHeadline': 'Nur noch {count} Stunden in deiner Testphase',
    'st.trial.soonSub': 'Wähle jetzt einen Tarif, um nach Ablauf deiner Testphase alle Funktionen und Daten zu behalten.',
    'st.trial.soonHeadline': 'Noch {count} Tage in deiner Testphase',
    'st.trial.dismiss': 'Schließen',
  },
  it: {
    'st.active': 'Attivo',
    'st.inactive': 'Inattivo',
    'st.enabled': 'Abilitato',
    'st.disabled': 'Disabilitato',
    'st.integrations': 'Integrazioni',
    'st.saveChanges': 'Salva modifiche',
    'st.savingEllipsis': 'Salvataggio…',
    'st.settings.loading': 'Caricamento impostazioni…',
    'st.settings.unavailable': "Le impostazioni dell'area di lavoro non sono temporaneamente disponibili. Riprova.",
    'st.settings.noWorkspace': "Il tuo account non è ancora collegato a un'area di lavoro, quindi le impostazioni non possono essere caricate. Contatta il tuo amministratore se ciò è inatteso.",
    'st.settings.manageWorkspace': 'Gestisci la tua area di lavoro',
    'st.settings.reset': 'Reimposta',
    'st.settings.tab.general': 'Generale',
    'st.settings.tab.notifications': 'Notifiche',
    'st.settings.tab.ai': "Impostazioni IA",
    'st.settings.tab.security': 'Sicurezza',
    'st.settings.tab.users': 'Gestione utenti',
    'st.settings.displayName': "Nome visualizzato dell'area di lavoro",
    'st.settings.timezone': "Fuso orario dell'area di lavoro",
    'st.settings.timezonePh': 'es. America/New_York',
    'st.settings.aiDefaultLang': "Lingua predefinita dell'IA",
    'st.settings.aiLangHelp': "Lingua in cui l'IA risponde quando la lingua del cliente non può essere rilevata. Non cambia la lingua dell'interfaccia web.",
    'st.settings.archiveDays': 'Archivia i record dopo N giorni (0 = mantieni tutto)',
    'st.settings.archiveHelp': "Archivia in modo reversibile conversazioni/ticket obsoleti (non elimina mai definitivamente). L'applicazione viene eseguita solo quando è abilitata dal tuo amministratore.",
    'st.settings.callRecording': 'Registrazione audio delle chiamate',
    'st.settings.callRecordingDesc': 'Registra l\'audio delle chiamate in uscita, di trasferimento e in conferenza.',
    'st.settings.callRecordingNote': "Le chiamate in entrata con l'assistente IA generano trascrizioni operative necessarie per il contesto del servizio, l'escalation e la creazione dei ticket (sempre conservate, indipendentemente dalla registrazione audio).",
    'st.settings.emailNotif': 'Notifiche e-mail',
    'st.settings.emailNotifDesc': 'E-mail di follow-up operativo ai clienti',
    'st.settings.smsNotif': 'Notifiche SMS',
    'st.settings.smsNotifDesc': "SMS di follow-up operativo ai clienti (possono essere applicati costi dell'operatore)",
    'st.settings.transactionalNote': 'I messaggi transazionali (OTP, inviti, fatturazione, sicurezza) vengono sempre inviati e non sono influenzati da queste preferenze.',
    'st.settings.aiAutoRes': 'Risoluzione automatica tramite IA',
    'st.settings.aiAutoResDesc': "Quando è disattivata, l'IA effettua l'escalation a un operatore umano invece di risolvere automaticamente.",
    'st.settings.saveAi': 'Salva impostazioni IA',
    'st.settings.manageAutoRules': 'Gestisci regole e soglie di risoluzione automatica',
    'st.settings.securityCompliance': 'Sicurezza e conformità',
    'st.settings.auditLogging': 'Registro di audit',
    'st.settings.auditActive': 'Attivo ({count} eventi)',
    'st.settings.auditNone': 'Nessuna attività registrata',
    'st.settings.compliance': 'Attestazioni di conformità',
    'st.settings.notPublished': 'Non pubblicato',
    'st.settings.manageTeam': 'Gestisci i membri del team e i ruoli.',
    'st.settings.manageUsers': 'Gestisci utenti',
    'st.settings.teamMembers': 'Membri del team',
    'st.settings.inviteReview': 'Invita il personale e rivedi il tuo team.',
    'st.settings.addUser': 'Aggiungi utente',
    'st.settings.inviteStaffMember': 'Invita un membro del personale',
    'st.settings.onboardingEmail': "Verrà inviata un'e-mail di onboarding.",
    'st.settings.email': 'E-mail',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': 'Ruolo',
    'st.settings.sending': 'Invio…',
    'st.settings.sendInvite': "Invia l'invito",
    'st.settings.noTeamMembers': 'Nessun membro del team trovato',
    'st.settings.staffRole': 'personale',
    'st.settings.toast.saved': 'Impostazioni salvate',
    'st.settings.toast.savedDesc': "Impostazioni dell'area di lavoro aggiornate.",
    'st.settings.toast.saveFailed': 'Salvataggio non riuscito',
    'st.settings.toast.aiSaved': 'Impostazioni IA salvate',
    'st.settings.toast.aiSavedDesc': 'Preferenza di risoluzione automatica aggiornata.',
    'st.settings.toast.invalidEmail': 'E-mail non valida',
    'st.settings.toast.invalidEmailDesc': 'Inserisci un indirizzo e-mail valido.',
    'st.settings.toast.inviteSent': 'Invito inviato',
    'st.settings.toast.inviteSentDesc': 'Invito inviato a {email}.',
    'st.settings.toast.inviteFailed': 'Invito non riuscito',
    'st.settings.inviteNotSent': "L'invito non è stato inviato",
    'st.settings.errLoadSettings': 'Caricamento delle impostazioni non riuscito ({status})',
    'st.settings.errSaveFailed': 'Salvataggio non riuscito ({status})',
    'st.settings.errInviteFailed': 'Invito non riuscito ({status})',
    'st.integ.planBadge': 'Piano {tier}',
    'st.integ.desc': 'Collega canali, CRM, monitoraggio e automazione. {allowed}/{total} disponibili nel tuo piano.',
    'st.integ.unlimited': 'Integrazioni attive illimitate.',
    'st.integ.upTo': 'Fino a {cap} attive ({enabled}/{cap}).',
    'st.integ.notRegistered': 'Non registrato',
    'st.integ.notRegisteredDesc': "Completa l'abbonamento prima di configurare le integrazioni.",
    'st.integ.saved': 'Salvato',
    'st.integ.savedDesc': '{name} aggiornato.',
    'st.integ.saveFailed': 'Salvataggio non riuscito',
    'st.integ.upgrade': "Passa a un piano superiore",
    'st.integ.configured': 'Configurato',
    'st.integ.needsCreds': 'Credenziali necessarie',
    'st.integ.available': 'Disponibile per la configurazione',
    'st.integ.enable': 'Abilita {name}',
    'st.integ.noExecNote': "Il salvataggio memorizza la tua configurazione in modo sicuro. L'esecuzione dei flussi di lavoro in tempo reale non è ancora abilitata per questo connettore.",
    'st.integ.higherPlan': 'Disponibile con un piano superiore. Effettua l\'upgrade in Fatturazione per abilitare {name}.',
    'st.hub.subtitle': 'I connettori della tua organizzazione',
    'st.hub.planTag': 'Piano {tier}',
    'st.hub.refreshStatus': 'Aggiorna stato',
    'st.hub.exportData': 'Esporta dati',
    'st.hub.addIntegration': 'Aggiungi integrazione',
    'st.hub.scopeNote': "Solo integrazioni con ambito organizzazione. L'infrastruttura della piattaforma e la governance a livello di piattaforma sono gestite da Servisfy e non vengono mostrate qui.",
    'st.hub.none': 'Nessuna integrazione configurata per questa organizzazione.',
    'st.hub.configureInSettings': 'Configura in Impostazioni → Integrazioni',
    'st.hub.connectorNote': "Connettore dell'organizzazione. Le credenziali sono gestite in modo sicuro e non vengono mostrate qui.",
    'st.hub.syncNote': 'La sincronizzazione e il test del connettore non sono ancora disponibili per questo connettore.',
    'st.hub.configure': 'Configura',
    'st.hub.webhooks': 'Webhook',
    'st.hub.webhooksNote': 'La gestione dei webhook non è configurata per questa organizzazione.',
    'st.hub.errLoad': 'Caricamento delle integrazioni non riuscito ({status})',
    'st.survey.qtype.multiple_choice': 'Scelta multipla',
    'st.survey.qtype.text': 'Risposta di testo',
    'st.survey.qtype.rating': 'Scala di valutazione',
    'st.survey.qtype.yes_no': 'Sì/No',
    'st.survey.loadFail': 'Impossibile caricare i sondaggi',
    'st.survey.loadFailDesc': 'Riprova o contatta il tuo amministratore se il problema persiste.',
    'st.survey.missingInfo': 'Informazioni mancanti',
    'st.survey.missingInfoDesc': 'Sono richiesti un titolo e almeno una domanda.',
    'st.survey.notAllowed': 'Non consentito',
    'st.survey.notAllowedEdit': 'Solo un Manager o un Amministratore può modificare i sondaggi.',
    'st.survey.updated': 'Sondaggio aggiornato',
    'st.survey.updatedDesc': 'Le tue modifiche sono state salvate.',
    'st.survey.updateFail': 'Aggiornamento non riuscito',
    'st.survey.updateFailDesc': 'Impossibile salvare il sondaggio. Riprova.',
    'st.survey.notAllowedStatus': 'Solo un Manager o un Amministratore può modificare lo stato del sondaggio.',
    'st.survey.statusFail': 'Impossibile aggiornare lo stato',
    'st.survey.notAllowedResults': 'Solo un Manager o un Amministratore può visualizzare i risultati.',
    'st.survey.resultsFail': 'Impossibile caricare i risultati',
    'st.survey.manage': 'Gestisci sondaggi ({count})',
    'st.survey.loading': 'Caricamento sondaggi…',
    'st.survey.empty': 'Ancora nessun sondaggio. Creane uno sopra per iniziare.',
    'st.survey.qCount': '{count} D',
    'st.survey.responses': '{count} risposte',
    'st.survey.results': 'Risultati',
    'st.survey.toggleActive': 'Attiva/disattiva',
    'st.survey.editTitle': 'Modifica sondaggio',
    'st.survey.editDesc': "Aggiorna i dettagli e le domande del sondaggio. Salvato tramite l'API dei sondaggi con ambito organizzazione.",
    'st.survey.fTitle': 'Titolo *',
    'st.survey.fDesc': 'Descrizione',
    'st.survey.fType': 'Tipo',
    'st.survey.paid': 'Retribuito',
    'st.survey.unpaid': 'Non retribuito',
    'st.survey.fReward': 'Ricompensa',
    'st.survey.fDeadline': 'Scadenza',
    'st.survey.questions': 'Domande ({count})',
    'st.survey.addQuestion': 'Aggiungi domanda',
    'st.survey.questionPh': 'Testo della domanda',
    'st.survey.optionPh': 'Opzione {n}',
    'st.survey.addOption': 'Aggiungi opzione',
    'st.survey.required': 'Obbligatoria',
    'st.survey.resultsTitle': 'Risultati del sondaggio',
    'st.survey.loadingResults': 'Caricamento risultati…',
    'st.survey.totalResponses': '{count} risposta/e totali',
    'st.survey.downloadCsv': 'Scarica CSV',
    'st.survey.average': 'Media:',
    'st.survey.noResults': 'Nessun risultato disponibile.',
    'st.voice.loading': 'Caricamento metriche vocali...',
    'st.voice.loadError': 'Caricamento delle metriche vocali non riuscito',
    'st.voice.aiCalls': 'Chiamate IA',
    'st.voice.aiResolved': 'Risolte dall\'IA',
    'st.voice.ncalls': '{count} chiamate',
    'st.voice.escalationRate': 'Tasso di escalation',
    'st.voice.avgDuration': 'Durata media',
    'st.voice.perCall': 'Per chiamata',
    'st.voice.csat': 'CSAT vocale',
    'st.voice.totalAiCalls': 'Totale chiamate IA',
    'st.voice.aiResRate': 'Tasso di risoluzione IA',
    'st.voice.callsResolvedByAi': '{count} chiamate risolte dall\'IA',
    'st.voice.nEscalated': '{count} in escalation',
    'st.voice.avgCallDuration': 'Durata media chiamata',
    'st.voice.nRatings': '{count} valutazioni',
    'st.voice.noRatings': 'Ancora nessuna valutazione',
    'st.voice.aiHandled': 'Gestite dall\'IA',
    'st.voice.noHumanTransfer': 'Nessun trasferimento a operatore',
    'st.voice.pendingCallbacks': 'Richiamate in sospeso',
    'st.voice.overdueCallbacks': 'Richiamate scadute',
    'st.voice.past5minSla': 'SLA di 5 min superato',
    'st.voice.avgResTime': 'Tempo medio di risoluzione',
    'st.voice.operatorAssignments': 'Assegnazioni operatore',
    'st.voice.operatorResolutions': 'Risoluzioni operatore',
    'st.voice.noData': 'Ancora nessun dato sulle chiamate vocali. Le chiamate vocali appariranno qui una volta elaborate.',
    'st.aim.loading': 'Caricamento metriche IA...',
    'st.aim.loadError': 'Caricamento delle metriche IA non riuscito',
    'st.aim.subtitle': "Monitora le metriche di risoluzione automatica ed escalation basate sull'IA",
    'st.aim.excellent': 'Eccellente',
    'st.aim.good': 'Buono',
    'st.aim.needsImprovement': 'Da migliorare',
    'st.aim.totalConversations': 'Totale conversazioni',
    'st.aim.aiProcessedChats': 'Chat elaborate dall\'IA',
    'st.aim.autoResRate': 'Tasso di risoluzione automatica',
    'st.aim.nResolved': '{count} risolte',
    'st.aim.escalationRate': 'Tasso di escalation',
    'st.aim.nEscalated': '{count} in escalation',
    'st.aim.avgConfidence': 'Confidenza media',
    'st.aim.intentAccuracy': "Precisione dell'intento",
    'st.aim.languageDistribution': 'Distribuzione per lingua',
    'st.aim.convByLanguage': 'Conversazioni per lingua',
    'st.aim.noLanguageData': 'Nessun dato sulla lingua disponibile',
    'st.aim.intentDistribution': 'Distribuzione degli intenti',
    'st.aim.customerIntents': "Intenti dei clienti identificati dall'IA",
    'st.aim.noIntentData': 'Nessun dato sugli intenti disponibile',
    'st.aim.escalationBreakdown': 'Dettaglio delle escalation',
    'st.aim.escalationByLevel': 'Escalation per livello (Operatore → Manager → Amministratore)',
    'st.aim.aiVoiceAnalytics': 'Analisi vocale IA',
    'st.aim.totalVoiceCalls': 'Totale chiamate vocali',
    'st.aim.allInboundCalls': 'Tutte le chiamate in entrata',
    'st.aim.aiHandled': 'Gestite dall\'IA',
    'st.aim.noHumanTransfer': 'Nessun trasferimento a operatore',
    'st.aim.aiResolved': 'Risolte dall\'IA',
    'st.aim.confirmedResolved': 'Risoluzione confermata',
    'st.aim.humanEscalated': 'In escalation a operatore',
    'st.aim.escalationRatePct': '{rate}% di tasso di escalation',
    'st.aim.pendingCallbacks': 'Richiamate in sospeso',
    'st.aim.awaitingCallback': 'In attesa di richiamata',
    'st.aim.overdueCallbacks': 'Richiamate scadute',
    'st.aim.pastSlaDeadline': 'Scadenza SLA superata',
    'st.aim.avgCallDuration': 'Durata media chiamata',
    'st.aim.minutesPerCall': 'Minuti per chiamata',
    'st.aim.avgResTime': 'Tempo medio di risoluzione',
    'st.aim.createResolve': 'Crea → risolvi',
    'st.aim.slaBreaches': 'Violazioni SLA richiamata',
    'st.aim.slaBreachesNote': 'Richiamate che hanno superato lo SLA di 5 minuti',
    'st.sbm.untitled': 'Soluzione senza titolo',
    'st.sbm.approved': 'Soluzione approvata',
    'st.sbm.approvedDesc': "La soluzione è ora disponibile per il riutilizzo da parte dell'IA.",
    'st.sbm.approvalFailed': 'Approvazione non riuscita',
    'st.sbm.rejected': 'Soluzione rifiutata',
    'st.sbm.rejectedDesc': "La soluzione non verrà utilizzata dall'IA.",
    'st.sbm.rejectionFailed': 'Rifiuto non riuscito',
    'st.sbm.missingInfo': 'Informazioni mancanti',
    'st.sbm.missingInfoDesc': 'Compila titolo, descrizione e passaggi di risoluzione.',
    'st.sbm.noBusiness': 'Nessuna attività selezionata',
    'st.sbm.noBusinessDesc': "Impossibile inviare — nessun contesto aziendale attivo.",
    'st.sbm.updated': 'Soluzione aggiornata',
    'st.sbm.updatedDesc': 'Modifiche salvate con successo.',
    'st.sbm.submitted': 'Soluzione inviata',
    'st.sbm.submittedDesc': "Soluzione inviata per l'approvazione della direzione. Stato: pending_approval.",
    'st.sbm.submitFailed': 'Invio non riuscito',
    'st.sbm.networkError': 'Errore di rete',
    'st.sbm.confirmDelete': 'Eliminare "{title}"? Questa operazione non può essere annullata.',
    'st.sbm.deleted': 'Soluzione eliminata',
    'st.sbm.deletedDesc': 'Soluzione rimossa definitivamente.',
    'st.sbm.deleteFailed': 'Eliminazione non riuscita',
    'st.sbm.title': 'Gestione della banca delle soluzioni',
    'st.sbm.subtitle': "Crea e gestisci soluzioni basate sull'IA per i problemi comuni",
    'st.sbm.editSolution': 'Modifica soluzione',
    'st.sbm.structure': 'Struttura della soluzione',
    'st.sbm.fTitle': 'Titolo della soluzione *',
    'st.sbm.fTitlePh': 'Titolo breve e descrittivo per questa soluzione',
    'st.sbm.fDesc': 'Descrizione del problema *',
    'st.sbm.fDescPh': 'Descrivi il problema che questa soluzione affronta',
    'st.sbm.fCategory': 'Categoria del problema *',
    'st.sbm.categoryPh': 'Seleziona la categoria del problema',
    'st.sbm.fType': 'Tipo di problema *',
    'st.sbm.typePh': 'Seleziona il tipo di problema',
    'st.sbm.fDifficulty': 'Livello di difficoltà *',
    'st.sbm.difficultyPh': 'Seleziona il livello di difficoltà',
    'st.sbm.diffLow': 'Bassa - Risoluzione semplice e rapida',
    'st.sbm.diffMedium': 'Media - Complessità moderata',
    'st.sbm.diffHigh': 'Alta - Soluzione complessa e tecnica',
    'st.sbm.fTags': 'Tag *',
    'st.sbm.tagsPh': 'Parole chiave separate da virgole',
    'st.sbm.tagsHelp': 'Parole chiave che i clienti potrebbero usare (es. accesso, password, reimposta)',
    'st.sbm.fResolution': 'Passaggi di risoluzione *',
    'st.sbm.resolutionPh': "Inserisci ogni passaggio su una nuova riga:\nPassaggio 1: Vai alla pagina di accesso\nPassaggio 2: Fai clic su password dimenticata\nPassaggio 3: Inserisci l'indirizzo e-mail\necc...",
    'st.sbm.resolutionHelp': 'Scrivi istruzioni chiare, passo dopo passo. Ogni passaggio dovrebbe essere su una nuova riga.',
    'st.sbm.updateSolution': 'Aggiorna soluzione',
    'st.sbm.addSolution': 'Aggiungi soluzione',
    'st.sbm.pendingApprovals': 'Approvazioni in sospeso',
    'st.sbm.nPending': '{count} in sospeso',
    'st.sbm.uncategorized': 'Senza categoria',
    'st.sbm.submittedOn': 'Inviata il {date}',
    'st.sbm.noSolutions': 'Nessuna soluzione creata',
    'st.sbm.noSolutionsDesc': 'Inizia a costruire la tua base di conoscenza aggiungendo la tua prima soluzione',
    'st.sbm.addFirst': 'Aggiungi la prima soluzione',
    'st.sbm.successRate': '{rate}% di tasso di successo',
    'st.sbm.uses': '{count} utilizzi',
    'st.sbm.keywords': 'Parole chiave',
    'st.sbm.resolutionSteps': 'Passaggi di risoluzione',
    'st.sbm.lastUpdated': 'Ultimo aggiornamento: {date}',
    'st.sbm.addedBy': 'Aggiunta da: {name}',
    'st.sbm.unknown': 'Sconosciuto',
    'st.conf.tapEnableAudio': "Tocca per attivare l'audio",
    'st.conf.inviting': 'Invito in corso…',
    'st.conf.noAnswer': 'Nessuna risposta',
    'st.conf.declined': 'Rifiutata',
    'st.conf.reconnecting': 'Riconnessione…',
    'st.conf.lost': 'Persa',
    'st.conf.connected': 'Connesso',
    'st.conf.noAudio': 'Nessun audio',
    'st.conf.connectingAudio': 'Connessione audio…',
    'st.conf.connecting': 'Connessione…',
    'st.conf.audioConference': 'Audioconferenza',
    'st.conf.invitingYou': '{host} ti sta invitando a un\'audioconferenza.',
    'st.conf.decline': 'Rifiuta',
    'st.conf.accept': 'Accetta',
    'st.conf.host': 'Host',
    'st.conf.participant': 'Partecipante',
    'st.conf.you': 'Tu',
    'st.conf.muted': '(disattivato)',
    'st.conf.unmute': 'Riattiva microfono',
    'st.conf.mute': 'Disattiva microfono',
    'st.conf.noOneYet': "Ancora nessun altro — invita un collega qui sotto.",
    'st.conf.removeFromConf': 'Rimuovi dalla conferenza',
    'st.conf.addTeammate': '+ Aggiungi collega online…',
    'st.conf.noStaffOnline': 'Nessun altro membro del personale attualmente online da aggiungere.',
    'st.conf.endConference': 'Termina conferenza',
    'st.conf.leave': 'Esci',
    'st.call.userFallback': 'Utente {id}',
    'st.call.shareVideoOnlyMsg': 'La condivisione dello schermo è disponibile nelle videochiamate.',
    'st.call.shareCouldNotStart': "Impossibile avviare la condivisione dello schermo.",
    'st.call.onHold': 'In attesa • {dur}',
    'st.call.connected': 'Connesso • {dur}',
    'st.call.connecting': 'Connessione...',
    'st.call.video': 'Video',
    'st.call.tapEnableCallAudio': "🔊 Tocca per attivare l'audio della chiamata",
    'st.call.callDuration': 'Durata della chiamata: {dur}',
    'st.call.resume': 'Riprendi chiamata',
    'st.call.hold': 'Metti in attesa',
    'st.call.sharingScreen': 'Condivisione schermo',
    'st.call.shareScreen': 'Condividi schermo',
    'st.call.shareVideoOnly': 'La condivisione dello schermo è disponibile nelle videochiamate',
    'st.call.endCall': 'Termina chiamata',
    'st.call.callVolume': 'Volume della chiamata',
    'st.trial.errResolveTenant': 'Impossibile risolvere l\'organizzazione',
    'st.trial.errPortalUnavailable': 'Portale non disponibile',
    'st.trial.stripeFail': 'Impossibile aprire il portale Stripe',
    'st.trial.stripeFailDesc': '{message}. Reindirizzamento alla pagina di fatturazione.',
    'st.trial.frozenHeadline': 'Il tuo abbonamento è in pausa — l\'account è in modalità di sola lettura',
    'st.trial.frozenSub': 'Riattiva ora per sbloccare nuovi ticket, conversazioni e la gestione del team.',
    'st.trial.reactivate': 'Riattiva',
    'st.trial.nDays': '{count} giorni',
    'st.trial.nHours': '{count} ore',
    'st.trial.nHour': '{count} ora',
    'st.trial.pastDueHeadline': 'Pagamento non riuscito — aggiorna la tua carta prima di {remainder}',
    'st.trial.pastDueSub': 'Riproveremo automaticamente (tentativo {attempt} di {max}). Il tuo account rimane attivo durante il periodo di tolleranza.',
    'st.trial.openingStripe': 'Apertura di Stripe…',
    'st.trial.updatePayment': 'Aggiorna metodo di pagamento',
    'st.trial.expiredHeadline': 'La tua prova è terminata',
    'st.trial.expiredSub': 'Effettua ora l\'upgrade per mantenere connessi il tuo team e i tuoi clienti.',
    'st.trial.upgradeNow': 'Effettua l\'upgrade ora',
    'st.trial.urgentHeadlineOne': 'Resta solo {count} ora di prova',
    'st.trial.urgentHeadline': 'Restano solo {count} ore di prova',
    'st.trial.soonSub': 'Scegli un piano ora per conservare tutte le funzionalità e i dati al termine della prova.',
    'st.trial.soonHeadline': 'Restano {count} giorni di prova',
    'st.trial.dismiss': 'Ignora',
  },
  ja: {
    'st.active': '有効',
    'st.inactive': '無効',
    'st.enabled': '有効',
    'st.disabled': '無効',
    'st.integrations': '連携',
    'st.saveChanges': '変更を保存',
    'st.savingEllipsis': '保存しています…',
    'st.settings.loading': '設定を読み込んでいます…',
    'st.settings.unavailable': 'ワークスペースの設定を一時的に利用できません。もう一度お試しください。',
    'st.settings.noWorkspace': 'お使いのアカウントはまだワークスペースに関連付けられていないため、設定を読み込めません。想定外の場合は管理者にお問い合わせください。',
    'st.settings.manageWorkspace': 'ワークスペースを管理',
    'st.settings.reset': 'リセット',
    'st.settings.tab.general': '一般',
    'st.settings.tab.notifications': '通知',
    'st.settings.tab.ai': 'AI設定',
    'st.settings.tab.security': 'セキュリティ',
    'st.settings.tab.users': 'ユーザー管理',
    'st.settings.displayName': 'ワークスペースの表示名',
    'st.settings.timezone': 'ワークスペースのタイムゾーン',
    'st.settings.timezonePh': '例: America/New_York',
    'st.settings.aiDefaultLang': 'AIの既定の言語',
    'st.settings.aiLangHelp': '顧客の言語を検出できない場合にAIが返信する言語です。WebのUI言語は変更されません。',
    'st.settings.archiveDays': 'N日後にレコードをアーカイブ（0=すべて保持）',
    'st.settings.archiveHelp': '古い会話やチケットをソフトアーカイブします（完全削除は行いません）。適用は管理者が有効にした場合にのみ実行されます。',
    'st.settings.callRecording': '通話音声の録音',
    'st.settings.callRecordingDesc': '発信、転送、電話会議の通話音声を録音します。',
    'st.settings.callRecordingNote': 'AIアシスタントへの着信通話では、サービスの文脈、エスカレーション、チケット作成に必要な運用トランスクリプトが生成されます（音声録音とは別に常に保持されます）。',
    'st.settings.emailNotif': 'メール通知',
    'st.settings.emailNotifDesc': '顧客への業務フォローアップメール',
    'st.settings.smsNotif': 'SMS通知',
    'st.settings.smsNotifDesc': '顧客への業務フォローアップSMS（通信事業者の料金がかかる場合があります）',
    'st.settings.transactionalNote': 'トランザクションメッセージ（OTP、招待、請求、セキュリティ）は常に送信され、これらの設定の影響を受けません。',
    'st.settings.aiAutoRes': 'AI自動解決',
    'st.settings.aiAutoResDesc': 'オフの場合、AIは自動解決せずに人間へエスカレーションします。',
    'st.settings.saveAi': 'AI設定を保存',
    'st.settings.manageAutoRules': '自動解決のルールとしきい値を管理',
    'st.settings.securityCompliance': 'セキュリティとコンプライアンス',
    'st.settings.auditLogging': '監査ログ',
    'st.settings.auditActive': '有効（{count}件のイベント）',
    'st.settings.auditNone': '記録された操作はありません',
    'st.settings.compliance': 'コンプライアンス証明',
    'st.settings.notPublished': '未公開',
    'st.settings.manageTeam': 'チームメンバーと役割を管理します。',
    'st.settings.manageUsers': 'ユーザーを管理',
    'st.settings.teamMembers': 'チームメンバー',
    'st.settings.inviteReview': 'スタッフを招待し、チームを確認します。',
    'st.settings.addUser': 'ユーザーを追加',
    'st.settings.inviteStaffMember': 'スタッフを招待',
    'st.settings.onboardingEmail': 'オンボーディングメールが送信されます。',
    'st.settings.email': 'メール',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': '役割',
    'st.settings.sending': '送信しています…',
    'st.settings.sendInvite': '招待を送信',
    'st.settings.noTeamMembers': 'チームメンバーが見つかりません',
    'st.settings.staffRole': 'スタッフ',
    'st.settings.toast.saved': '設定を保存しました',
    'st.settings.toast.savedDesc': 'ワークスペースの設定を更新しました。',
    'st.settings.toast.saveFailed': '保存に失敗しました',
    'st.settings.toast.aiSaved': 'AI設定を保存しました',
    'st.settings.toast.aiSavedDesc': '自動解決の設定を更新しました。',
    'st.settings.toast.invalidEmail': '無効なメール',
    'st.settings.toast.invalidEmailDesc': '有効なメールアドレスを入力してください。',
    'st.settings.toast.inviteSent': '招待を送信しました',
    'st.settings.toast.inviteSentDesc': '{email}に招待を送信しました。',
    'st.settings.toast.inviteFailed': '招待に失敗しました',
    'st.settings.inviteNotSent': '招待は送信されませんでした',
    'st.settings.errLoadSettings': '設定の読み込みに失敗しました（{status}）',
    'st.settings.errSaveFailed': '保存に失敗しました（{status}）',
    'st.settings.errInviteFailed': '招待に失敗しました（{status}）',
    'st.integ.planBadge': '{tier}プラン',
    'st.integ.desc': 'チャネル、CRM、モニタリング、自動化を接続します。ご利用のプランで{allowed}/{total}件が利用可能です。',
    'st.integ.unlimited': '有効な連携は無制限です。',
    'st.integ.upTo': '最大{cap}件まで有効（{enabled}/{cap}）。',
    'st.integ.notRegistered': '未登録',
    'st.integ.notRegisteredDesc': '連携を設定する前にサブスクリプションを完了してください。',
    'st.integ.saved': '保存しました',
    'st.integ.savedDesc': '{name}を更新しました。',
    'st.integ.saveFailed': '保存に失敗しました',
    'st.integ.upgrade': 'アップグレード',
    'st.integ.configured': '設定済み',
    'st.integ.needsCreds': '認証情報が必要',
    'st.integ.available': '設定可能',
    'st.integ.enable': '{name}を有効化',
    'st.integ.noExecNote': '保存すると設定が安全に保管されます。このコネクタではライブのワークフロー実行はまだ有効になっていません。',
    'st.integ.higherPlan': '上位プランで利用可能です。{name}を有効にするには請求でアップグレードしてください。',
    'st.hub.subtitle': 'テナントのコネクタ',
    'st.hub.planTag': '{tier}プラン',
    'st.hub.refreshStatus': 'ステータスを更新',
    'st.hub.exportData': 'データをエクスポート',
    'st.hub.addIntegration': '連携を追加',
    'st.hub.scopeNote': 'テナント範囲の連携のみです。プラットフォームのインフラおよびプラットフォームレベルのガバナンスはServisfyが管理しており、ここには表示されません。',
    'st.hub.none': 'このテナントに設定された連携はありません。',
    'st.hub.configureInSettings': '設定 → 連携で構成',
    'st.hub.connectorNote': 'テナントコネクタです。認証情報は安全に管理され、ここには表示されません。',
    'st.hub.syncNote': 'このコネクタでは同期とコネクタテストはまだ利用できません。',
    'st.hub.configure': '構成',
    'st.hub.webhooks': 'Webhook',
    'st.hub.webhooksNote': 'このテナントではWebhook管理が設定されていません。',
    'st.hub.errLoad': '連携の読み込みに失敗しました（{status}）',
    'st.survey.qtype.multiple_choice': '複数選択',
    'st.survey.qtype.text': '自由記述',
    'st.survey.qtype.rating': '評価スケール',
    'st.survey.qtype.yes_no': 'はい/いいえ',
    'st.survey.loadFail': 'アンケートを読み込めませんでした',
    'st.survey.loadFailDesc': 'もう一度お試しいただくか、問題が解決しない場合は管理者にお問い合わせください。',
    'st.survey.missingInfo': '情報が不足しています',
    'st.survey.missingInfoDesc': 'タイトルと少なくとも1つの質問が必要です。',
    'st.survey.notAllowed': '許可されていません',
    'st.survey.notAllowedEdit': 'アンケートを編集できるのはマネージャーまたは管理者のみです。',
    'st.survey.updated': 'アンケートを更新しました',
    'st.survey.updatedDesc': '変更を保存しました。',
    'st.survey.updateFail': '更新に失敗しました',
    'st.survey.updateFailDesc': 'アンケートを保存できませんでした。もう一度お試しください。',
    'st.survey.notAllowedStatus': 'アンケートのステータスを変更できるのはマネージャーまたは管理者のみです。',
    'st.survey.statusFail': 'ステータスを更新できませんでした',
    'st.survey.notAllowedResults': '結果を表示できるのはマネージャーまたは管理者のみです。',
    'st.survey.resultsFail': '結果を読み込めませんでした',
    'st.survey.manage': 'アンケートを管理（{count}）',
    'st.survey.loading': 'アンケートを読み込んでいます…',
    'st.survey.empty': 'アンケートはまだありません。上で作成して始めましょう。',
    'st.survey.qCount': '{count}問',
    'st.survey.responses': '{count}件の回答',
    'st.survey.results': '結果',
    'st.survey.toggleActive': '有効/無効を切り替え',
    'st.survey.editTitle': 'アンケートを編集',
    'st.survey.editDesc': 'アンケートの詳細と質問を更新します。テナント範囲のアンケートAPI経由で保存されます。',
    'st.survey.fTitle': 'タイトル *',
    'st.survey.fDesc': '説明',
    'st.survey.fType': '種類',
    'st.survey.paid': '有償',
    'st.survey.unpaid': '無償',
    'st.survey.fReward': '報酬',
    'st.survey.fDeadline': '締め切り',
    'st.survey.questions': '質問（{count}）',
    'st.survey.addQuestion': '質問を追加',
    'st.survey.questionPh': '質問文',
    'st.survey.optionPh': '選択肢 {n}',
    'st.survey.addOption': '選択肢を追加',
    'st.survey.required': '必須',
    'st.survey.resultsTitle': 'アンケート結果',
    'st.survey.loadingResults': '結果を読み込んでいます…',
    'st.survey.totalResponses': '合計{count}件の回答',
    'st.survey.downloadCsv': 'CSVをダウンロード',
    'st.survey.average': '平均:',
    'st.survey.noResults': '利用可能な結果はありません。',
    'st.voice.loading': '音声指標を読み込んでいます...',
    'st.voice.loadError': '音声指標の読み込みに失敗しました',
    'st.voice.aiCalls': 'AI通話',
    'st.voice.aiResolved': 'AIが解決',
    'st.voice.ncalls': '{count}件の通話',
    'st.voice.escalationRate': 'エスカレーション率',
    'st.voice.avgDuration': '平均時間',
    'st.voice.perCall': '1通話あたり',
    'st.voice.csat': '音声CSAT',
    'st.voice.totalAiCalls': 'AI通話の合計',
    'st.voice.aiResRate': 'AI解決率',
    'st.voice.callsResolvedByAi': 'AIが解決した通話{count}件',
    'st.voice.nEscalated': '{count}件エスカレーション',
    'st.voice.avgCallDuration': '平均通話時間',
    'st.voice.nRatings': '{count}件の評価',
    'st.voice.noRatings': 'まだ評価はありません',
    'st.voice.aiHandled': 'AIが対応',
    'st.voice.noHumanTransfer': '人間への転送なし',
    'st.voice.pendingCallbacks': '保留中のコールバック',
    'st.voice.overdueCallbacks': '期限超過のコールバック',
    'st.voice.past5minSla': '5分SLA超過',
    'st.voice.avgResTime': '平均解決時間',
    'st.voice.operatorAssignments': 'オペレーター割り当て',
    'st.voice.operatorResolutions': 'オペレーター解決',
    'st.voice.noData': '音声通話のデータはまだありません。音声通話は処理されるとここに表示されます。',
    'st.aim.loading': 'AI指標を読み込んでいます...',
    'st.aim.loadError': 'AI指標の読み込みに失敗しました',
    'st.aim.subtitle': 'AI主導の自動解決とエスカレーション指標を監視します',
    'st.aim.excellent': '優秀',
    'st.aim.good': '良好',
    'st.aim.needsImprovement': '改善が必要',
    'st.aim.totalConversations': '会話の合計',
    'st.aim.aiProcessedChats': 'AIが処理したチャット',
    'st.aim.autoResRate': '自動解決率',
    'st.aim.nResolved': '{count}件解決',
    'st.aim.escalationRate': 'エスカレーション率',
    'st.aim.nEscalated': '{count}件エスカレーション',
    'st.aim.avgConfidence': '平均信頼度',
    'st.aim.intentAccuracy': '意図の正確度',
    'st.aim.languageDistribution': '言語の分布',
    'st.aim.convByLanguage': '言語別の会話',
    'st.aim.noLanguageData': '言語データがありません',
    'st.aim.intentDistribution': '意図の分布',
    'st.aim.customerIntents': 'AIが特定した顧客の意図',
    'st.aim.noIntentData': '意図データがありません',
    'st.aim.escalationBreakdown': 'エスカレーションの内訳',
    'st.aim.escalationByLevel': 'レベル別のエスカレーション（Operator → Manager → Admin）',
    'st.aim.aiVoiceAnalytics': 'AI音声分析',
    'st.aim.totalVoiceCalls': '音声通話の合計',
    'st.aim.allInboundCalls': 'すべての着信通話',
    'st.aim.aiHandled': 'AIが対応',
    'st.aim.noHumanTransfer': '人間への転送なし',
    'st.aim.aiResolved': 'AIが解決',
    'st.aim.confirmedResolved': '解決を確認済み',
    'st.aim.humanEscalated': '人間にエスカレーション',
    'st.aim.escalationRatePct': 'エスカレーション率{rate}%',
    'st.aim.pendingCallbacks': '保留中のコールバック',
    'st.aim.awaitingCallback': 'コールバック待ち',
    'st.aim.overdueCallbacks': '期限超過のコールバック',
    'st.aim.pastSlaDeadline': 'SLA期限超過',
    'st.aim.avgCallDuration': '平均通話時間',
    'st.aim.minutesPerCall': '1通話あたりの分数',
    'st.aim.avgResTime': '平均解決時間',
    'st.aim.createResolve': '作成 → 解決',
    'st.aim.slaBreaches': 'コールバックSLA違反',
    'st.aim.slaBreachesNote': '5分のSLAを超過したコールバック',
    'st.sbm.untitled': '無題のソリューション',
    'st.sbm.approved': 'ソリューションを承認しました',
    'st.sbm.approvedDesc': 'ソリューションはAIによる再利用が可能になりました。',
    'st.sbm.approvalFailed': '承認に失敗しました',
    'st.sbm.rejected': 'ソリューションを却下しました',
    'st.sbm.rejectedDesc': 'このソリューションはAIに使用されません。',
    'st.sbm.rejectionFailed': '却下に失敗しました',
    'st.sbm.missingInfo': '情報が不足しています',
    'st.sbm.missingInfoDesc': 'タイトル、説明、解決手順を入力してください。',
    'st.sbm.noBusiness': 'ビジネスが選択されていません',
    'st.sbm.noBusinessDesc': '送信できません — 有効なビジネスコンテキストがありません。',
    'st.sbm.updated': 'ソリューションを更新しました',
    'st.sbm.updatedDesc': '変更を正常に保存しました。',
    'st.sbm.submitted': 'ソリューションを送信しました',
    'st.sbm.submittedDesc': 'ソリューションを管理者の承認のために送信しました。ステータス: pending_approval。',
    'st.sbm.submitFailed': '送信に失敗しました',
    'st.sbm.networkError': 'ネットワークエラー',
    'st.sbm.confirmDelete': '「{title}」を削除しますか？この操作は取り消せません。',
    'st.sbm.deleted': 'ソリューションを削除しました',
    'st.sbm.deletedDesc': 'ソリューションを完全に削除しました。',
    'st.sbm.deleteFailed': '削除に失敗しました',
    'st.sbm.title': 'ソリューションバンク管理',
    'st.sbm.subtitle': 'よくある問題に対するAI搭載のソリューションを作成・管理します',
    'st.sbm.editSolution': 'ソリューションを編集',
    'st.sbm.structure': 'ソリューションの構造',
    'st.sbm.fTitle': 'ソリューションのタイトル *',
    'st.sbm.fTitlePh': 'このソリューションの簡潔で分かりやすいタイトル',
    'st.sbm.fDesc': '問題の説明 *',
    'st.sbm.fDescPh': 'このソリューションが対処する問題を説明してください',
    'st.sbm.fCategory': '問題のカテゴリ *',
    'st.sbm.categoryPh': '問題のカテゴリを選択',
    'st.sbm.fType': '問題の種類 *',
    'st.sbm.typePh': '問題の種類を選択',
    'st.sbm.fDifficulty': '難易度 *',
    'st.sbm.difficultyPh': '難易度を選択',
    'st.sbm.diffLow': '低 - シンプルで迅速な解決',
    'st.sbm.diffMedium': '中 - 中程度の複雑さ',
    'st.sbm.diffHigh': '高 - 複雑で技術的な解決',
    'st.sbm.fTags': 'タグ *',
    'st.sbm.tagsPh': 'カンマで区切ったキーワード',
    'st.sbm.tagsHelp': '顧客が使用しそうなキーワード（例: ログイン、パスワード、リセット）',
    'st.sbm.fResolution': '解決手順 *',
    'st.sbm.resolutionPh': '各手順を新しい行に入力してください:\nステップ1: ログインページに移動\nステップ2: パスワードをお忘れですかをクリック\nステップ3: メールアドレスを入力\nなど...',
    'st.sbm.resolutionHelp': '明確な手順を段階的に記述してください。各手順は新しい行に記載してください。',
    'st.sbm.updateSolution': 'ソリューションを更新',
    'st.sbm.addSolution': 'ソリューションを追加',
    'st.sbm.pendingApprovals': '承認待ち',
    'st.sbm.nPending': '{count}件保留中',
    'st.sbm.uncategorized': '未分類',
    'st.sbm.submittedOn': '{date}に送信',
    'st.sbm.noSolutions': 'ソリューションが作成されていません',
    'st.sbm.noSolutionsDesc': '最初のソリューションを追加してナレッジベースの構築を始めましょう',
    'st.sbm.addFirst': '最初のソリューションを追加',
    'st.sbm.successRate': '成功率{rate}%',
    'st.sbm.uses': '{count}回使用',
    'st.sbm.keywords': 'キーワード',
    'st.sbm.resolutionSteps': '解決手順',
    'st.sbm.lastUpdated': '最終更新: {date}',
    'st.sbm.addedBy': '追加者: {name}',
    'st.sbm.unknown': '不明',
    'st.conf.tapEnableAudio': 'タップして音声を有効化',
    'st.conf.inviting': '招待しています…',
    'st.conf.noAnswer': '応答なし',
    'st.conf.declined': '拒否されました',
    'st.conf.reconnecting': '再接続しています…',
    'st.conf.lost': '切断',
    'st.conf.connected': '接続済み',
    'st.conf.noAudio': '音声なし',
    'st.conf.connectingAudio': '音声を接続しています…',
    'st.conf.connecting': '接続しています…',
    'st.conf.audioConference': '音声会議',
    'st.conf.invitingYou': '{host}があなたを音声会議に招待しています。',
    'st.conf.decline': '拒否',
    'st.conf.accept': '承諾',
    'st.conf.host': 'ホスト',
    'st.conf.participant': '参加者',
    'st.conf.you': 'あなた',
    'st.conf.muted': '（ミュート）',
    'st.conf.unmute': 'ミュート解除',
    'st.conf.mute': 'ミュート',
    'st.conf.noOneYet': 'まだ他に誰もいません — 下からチームメイトを招待してください。',
    'st.conf.removeFromConf': '会議から削除',
    'st.conf.addTeammate': '+ オンラインのチームメイトを追加…',
    'st.conf.noStaffOnline': '追加できるオンラインのスタッフは他にいません。',
    'st.conf.endConference': '会議を終了',
    'st.conf.leave': '退出',
    'st.call.userFallback': 'ユーザー{id}',
    'st.call.shareVideoOnlyMsg': '画面共有はビデオ通話で利用できます。',
    'st.call.shareCouldNotStart': '画面共有を開始できませんでした。',
    'st.call.onHold': '保留中 • {dur}',
    'st.call.connected': '接続済み • {dur}',
    'st.call.connecting': '接続しています...',
    'st.call.video': 'ビデオ',
    'st.call.tapEnableCallAudio': '🔊 タップして通話音声を有効化',
    'st.call.callDuration': '通話時間: {dur}',
    'st.call.resume': '通話を再開',
    'st.call.hold': '通話を保留',
    'st.call.sharingScreen': '画面を共有中',
    'st.call.shareScreen': '画面を共有',
    'st.call.shareVideoOnly': '画面共有はビデオ通話で利用できます',
    'st.call.endCall': '通話を終了',
    'st.call.callVolume': '通話音量',
    'st.trial.errResolveTenant': 'テナントを解決できませんでした',
    'st.trial.errPortalUnavailable': 'ポータルが利用できません',
    'st.trial.stripeFail': 'Stripeポータルを開けませんでした',
    'st.trial.stripeFailDesc': '{message}。請求ページにリダイレクトします。',
    'st.trial.frozenHeadline': 'サブスクリプションが一時停止中です — アカウントは読み取り専用モードです',
    'st.trial.frozenSub': '今すぐ再開して、新しいチケット、会話、チーム管理のロックを解除しましょう。',
    'st.trial.reactivate': '再開',
    'st.trial.nDays': '{count}日',
    'st.trial.nHours': '{count}時間',
    'st.trial.nHour': '{count}時間',
    'st.trial.pastDueHeadline': '支払いに失敗しました — {remainder}までにカードを更新してください',
    'st.trial.pastDueSub': '自動的に再試行します（{max}回中{attempt}回目）。猶予期間中はアカウントが有効なままです。',
    'st.trial.openingStripe': 'Stripeを開いています…',
    'st.trial.updatePayment': '支払い方法を更新',
    'st.trial.expiredHeadline': 'トライアルが終了しました',
    'st.trial.expiredSub': '今すぐアップグレードして、チームと顧客のつながりを維持しましょう。',
    'st.trial.upgradeNow': '今すぐアップグレード',
    'st.trial.urgentHeadlineOne': 'トライアルは残り{count}時間です',
    'st.trial.urgentHeadline': 'トライアルは残り{count}時間です',
    'st.trial.soonSub': '今すぐプランを選択して、トライアル終了後もすべての機能とデータを維持しましょう。',
    'st.trial.soonHeadline': 'トライアルは残り{count}日です',
    'st.trial.dismiss': '閉じる',
  },
  ko: {
    'st.active': '활성',
    'st.inactive': '비활성',
    'st.enabled': '사용',
    'st.disabled': '사용 안 함',
    'st.integrations': '통합',
    'st.saveChanges': '변경사항 저장',
    'st.savingEllipsis': '저장 중…',
    'st.settings.loading': '설정을 불러오는 중…',
    'st.settings.unavailable': '워크스페이스 설정을 일시적으로 사용할 수 없습니다. 다시 시도해 주세요.',
    'st.settings.noWorkspace': '계정이 아직 워크스페이스에 연결되지 않아 설정을 불러올 수 없습니다. 예상과 다르다면 관리자에게 문의하세요.',
    'st.settings.manageWorkspace': '워크스페이스 관리',
    'st.settings.reset': '재설정',
    'st.settings.tab.general': '일반',
    'st.settings.tab.notifications': '알림',
    'st.settings.tab.ai': 'AI 설정',
    'st.settings.tab.security': '보안',
    'st.settings.tab.users': '사용자 관리',
    'st.settings.displayName': '워크스페이스 표시 이름',
    'st.settings.timezone': '워크스페이스 시간대',
    'st.settings.timezonePh': '예: America/New_York',
    'st.settings.aiDefaultLang': 'AI 기본 언어',
    'st.settings.aiLangHelp': '고객의 언어를 감지할 수 없을 때 AI가 응답하는 언어입니다. 웹 UI 언어는 변경되지 않습니다.',
    'st.settings.archiveDays': 'N일 후 레코드 보관 (0 = 모두 유지)',
    'st.settings.archiveHelp': '오래된 대화/티켓을 소프트 보관합니다(영구 삭제하지 않음). 적용은 관리자가 활성화한 경우에만 실행됩니다.',
    'st.settings.callRecording': '통화 오디오 녹음',
    'st.settings.callRecordingDesc': '발신, 전환, 컨퍼런스 통화의 오디오를 녹음합니다.',
    'st.settings.callRecordingNote': '인바운드 AI 어시스턴트 통화는 서비스 컨텍스트, 에스컬레이션, 티켓 생성에 필요한 운영 대화 기록을 생성합니다(오디오 녹음과 별개로 항상 보관됨).',
    'st.settings.emailNotif': '이메일 알림',
    'st.settings.emailNotifDesc': '고객에게 보내는 운영 후속 이메일',
    'st.settings.smsNotif': 'SMS 알림',
    'st.settings.smsNotifDesc': '고객에게 보내는 운영 후속 SMS(통신사 요금이 부과될 수 있음)',
    'st.settings.transactionalNote': '거래성 메시지(OTP, 초대, 청구, 보안)는 항상 전송되며 이 환경설정의 영향을 받지 않습니다.',
    'st.settings.aiAutoRes': 'AI 자동 해결',
    'st.settings.aiAutoResDesc': '꺼져 있으면 AI가 자동으로 해결하지 않고 담당자에게 에스컬레이션합니다.',
    'st.settings.saveAi': 'AI 설정 저장',
    'st.settings.manageAutoRules': '자동 해결 규칙 및 임계값 관리',
    'st.settings.securityCompliance': '보안 및 규정 준수',
    'st.settings.auditLogging': '감사 로깅',
    'st.settings.auditActive': '활성({count}개 이벤트)',
    'st.settings.auditNone': '기록된 활동 없음',
    'st.settings.compliance': '규정 준수 증명',
    'st.settings.notPublished': '게시되지 않음',
    'st.settings.manageTeam': '팀원과 역할을 관리하세요.',
    'st.settings.manageUsers': '사용자 관리',
    'st.settings.teamMembers': '팀원',
    'st.settings.inviteReview': '직원을 초대하고 팀을 검토하세요.',
    'st.settings.addUser': '사용자 추가',
    'st.settings.inviteStaffMember': '직원 초대',
    'st.settings.onboardingEmail': '온보딩 이메일이 전송됩니다.',
    'st.settings.email': '이메일',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': '역할',
    'st.settings.sending': '전송 중…',
    'st.settings.sendInvite': '초대 보내기',
    'st.settings.noTeamMembers': '팀원을 찾을 수 없습니다',
    'st.settings.staffRole': '직원',
    'st.settings.toast.saved': '설정이 저장되었습니다',
    'st.settings.toast.savedDesc': '워크스페이스 설정이 업데이트되었습니다.',
    'st.settings.toast.saveFailed': '저장 실패',
    'st.settings.toast.aiSaved': 'AI 설정이 저장되었습니다',
    'st.settings.toast.aiSavedDesc': '자동 해결 환경설정이 업데이트되었습니다.',
    'st.settings.toast.invalidEmail': '잘못된 이메일',
    'st.settings.toast.invalidEmailDesc': '유효한 이메일 주소를 입력하세요.',
    'st.settings.toast.inviteSent': '초대를 보냈습니다',
    'st.settings.toast.inviteSentDesc': '{email}(으)로 초대를 보냈습니다.',
    'st.settings.toast.inviteFailed': '초대 실패',
    'st.settings.inviteNotSent': '초대가 전송되지 않았습니다',
    'st.settings.errLoadSettings': '설정을 불러오지 못했습니다({status})',
    'st.settings.errSaveFailed': '저장 실패({status})',
    'st.settings.errInviteFailed': '초대 실패({status})',
    'st.integ.planBadge': '{tier} 요금제',
    'st.integ.desc': '채널, CRM, 모니터링, 자동화를 연결하세요. 요금제에서 {allowed}/{total}개를 사용할 수 있습니다.',
    'st.integ.unlimited': '무제한 활성 통합.',
    'st.integ.upTo': '최대 {cap}개 활성({enabled}/{cap}).',
    'st.integ.notRegistered': '미등록',
    'st.integ.notRegisteredDesc': '통합을 구성하기 전에 구독을 완료하세요.',
    'st.integ.saved': '저장됨',
    'st.integ.savedDesc': '{name}이(가) 업데이트되었습니다.',
    'st.integ.saveFailed': '저장 실패',
    'st.integ.upgrade': '업그레이드',
    'st.integ.configured': '구성됨',
    'st.integ.needsCreds': '자격 증명 필요',
    'st.integ.available': '구성 가능',
    'st.integ.enable': '{name} 사용',
    'st.integ.noExecNote': '저장하면 구성이 안전하게 보관됩니다. 이 커넥터에서는 실시간 워크플로 실행이 아직 활성화되지 않았습니다.',
    'st.integ.higherPlan': '상위 요금제에서 사용할 수 있습니다. {name}을(를) 사용하려면 청구에서 업그레이드하세요.',
    'st.hub.subtitle': '테넌트의 커넥터',
    'st.hub.planTag': '{tier} 요금제',
    'st.hub.refreshStatus': '상태 새로고침',
    'st.hub.exportData': '데이터 내보내기',
    'st.hub.addIntegration': '통합 추가',
    'st.hub.scopeNote': '테넌트 범위의 통합만 표시됩니다. 플랫폼 인프라와 플랫폼 수준의 거버넌스는 Servisfy가 관리하며 여기에 표시되지 않습니다.',
    'st.hub.none': '이 테넌트에 구성된 통합이 없습니다.',
    'st.hub.configureInSettings': '설정 → 통합에서 구성',
    'st.hub.connectorNote': '테넌트 커넥터입니다. 자격 증명은 안전하게 관리되며 여기에 표시되지 않습니다.',
    'st.hub.syncNote': '이 커넥터에서는 동기화 및 커넥터 테스트를 아직 사용할 수 없습니다.',
    'st.hub.configure': '구성',
    'st.hub.webhooks': '웹훅',
    'st.hub.webhooksNote': '이 테넌트에는 웹훅 관리가 구성되어 있지 않습니다.',
    'st.hub.errLoad': '통합을 불러오지 못했습니다({status})',
    'st.survey.qtype.multiple_choice': '객관식',
    'st.survey.qtype.text': '텍스트 응답',
    'st.survey.qtype.rating': '평가 척도',
    'st.survey.qtype.yes_no': '예/아니요',
    'st.survey.loadFail': '설문을 불러올 수 없습니다',
    'st.survey.loadFailDesc': '다시 시도하거나 문제가 지속되면 관리자에게 문의하세요.',
    'st.survey.missingInfo': '정보 누락',
    'st.survey.missingInfoDesc': '제목과 최소 하나의 질문이 필요합니다.',
    'st.survey.notAllowed': '허용되지 않음',
    'st.survey.notAllowedEdit': '설문은 매니저 또는 관리자만 편집할 수 있습니다.',
    'st.survey.updated': '설문이 업데이트되었습니다',
    'st.survey.updatedDesc': '변경사항이 저장되었습니다.',
    'st.survey.updateFail': '업데이트 실패',
    'st.survey.updateFailDesc': '설문을 저장할 수 없습니다. 다시 시도하세요.',
    'st.survey.notAllowedStatus': '설문 상태는 매니저 또는 관리자만 변경할 수 있습니다.',
    'st.survey.statusFail': '상태를 업데이트할 수 없습니다',
    'st.survey.notAllowedResults': '결과는 매니저 또는 관리자만 볼 수 있습니다.',
    'st.survey.resultsFail': '결과를 불러올 수 없습니다',
    'st.survey.manage': '설문 관리({count})',
    'st.survey.loading': '설문을 불러오는 중…',
    'st.survey.empty': '아직 설문이 없습니다. 위에서 하나를 만들어 시작하세요.',
    'st.survey.qCount': '질문 {count}개',
    'st.survey.responses': '응답 {count}개',
    'st.survey.results': '결과',
    'st.survey.toggleActive': '활성 전환',
    'st.survey.editTitle': '설문 편집',
    'st.survey.editDesc': '설문 세부정보와 질문을 업데이트합니다. 테넌트 범위의 설문 API를 통해 저장됩니다.',
    'st.survey.fTitle': '제목 *',
    'st.survey.fDesc': '설명',
    'st.survey.fType': '유형',
    'st.survey.paid': '유료',
    'st.survey.unpaid': '무료',
    'st.survey.fReward': '보상',
    'st.survey.fDeadline': '마감일',
    'st.survey.questions': '질문({count})',
    'st.survey.addQuestion': '질문 추가',
    'st.survey.questionPh': '질문 내용',
    'st.survey.optionPh': '선택지 {n}',
    'st.survey.addOption': '선택지 추가',
    'st.survey.required': '필수',
    'st.survey.resultsTitle': '설문 결과',
    'st.survey.loadingResults': '결과를 불러오는 중…',
    'st.survey.totalResponses': '총 {count}개의 응답',
    'st.survey.downloadCsv': 'CSV 다운로드',
    'st.survey.average': '평균:',
    'st.survey.noResults': '사용 가능한 결과가 없습니다.',
    'st.voice.loading': '음성 지표를 불러오는 중...',
    'st.voice.loadError': '음성 지표를 불러오지 못했습니다',
    'st.voice.aiCalls': 'AI 통화',
    'st.voice.aiResolved': 'AI 해결',
    'st.voice.ncalls': '통화 {count}건',
    'st.voice.escalationRate': '에스컬레이션 비율',
    'st.voice.avgDuration': '평균 시간',
    'st.voice.perCall': '통화당',
    'st.voice.csat': '음성 CSAT',
    'st.voice.totalAiCalls': '총 AI 통화',
    'st.voice.aiResRate': 'AI 해결률',
    'st.voice.callsResolvedByAi': 'AI가 해결한 통화 {count}건',
    'st.voice.nEscalated': '{count}건 에스컬레이션',
    'st.voice.avgCallDuration': '평균 통화 시간',
    'st.voice.nRatings': '평가 {count}개',
    'st.voice.noRatings': '아직 평가가 없습니다',
    'st.voice.aiHandled': 'AI 처리',
    'st.voice.noHumanTransfer': '담당자 전환 없음',
    'st.voice.pendingCallbacks': '대기 중인 콜백',
    'st.voice.overdueCallbacks': '기한 초과 콜백',
    'st.voice.past5minSla': '5분 SLA 초과',
    'st.voice.avgResTime': '평균 해결 시간',
    'st.voice.operatorAssignments': '오퍼레이터 배정',
    'st.voice.operatorResolutions': '오퍼레이터 해결',
    'st.voice.noData': '아직 음성 통화 데이터가 없습니다. 음성 통화는 처리되면 여기에 표시됩니다.',
    'st.aim.loading': 'AI 지표를 불러오는 중...',
    'st.aim.loadError': 'AI 지표를 불러오지 못했습니다',
    'st.aim.subtitle': 'AI 기반 자동 해결 및 에스컬레이션 지표를 모니터링합니다',
    'st.aim.excellent': '우수',
    'st.aim.good': '양호',
    'st.aim.needsImprovement': '개선 필요',
    'st.aim.totalConversations': '총 대화',
    'st.aim.aiProcessedChats': 'AI가 처리한 채팅',
    'st.aim.autoResRate': '자동 해결률',
    'st.aim.nResolved': '{count}건 해결',
    'st.aim.escalationRate': '에스컬레이션 비율',
    'st.aim.nEscalated': '{count}건 에스컬레이션',
    'st.aim.avgConfidence': '평균 신뢰도',
    'st.aim.intentAccuracy': '의도 정확도',
    'st.aim.languageDistribution': '언어 분포',
    'st.aim.convByLanguage': '언어별 대화',
    'st.aim.noLanguageData': '언어 데이터가 없습니다',
    'st.aim.intentDistribution': '의도 분포',
    'st.aim.customerIntents': 'AI가 식별한 고객 의도',
    'st.aim.noIntentData': '의도 데이터가 없습니다',
    'st.aim.escalationBreakdown': '에스컬레이션 세부 내역',
    'st.aim.escalationByLevel': '수준별 에스컬레이션(Operator → Manager → Admin)',
    'st.aim.aiVoiceAnalytics': 'AI 음성 분석',
    'st.aim.totalVoiceCalls': '총 음성 통화',
    'st.aim.allInboundCalls': '모든 인바운드 통화',
    'st.aim.aiHandled': 'AI 처리',
    'st.aim.noHumanTransfer': '담당자 전환 없음',
    'st.aim.aiResolved': 'AI 해결',
    'st.aim.confirmedResolved': '해결 확인됨',
    'st.aim.humanEscalated': '담당자에게 에스컬레이션',
    'st.aim.escalationRatePct': '에스컬레이션 비율 {rate}%',
    'st.aim.pendingCallbacks': '대기 중인 콜백',
    'st.aim.awaitingCallback': '콜백 대기 중',
    'st.aim.overdueCallbacks': '기한 초과 콜백',
    'st.aim.pastSlaDeadline': 'SLA 기한 초과',
    'st.aim.avgCallDuration': '평균 통화 시간',
    'st.aim.minutesPerCall': '통화당 분',
    'st.aim.avgResTime': '평균 해결 시간',
    'st.aim.createResolve': '생성 → 해결',
    'st.aim.slaBreaches': '콜백 SLA 위반',
    'st.aim.slaBreachesNote': '5분 SLA를 초과한 콜백',
    'st.sbm.untitled': '제목 없는 솔루션',
    'st.sbm.approved': '솔루션 승인됨',
    'st.sbm.approvedDesc': '이제 솔루션을 AI가 재사용할 수 있습니다.',
    'st.sbm.approvalFailed': '승인 실패',
    'st.sbm.rejected': '솔루션 거부됨',
    'st.sbm.rejectedDesc': 'AI가 이 솔루션을 사용하지 않습니다.',
    'st.sbm.rejectionFailed': '거부 실패',
    'st.sbm.missingInfo': '정보 누락',
    'st.sbm.missingInfoDesc': '제목, 설명, 해결 단계를 입력하세요.',
    'st.sbm.noBusiness': '선택된 비즈니스 없음',
    'st.sbm.noBusinessDesc': '제출할 수 없습니다 — 활성 비즈니스 컨텍스트가 없습니다.',
    'st.sbm.updated': '솔루션 업데이트됨',
    'st.sbm.updatedDesc': '변경사항이 성공적으로 저장되었습니다.',
    'st.sbm.submitted': '솔루션 제출됨',
    'st.sbm.submittedDesc': '관리자 승인을 위해 솔루션을 제출했습니다. 상태: pending_approval.',
    'st.sbm.submitFailed': '제출 실패',
    'st.sbm.networkError': '네트워크 오류',
    'st.sbm.confirmDelete': '"{title}"을(를) 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.',
    'st.sbm.deleted': '솔루션 삭제됨',
    'st.sbm.deletedDesc': '솔루션이 영구적으로 제거되었습니다.',
    'st.sbm.deleteFailed': '삭제 실패',
    'st.sbm.title': '솔루션 뱅크 관리',
    'st.sbm.subtitle': '일반적인 문제에 대한 AI 기반 솔루션을 생성하고 관리합니다',
    'st.sbm.editSolution': '솔루션 편집',
    'st.sbm.structure': '솔루션 구조',
    'st.sbm.fTitle': '솔루션 제목 *',
    'st.sbm.fTitlePh': '이 솔루션에 대한 간결하고 설명적인 제목',
    'st.sbm.fDesc': '문제 설명 *',
    'st.sbm.fDescPh': '이 솔루션이 해결하는 문제를 설명하세요',
    'st.sbm.fCategory': '문제 카테고리 *',
    'st.sbm.categoryPh': '문제 카테고리 선택',
    'st.sbm.fType': '문제 유형 *',
    'st.sbm.typePh': '문제 유형 선택',
    'st.sbm.fDifficulty': '난이도 *',
    'st.sbm.difficultyPh': '난이도 선택',
    'st.sbm.diffLow': '낮음 - 간단하고 빠른 해결',
    'st.sbm.diffMedium': '중간 - 보통 복잡도',
    'st.sbm.diffHigh': '높음 - 복잡하고 기술적인 해결',
    'st.sbm.fTags': '태그 *',
    'st.sbm.tagsPh': '쉼표로 구분된 키워드',
    'st.sbm.tagsHelp': '고객이 사용할 수 있는 키워드(예: 로그인, 비밀번호, 재설정)',
    'st.sbm.fResolution': '해결 단계 *',
    'st.sbm.resolutionPh': '각 단계를 새 줄에 입력하세요:\n1단계: 로그인 페이지로 이동\n2단계: 비밀번호 찾기 클릭\n3단계: 이메일 주소 입력\n기타...',
    'st.sbm.resolutionHelp': '명확한 단계별 지침을 작성하세요. 각 단계는 새 줄에 있어야 합니다.',
    'st.sbm.updateSolution': '솔루션 업데이트',
    'st.sbm.addSolution': '솔루션 추가',
    'st.sbm.pendingApprovals': '대기 중인 승인',
    'st.sbm.nPending': '{count}건 대기 중',
    'st.sbm.uncategorized': '분류되지 않음',
    'st.sbm.submittedOn': '{date}에 제출됨',
    'st.sbm.noSolutions': '생성된 솔루션 없음',
    'st.sbm.noSolutionsDesc': '첫 번째 솔루션을 추가하여 지식 베이스 구축을 시작하세요',
    'st.sbm.addFirst': '첫 솔루션 추가',
    'st.sbm.successRate': '성공률 {rate}%',
    'st.sbm.uses': '{count}회 사용',
    'st.sbm.keywords': '키워드',
    'st.sbm.resolutionSteps': '해결 단계',
    'st.sbm.lastUpdated': '마지막 업데이트: {date}',
    'st.sbm.addedBy': '추가한 사람: {name}',
    'st.sbm.unknown': '알 수 없음',
    'st.conf.tapEnableAudio': '탭하여 오디오 활성화',
    'st.conf.inviting': '초대하는 중…',
    'st.conf.noAnswer': '응답 없음',
    'st.conf.declined': '거절됨',
    'st.conf.reconnecting': '다시 연결하는 중…',
    'st.conf.lost': '연결 끊김',
    'st.conf.connected': '연결됨',
    'st.conf.noAudio': '오디오 없음',
    'st.conf.connectingAudio': '오디오를 연결하는 중…',
    'st.conf.connecting': '연결하는 중…',
    'st.conf.audioConference': '음성 회의',
    'st.conf.invitingYou': '{host}님이 음성 회의에 초대했습니다.',
    'st.conf.decline': '거절',
    'st.conf.accept': '수락',
    'st.conf.host': '호스트',
    'st.conf.participant': '참가자',
    'st.conf.you': '나',
    'st.conf.muted': '(음소거)',
    'st.conf.unmute': '음소거 해제',
    'st.conf.mute': '음소거',
    'st.conf.noOneYet': '아직 아무도 없습니다 — 아래에서 팀원을 초대하세요.',
    'st.conf.removeFromConf': '회의에서 제거',
    'st.conf.addTeammate': '+ 온라인 팀원 추가…',
    'st.conf.noStaffOnline': '현재 추가할 수 있는 온라인 직원이 없습니다.',
    'st.conf.endConference': '회의 종료',
    'st.conf.leave': '나가기',
    'st.call.userFallback': '사용자 {id}',
    'st.call.shareVideoOnlyMsg': '화면 공유는 영상 통화에서 사용할 수 있습니다.',
    'st.call.shareCouldNotStart': '화면 공유를 시작할 수 없습니다.',
    'st.call.onHold': '보류 중 • {dur}',
    'st.call.connected': '연결됨 • {dur}',
    'st.call.connecting': '연결하는 중...',
    'st.call.video': '영상',
    'st.call.tapEnableCallAudio': '🔊 탭하여 통화 오디오 활성화',
    'st.call.callDuration': '통화 시간: {dur}',
    'st.call.resume': '통화 재개',
    'st.call.hold': '통화 보류',
    'st.call.sharingScreen': '화면 공유 중',
    'st.call.shareScreen': '화면 공유',
    'st.call.shareVideoOnly': '화면 공유는 영상 통화에서 사용할 수 있습니다',
    'st.call.endCall': '통화 종료',
    'st.call.callVolume': '통화 음량',
    'st.trial.errResolveTenant': '테넌트를 확인할 수 없습니다',
    'st.trial.errPortalUnavailable': '포털을 사용할 수 없습니다',
    'st.trial.stripeFail': 'Stripe 포털을 열 수 없습니다',
    'st.trial.stripeFailDesc': '{message}. 청구 페이지로 리디렉션합니다.',
    'st.trial.frozenHeadline': '구독이 일시 중지되었습니다 — 계정이 읽기 전용 모드입니다',
    'st.trial.frozenSub': '지금 재활성화하여 새 티켓, 대화, 팀 관리를 잠금 해제하세요.',
    'st.trial.reactivate': '재활성화',
    'st.trial.nDays': '{count}일',
    'st.trial.nHours': '{count}시간',
    'st.trial.nHour': '{count}시간',
    'st.trial.pastDueHeadline': '결제 실패 — {remainder} 전에 카드를 업데이트하세요',
    'st.trial.pastDueSub': '자동으로 다시 시도합니다({max}회 중 {attempt}회). 유예 기간 동안 계정은 활성 상태로 유지됩니다.',
    'st.trial.openingStripe': 'Stripe를 여는 중…',
    'st.trial.updatePayment': '결제 수단 업데이트',
    'st.trial.expiredHeadline': '체험이 종료되었습니다',
    'st.trial.expiredSub': '지금 업그레이드하여 팀과 고객의 연결을 유지하세요.',
    'st.trial.upgradeNow': '지금 업그레이드',
    'st.trial.urgentHeadlineOne': '체험이 {count}시간 남았습니다',
    'st.trial.urgentHeadline': '체험이 {count}시간 남았습니다',
    'st.trial.soonSub': '지금 요금제를 선택하여 체험 종료 후에도 모든 기능과 데이터를 유지하세요.',
    'st.trial.soonHeadline': '체험이 {count}일 남았습니다',
    'st.trial.dismiss': '닫기',
  },
  zh: {
    'st.active': '已启用',
    'st.inactive': '未启用',
    'st.enabled': '已开启',
    'st.disabled': '已关闭',
    'st.integrations': '集成',
    'st.saveChanges': '保存更改',
    'st.savingEllipsis': '正在保存…',
    'st.settings.loading': '正在加载设置…',
    'st.settings.unavailable': '工作区设置暂时不可用。请重试。',
    'st.settings.noWorkspace': '您的账户尚未关联到工作区，因此无法加载设置。如有意外，请联系您的管理员。',
    'st.settings.manageWorkspace': '管理您的工作区',
    'st.settings.reset': '重置',
    'st.settings.tab.general': '通用',
    'st.settings.tab.notifications': '通知',
    'st.settings.tab.ai': 'AI 设置',
    'st.settings.tab.security': '安全',
    'st.settings.tab.users': '用户管理',
    'st.settings.displayName': '工作区显示名称',
    'st.settings.timezone': '工作区时区',
    'st.settings.timezonePh': '例如 America/New_York',
    'st.settings.aiDefaultLang': 'AI 默认语言',
    'st.settings.aiLangHelp': '当无法检测到客户语言时 AI 回复所用的语言。不会更改网页界面语言。',
    'st.settings.archiveDays': 'N 天后归档记录（0 = 全部保留）',
    'st.settings.archiveHelp': '软归档旧对话/工单（绝不永久删除）。仅在管理员启用时才会执行。',
    'st.settings.callRecording': '通话音频录制',
    'st.settings.callRecordingDesc': '录制外呼、转接和电话会议的音频。',
    'st.settings.callRecordingNote': 'AI 助手的来电会生成用于服务背景、升级和创建工单所需的运营记录（始终保留，与音频录制分开）。',
    'st.settings.emailNotif': '电子邮件通知',
    'st.settings.emailNotifDesc': '向客户发送的运营跟进邮件',
    'st.settings.smsNotif': '短信通知',
    'st.settings.smsNotifDesc': '向客户发送的运营跟进短信（可能会产生运营商费用）',
    'st.settings.transactionalNote': '事务性消息（OTP、邀请、账单、安全）始终发送，不受这些偏好设置的影响。',
    'st.settings.aiAutoRes': 'AI 自动解决',
    'st.settings.aiAutoResDesc': '关闭时，AI 将升级至人工处理，而非自动解决。',
    'st.settings.saveAi': '保存 AI 设置',
    'st.settings.manageAutoRules': '管理自动解决规则和阈值',
    'st.settings.securityCompliance': '安全与合规',
    'st.settings.auditLogging': '审计日志',
    'st.settings.auditActive': '已启用（{count} 个事件）',
    'st.settings.auditNone': '没有记录的活动',
    'st.settings.compliance': '合规证明',
    'st.settings.notPublished': '未发布',
    'st.settings.manageTeam': '管理团队成员和角色。',
    'st.settings.manageUsers': '管理用户',
    'st.settings.teamMembers': '团队成员',
    'st.settings.inviteReview': '邀请员工并查看您的团队。',
    'st.settings.addUser': '添加用户',
    'st.settings.inviteStaffMember': '邀请员工',
    'st.settings.onboardingEmail': '将发送一封入职邮件。',
    'st.settings.email': '电子邮件',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': '角色',
    'st.settings.sending': '正在发送…',
    'st.settings.sendInvite': '发送邀请',
    'st.settings.noTeamMembers': '未找到团队成员',
    'st.settings.staffRole': '员工',
    'st.settings.toast.saved': '设置已保存',
    'st.settings.toast.savedDesc': '工作区设置已更新。',
    'st.settings.toast.saveFailed': '保存失败',
    'st.settings.toast.aiSaved': 'AI 设置已保存',
    'st.settings.toast.aiSavedDesc': '自动解决偏好已更新。',
    'st.settings.toast.invalidEmail': '电子邮件无效',
    'st.settings.toast.invalidEmailDesc': '请输入有效的电子邮件地址。',
    'st.settings.toast.inviteSent': '邀请已发送',
    'st.settings.toast.inviteSentDesc': '邀请已发送至 {email}。',
    'st.settings.toast.inviteFailed': '邀请失败',
    'st.settings.inviteNotSent': '邀请未发送',
    'st.settings.errLoadSettings': '加载设置失败（{status}）',
    'st.settings.errSaveFailed': '保存失败（{status}）',
    'st.settings.errInviteFailed': '邀请失败（{status}）',
    'st.integ.planBadge': '{tier} 套餐',
    'st.integ.desc': '连接渠道、CRM、监控和自动化。您的套餐可用 {allowed}/{total} 个。',
    'st.integ.unlimited': '无限量活动集成。',
    'st.integ.upTo': '最多 {cap} 个活动（{enabled}/{cap}）。',
    'st.integ.notRegistered': '未注册',
    'st.integ.notRegisteredDesc': '配置集成前请先完成订阅。',
    'st.integ.saved': '已保存',
    'st.integ.savedDesc': '{name} 已更新。',
    'st.integ.saveFailed': '保存失败',
    'st.integ.upgrade': '升级',
    'st.integ.configured': '已配置',
    'st.integ.needsCreds': '需要凭据',
    'st.integ.available': '可配置',
    'st.integ.enable': '启用 {name}',
    'st.integ.noExecNote': '保存会安全存储您的配置。此连接器尚未启用实时工作流执行。',
    'st.integ.higherPlan': '需更高套餐方可使用。请在账单中升级以启用 {name}。',
    'st.hub.subtitle': '您租户的连接器',
    'st.hub.planTag': '{tier} 套餐',
    'st.hub.refreshStatus': '刷新状态',
    'st.hub.exportData': '导出数据',
    'st.hub.addIntegration': '添加集成',
    'st.hub.scopeNote': '仅显示租户范围的集成。平台基础设施和平台级治理由 Servisfy 管理，此处不显示。',
    'st.hub.none': '此租户未配置任何集成。',
    'st.hub.configureInSettings': '在设置 → 集成中配置',
    'st.hub.connectorNote': '租户连接器。凭据已安全管理，此处不显示。',
    'st.hub.syncNote': '此连接器尚不支持同步和连接器测试。',
    'st.hub.configure': '配置',
    'st.hub.webhooks': 'Webhook',
    'st.hub.webhooksNote': '此租户未配置 Webhook 管理。',
    'st.hub.errLoad': '加载集成失败（{status}）',
    'st.survey.qtype.multiple_choice': '多项选择',
    'st.survey.qtype.text': '文本回答',
    'st.survey.qtype.rating': '评分量表',
    'st.survey.qtype.yes_no': '是/否',
    'st.survey.loadFail': '无法加载问卷',
    'st.survey.loadFailDesc': '请重试，如问题持续存在，请联系您的管理员。',
    'st.survey.missingInfo': '信息缺失',
    'st.survey.missingInfoDesc': '需要标题和至少一个问题。',
    'st.survey.notAllowed': '不允许',
    'st.survey.notAllowedEdit': '只有经理或管理员才能编辑问卷。',
    'st.survey.updated': '问卷已更新',
    'st.survey.updatedDesc': '您的更改已保存。',
    'st.survey.updateFail': '更新失败',
    'st.survey.updateFailDesc': '无法保存问卷。请重试。',
    'st.survey.notAllowedStatus': '只有经理或管理员才能更改问卷状态。',
    'st.survey.statusFail': '无法更新状态',
    'st.survey.notAllowedResults': '只有经理或管理员才能查看结果。',
    'st.survey.resultsFail': '无法加载结果',
    'st.survey.manage': '管理问卷（{count}）',
    'st.survey.loading': '正在加载问卷…',
    'st.survey.empty': '暂无问卷。在上方创建一个即可开始。',
    'st.survey.qCount': '{count} 题',
    'st.survey.responses': '{count} 份回复',
    'st.survey.results': '结果',
    'st.survey.toggleActive': '切换启用状态',
    'st.survey.editTitle': '编辑问卷',
    'st.survey.editDesc': '更新问卷详情和问题。通过租户范围的问卷 API 保存。',
    'st.survey.fTitle': '标题 *',
    'st.survey.fDesc': '描述',
    'st.survey.fType': '类型',
    'st.survey.paid': '有偿',
    'st.survey.unpaid': '无偿',
    'st.survey.fReward': '奖励',
    'st.survey.fDeadline': '截止日期',
    'st.survey.questions': '问题（{count}）',
    'st.survey.addQuestion': '添加问题',
    'st.survey.questionPh': '问题内容',
    'st.survey.optionPh': '选项 {n}',
    'st.survey.addOption': '添加选项',
    'st.survey.required': '必填',
    'st.survey.resultsTitle': '问卷结果',
    'st.survey.loadingResults': '正在加载结果…',
    'st.survey.totalResponses': '共 {count} 份回复',
    'st.survey.downloadCsv': '下载 CSV',
    'st.survey.average': '平均：',
    'st.survey.noResults': '暂无可用结果。',
    'st.voice.loading': '正在加载语音指标...',
    'st.voice.loadError': '加载语音指标失败',
    'st.voice.aiCalls': 'AI 通话',
    'st.voice.aiResolved': 'AI 已解决',
    'st.voice.ncalls': '{count} 次通话',
    'st.voice.escalationRate': '升级率',
    'st.voice.avgDuration': '平均时长',
    'st.voice.perCall': '每次通话',
    'st.voice.csat': '语音 CSAT',
    'st.voice.totalAiCalls': 'AI 通话总数',
    'st.voice.aiResRate': 'AI 解决率',
    'st.voice.callsResolvedByAi': 'AI 解决的通话 {count} 次',
    'st.voice.nEscalated': '{count} 次升级',
    'st.voice.avgCallDuration': '平均通话时长',
    'st.voice.nRatings': '{count} 个评分',
    'st.voice.noRatings': '暂无评分',
    'st.voice.aiHandled': 'AI 处理',
    'st.voice.noHumanTransfer': '无人工转接',
    'st.voice.pendingCallbacks': '待处理回拨',
    'st.voice.overdueCallbacks': '逾期回拨',
    'st.voice.past5minSla': '超过 5 分钟 SLA',
    'st.voice.avgResTime': '平均解决时间',
    'st.voice.operatorAssignments': '话务员分派',
    'st.voice.operatorResolutions': '话务员解决',
    'st.voice.noData': '暂无语音通话数据。语音通话在处理后将显示在此处。',
    'st.aim.loading': '正在加载 AI 指标...',
    'st.aim.loadError': '加载 AI 指标失败',
    'st.aim.subtitle': '监控由 AI 驱动的自动解决和升级指标',
    'st.aim.excellent': '优秀',
    'st.aim.good': '良好',
    'st.aim.needsImprovement': '有待改进',
    'st.aim.totalConversations': '对话总数',
    'st.aim.aiProcessedChats': 'AI 处理的聊天',
    'st.aim.autoResRate': '自动解决率',
    'st.aim.nResolved': '{count} 个已解决',
    'st.aim.escalationRate': '升级率',
    'st.aim.nEscalated': '{count} 个已升级',
    'st.aim.avgConfidence': '平均置信度',
    'st.aim.intentAccuracy': '意图准确度',
    'st.aim.languageDistribution': '语言分布',
    'st.aim.convByLanguage': '按语言划分的对话',
    'st.aim.noLanguageData': '无可用语言数据',
    'st.aim.intentDistribution': '意图分布',
    'st.aim.customerIntents': 'AI 识别的客户意图',
    'st.aim.noIntentData': '无可用意图数据',
    'st.aim.escalationBreakdown': '升级明细',
    'st.aim.escalationByLevel': '按级别的升级（Operator → Manager → Admin）',
    'st.aim.aiVoiceAnalytics': 'AI 语音分析',
    'st.aim.totalVoiceCalls': '语音通话总数',
    'st.aim.allInboundCalls': '所有来电',
    'st.aim.aiHandled': 'AI 处理',
    'st.aim.noHumanTransfer': '无人工转接',
    'st.aim.aiResolved': 'AI 已解决',
    'st.aim.confirmedResolved': '已确认解决',
    'st.aim.humanEscalated': '已升级至人工',
    'st.aim.escalationRatePct': '升级率 {rate}%',
    'st.aim.pendingCallbacks': '待处理回拨',
    'st.aim.awaitingCallback': '等待回拨',
    'st.aim.overdueCallbacks': '逾期回拨',
    'st.aim.pastSlaDeadline': '超过 SLA 期限',
    'st.aim.avgCallDuration': '平均通话时长',
    'st.aim.minutesPerCall': '每次通话分钟数',
    'st.aim.avgResTime': '平均解决时间',
    'st.aim.createResolve': '创建 → 解决',
    'st.aim.slaBreaches': '回拨 SLA 违规',
    'st.aim.slaBreachesNote': '超过 5 分钟 SLA 的回拨',
    'st.sbm.untitled': '无标题解决方案',
    'st.sbm.approved': '解决方案已批准',
    'st.sbm.approvedDesc': '解决方案现已可供 AI 重复使用。',
    'st.sbm.approvalFailed': '批准失败',
    'st.sbm.rejected': '解决方案已拒绝',
    'st.sbm.rejectedDesc': 'AI 将不会使用该解决方案。',
    'st.sbm.rejectionFailed': '拒绝失败',
    'st.sbm.missingInfo': '信息缺失',
    'st.sbm.missingInfoDesc': '请填写标题、描述和解决步骤。',
    'st.sbm.noBusiness': '未选择商家',
    'st.sbm.noBusinessDesc': '无法提交——没有活动的商家上下文。',
    'st.sbm.updated': '解决方案已更新',
    'st.sbm.updatedDesc': '更改已成功保存。',
    'st.sbm.submitted': '解决方案已提交',
    'st.sbm.submittedDesc': '解决方案已提交管理层批准。状态：pending_approval。',
    'st.sbm.submitFailed': '提交失败',
    'st.sbm.networkError': '网络错误',
    'st.sbm.confirmDelete': '删除"{title}"？此操作无法撤销。',
    'st.sbm.deleted': '解决方案已删除',
    'st.sbm.deletedDesc': '解决方案已永久移除。',
    'st.sbm.deleteFailed': '删除失败',
    'st.sbm.title': '解决方案库管理',
    'st.sbm.subtitle': '为常见问题创建和管理由 AI 驱动的解决方案',
    'st.sbm.editSolution': '编辑解决方案',
    'st.sbm.structure': '解决方案结构',
    'st.sbm.fTitle': '解决方案标题 *',
    'st.sbm.fTitlePh': '此解决方案的简明描述性标题',
    'st.sbm.fDesc': '问题描述 *',
    'st.sbm.fDescPh': '描述此解决方案所针对的问题',
    'st.sbm.fCategory': '问题类别 *',
    'st.sbm.categoryPh': '选择问题类别',
    'st.sbm.fType': '问题类型 *',
    'st.sbm.typePh': '选择问题类型',
    'st.sbm.fDifficulty': '难度级别 *',
    'st.sbm.difficultyPh': '选择难度级别',
    'st.sbm.diffLow': '低 - 简单快速的解决方案',
    'st.sbm.diffMedium': '中 - 中等复杂度',
    'st.sbm.diffHigh': '高 - 复杂的技术解决方案',
    'st.sbm.fTags': '标签 *',
    'st.sbm.tagsPh': '以逗号分隔的关键词',
    'st.sbm.tagsHelp': '客户可能使用的关键词（例如：登录、密码、重置）',
    'st.sbm.fResolution': '解决步骤 *',
    'st.sbm.resolutionPh': '每个步骤另起一行输入：\n步骤 1：转到登录页面\n步骤 2：点击忘记密码\n步骤 3：输入电子邮件地址\n等等...',
    'st.sbm.resolutionHelp': '编写清晰的分步说明。每个步骤应另起一行。',
    'st.sbm.updateSolution': '更新解决方案',
    'st.sbm.addSolution': '添加解决方案',
    'st.sbm.pendingApprovals': '待批准',
    'st.sbm.nPending': '{count} 个待处理',
    'st.sbm.uncategorized': '未分类',
    'st.sbm.submittedOn': '提交于 {date}',
    'st.sbm.noSolutions': '尚未创建解决方案',
    'st.sbm.noSolutionsDesc': '添加您的第一个解决方案，开始构建您的知识库',
    'st.sbm.addFirst': '添加第一个解决方案',
    'st.sbm.successRate': '成功率 {rate}%',
    'st.sbm.uses': '{count} 次使用',
    'st.sbm.keywords': '关键词',
    'st.sbm.resolutionSteps': '解决步骤',
    'st.sbm.lastUpdated': '上次更新：{date}',
    'st.sbm.addedBy': '添加者：{name}',
    'st.sbm.unknown': '未知',
    'st.conf.tapEnableAudio': '点按以启用音频',
    'st.conf.inviting': '正在邀请…',
    'st.conf.noAnswer': '无应答',
    'st.conf.declined': '已拒绝',
    'st.conf.reconnecting': '正在重新连接…',
    'st.conf.lost': '已断开',
    'st.conf.connected': '已连接',
    'st.conf.noAudio': '无音频',
    'st.conf.connectingAudio': '正在连接音频…',
    'st.conf.connecting': '正在连接…',
    'st.conf.audioConference': '音频会议',
    'st.conf.invitingYou': '{host} 邀请您参加音频会议。',
    'st.conf.decline': '拒绝',
    'st.conf.accept': '接受',
    'st.conf.host': '主持人',
    'st.conf.participant': '参与者',
    'st.conf.you': '您',
    'st.conf.muted': '（已静音）',
    'st.conf.unmute': '取消静音',
    'st.conf.mute': '静音',
    'st.conf.noOneYet': '暂时还没有其他人——在下方邀请队友。',
    'st.conf.removeFromConf': '从会议中移除',
    'st.conf.addTeammate': '+ 添加在线队友…',
    'st.conf.noStaffOnline': '当前没有其他在线员工可添加。',
    'st.conf.endConference': '结束会议',
    'st.conf.leave': '离开',
    'st.call.userFallback': '用户 {id}',
    'st.call.shareVideoOnlyMsg': '屏幕共享在视频通话中可用。',
    'st.call.shareCouldNotStart': '无法开始屏幕共享。',
    'st.call.onHold': '保持中 • {dur}',
    'st.call.connected': '已连接 • {dur}',
    'st.call.connecting': '正在连接...',
    'st.call.video': '视频',
    'st.call.tapEnableCallAudio': '🔊 点按以启用通话音频',
    'st.call.callDuration': '通话时长：{dur}',
    'st.call.resume': '恢复通话',
    'st.call.hold': '保持通话',
    'st.call.sharingScreen': '正在共享屏幕',
    'st.call.shareScreen': '共享屏幕',
    'st.call.shareVideoOnly': '屏幕共享在视频通话中可用',
    'st.call.endCall': '结束通话',
    'st.call.callVolume': '通话音量',
    'st.trial.errResolveTenant': '无法解析租户',
    'st.trial.errPortalUnavailable': '门户不可用',
    'st.trial.stripeFail': '无法打开 Stripe 门户',
    'st.trial.stripeFailDesc': '{message}。正在重定向到账单页面。',
    'st.trial.frozenHeadline': '您的订阅已暂停——账户处于只读模式',
    'st.trial.frozenSub': '立即重新激活，以解锁新工单、对话和团队管理。',
    'st.trial.reactivate': '重新激活',
    'st.trial.nDays': '{count} 天',
    'st.trial.nHours': '{count} 小时',
    'st.trial.nHour': '{count} 小时',
    'st.trial.pastDueHeadline': '付款失败——请在 {remainder} 前更新您的卡片',
    'st.trial.pastDueSub': '我们将自动重试（第 {attempt} 次，共 {max} 次）。在宽限期内您的账户保持活动状态。',
    'st.trial.openingStripe': '正在打开 Stripe…',
    'st.trial.updatePayment': '更新付款方式',
    'st.trial.expiredHeadline': '您的试用已结束',
    'st.trial.expiredSub': '立即升级，让您的团队和客户保持连接。',
    'st.trial.upgradeNow': '立即升级',
    'st.trial.urgentHeadlineOne': '您的试用仅剩 {count} 小时',
    'st.trial.urgentHeadline': '您的试用仅剩 {count} 小时',
    'st.trial.soonSub': '立即选择套餐，在试用结束后保留所有功能和数据。',
    'st.trial.soonHeadline': '您的试用还剩 {count} 天',
    'st.trial.dismiss': '关闭',
  },
  ar: {
    'st.active': 'نشط',
    'st.inactive': 'غير نشط',
    'st.enabled': 'مُفعّل',
    'st.disabled': 'مُعطّل',
    'st.integrations': 'عمليات التكامل',
    'st.saveChanges': 'حفظ التغييرات',
    'st.savingEllipsis': 'جارٍ الحفظ…',
    'st.settings.loading': 'جارٍ تحميل الإعدادات…',
    'st.settings.unavailable': 'إعدادات مساحة العمل غير متاحة مؤقتًا. يُرجى المحاولة مرة أخرى.',
    'st.settings.noWorkspace': 'حسابك غير مرتبط بمساحة عمل بعد، لذا يتعذّر تحميل الإعدادات. تواصل مع المسؤول إذا كان هذا غير متوقّع.',
    'st.settings.manageWorkspace': 'إدارة مساحة العمل',
    'st.settings.reset': 'إعادة تعيين',
    'st.settings.tab.general': 'عام',
    'st.settings.tab.notifications': 'الإشعارات',
    'st.settings.tab.ai': 'إعدادات الذكاء الاصطناعي',
    'st.settings.tab.security': 'الأمان',
    'st.settings.tab.users': 'إدارة المستخدمين',
    'st.settings.displayName': 'الاسم المعروض لمساحة العمل',
    'st.settings.timezone': 'المنطقة الزمنية لمساحة العمل',
    'st.settings.timezonePh': 'مثال America/New_York',
    'st.settings.aiDefaultLang': 'اللغة الافتراضية للذكاء الاصطناعي',
    'st.settings.aiLangHelp': 'اللغة التي يرد بها الذكاء الاصطناعي عندما يتعذّر اكتشاف لغة العميل. لا تُغيّر لغة واجهة الويب.',
    'st.settings.archiveDays': 'أرشفة السجلات بعد N يومًا (0 = الاحتفاظ بالكل)',
    'st.settings.archiveHelp': 'يؤرشف المحادثات/التذاكر القديمة أرشفة قابلة للاسترجاع (لا يحذفها نهائيًا أبدًا). يتم التطبيق فقط عند تفعيله من قِبل المسؤول.',
    'st.settings.callRecording': 'تسجيل صوت المكالمات',
    'st.settings.callRecordingDesc': 'يسجّل صوت المكالمات الصادرة والمحوّلة ومكالمات المؤتمر.',
    'st.settings.callRecordingNote': 'تُنشئ المكالمات الواردة عبر مساعد الذكاء الاصطناعي نصوصًا تشغيلية مطلوبة لسياق الخدمة والتصعيد وإنشاء التذاكر (يُحتفظ بها دائمًا، بشكل منفصل عن تسجيل الصوت).',
    'st.settings.emailNotif': 'إشعارات البريد الإلكتروني',
    'st.settings.emailNotifDesc': 'رسائل متابعة تشغيلية بالبريد الإلكتروني إلى العملاء',
    'st.settings.smsNotif': 'إشعارات الرسائل النصية',
    'st.settings.smsNotifDesc': 'رسائل نصية تشغيلية للمتابعة إلى العملاء (قد تُطبّق رسوم المشغّل)',
    'st.settings.transactionalNote': 'تُرسل الرسائل المعاملاتية (OTP، الدعوات، الفوترة، الأمان) دائمًا ولا تتأثر بهذه التفضيلات.',
    'st.settings.aiAutoRes': 'الحل التلقائي بالذكاء الاصطناعي',
    'st.settings.aiAutoResDesc': 'عند الإيقاف، يصعّد الذكاء الاصطناعي إلى موظف بشري بدلًا من الحل التلقائي.',
    'st.settings.saveAi': 'حفظ إعدادات الذكاء الاصطناعي',
    'st.settings.manageAutoRules': 'إدارة قواعد الحل التلقائي وحدوده',
    'st.settings.securityCompliance': 'الأمان والامتثال',
    'st.settings.auditLogging': 'تسجيل التدقيق',
    'st.settings.auditActive': 'نشط ({count} حدثًا)',
    'st.settings.auditNone': 'لا يوجد نشاط مُسجّل',
    'st.settings.compliance': 'شهادات الامتثال',
    'st.settings.notPublished': 'غير منشور',
    'st.settings.manageTeam': 'إدارة أعضاء الفريق والأدوار.',
    'st.settings.manageUsers': 'إدارة المستخدمين',
    'st.settings.teamMembers': 'أعضاء الفريق',
    'st.settings.inviteReview': 'ادعُ الموظفين وراجع فريقك.',
    'st.settings.addUser': 'إضافة مستخدم',
    'st.settings.inviteStaffMember': 'دعوة موظف',
    'st.settings.onboardingEmail': 'سيتم إرسال بريد إلكتروني للانضمام.',
    'st.settings.email': 'البريد الإلكتروني',
    'st.settings.emailPh': 'name@company.com',
    'st.settings.role': 'الدور',
    'st.settings.sending': 'جارٍ الإرسال…',
    'st.settings.sendInvite': 'إرسال الدعوة',
    'st.settings.noTeamMembers': 'لم يتم العثور على أعضاء فريق',
    'st.settings.staffRole': 'موظف',
    'st.settings.toast.saved': 'تم حفظ الإعدادات',
    'st.settings.toast.savedDesc': 'تم تحديث إعدادات مساحة العمل.',
    'st.settings.toast.saveFailed': 'فشل الحفظ',
    'st.settings.toast.aiSaved': 'تم حفظ إعدادات الذكاء الاصطناعي',
    'st.settings.toast.aiSavedDesc': 'تم تحديث تفضيل الحل التلقائي.',
    'st.settings.toast.invalidEmail': 'بريد إلكتروني غير صالح',
    'st.settings.toast.invalidEmailDesc': 'أدخل عنوان بريد إلكتروني صالحًا.',
    'st.settings.toast.inviteSent': 'تم إرسال الدعوة',
    'st.settings.toast.inviteSentDesc': 'تم إرسال الدعوة إلى {email}.',
    'st.settings.toast.inviteFailed': 'فشلت الدعوة',
    'st.settings.inviteNotSent': 'لم يتم إرسال الدعوة',
    'st.settings.errLoadSettings': 'فشل تحميل الإعدادات ({status})',
    'st.settings.errSaveFailed': 'فشل الحفظ ({status})',
    'st.settings.errInviteFailed': 'فشلت الدعوة ({status})',
    'st.integ.planBadge': 'خطة {tier}',
    'st.integ.desc': 'اربط القنوات وأنظمة CRM والمراقبة والأتمتة. {allowed}/{total} متاحة في خطتك.',
    'st.integ.unlimited': 'عمليات تكامل نشطة غير محدودة.',
    'st.integ.upTo': 'حتى {cap} نشطة ({enabled}/{cap}).',
    'st.integ.notRegistered': 'غير مُسجّل',
    'st.integ.notRegisteredDesc': 'أكمل الاشتراك قبل تكوين عمليات التكامل.',
    'st.integ.saved': 'تم الحفظ',
    'st.integ.savedDesc': 'تم تحديث {name}.',
    'st.integ.saveFailed': 'فشل الحفظ',
    'st.integ.upgrade': 'ترقية',
    'st.integ.configured': 'مُكوَّن',
    'st.integ.needsCreds': 'يتطلب بيانات اعتماد',
    'st.integ.available': 'متاح للتكوين',
    'st.integ.enable': 'تفعيل {name}',
    'st.integ.noExecNote': 'يخزّن الحفظ تكوينك بأمان. لم يتم تفعيل تنفيذ سير العمل المباشر لهذا الموصّل بعد.',
    'st.integ.higherPlan': 'متاح في خطة أعلى. قم بالترقية في الفوترة لتفعيل {name}.',
    'st.hub.subtitle': 'موصّلات مؤسستك',
    'st.hub.planTag': 'خطة {tier}',
    'st.hub.refreshStatus': 'تحديث الحالة',
    'st.hub.exportData': 'تصدير البيانات',
    'st.hub.addIntegration': 'إضافة تكامل',
    'st.hub.scopeNote': 'عمليات التكامل ضمن نطاق المؤسسة فقط. تتم إدارة البنية التحتية للمنصة والحوكمة على مستوى المنصة بواسطة Servisfy ولا تظهر هنا.',
    'st.hub.none': 'لا توجد عمليات تكامل مُكوَّنة لهذه المؤسسة.',
    'st.hub.configureInSettings': 'التكوين في الإعدادات ← عمليات التكامل',
    'st.hub.connectorNote': 'موصّل المؤسسة. تُدار بيانات الاعتماد بأمان ولا تظهر هنا.',
    'st.hub.syncNote': 'المزامنة واختبار الموصّل غير متاحين لهذا الموصّل بعد.',
    'st.hub.configure': 'تكوين',
    'st.hub.webhooks': 'الويب هوك',
    'st.hub.webhooksNote': 'إدارة الويب هوك غير مُكوَّنة لهذه المؤسسة.',
    'st.hub.errLoad': 'فشل تحميل عمليات التكامل ({status})',
    'st.survey.qtype.multiple_choice': 'اختيار متعدد',
    'st.survey.qtype.text': 'إجابة نصية',
    'st.survey.qtype.rating': 'مقياس تقييم',
    'st.survey.qtype.yes_no': 'نعم/لا',
    'st.survey.loadFail': 'تعذّر تحميل الاستبيانات',
    'st.survey.loadFailDesc': 'يُرجى المحاولة مرة أخرى، أو تواصل مع المسؤول إذا استمرت المشكلة.',
    'st.survey.missingInfo': 'معلومات ناقصة',
    'st.survey.missingInfoDesc': 'يلزم عنوان وسؤال واحد على الأقل.',
    'st.survey.notAllowed': 'غير مسموح',
    'st.survey.notAllowedEdit': 'يمكن فقط للمدير أو المسؤول تعديل الاستبيانات.',
    'st.survey.updated': 'تم تحديث الاستبيان',
    'st.survey.updatedDesc': 'تم حفظ تغييراتك.',
    'st.survey.updateFail': 'فشل التحديث',
    'st.survey.updateFailDesc': 'تعذّر حفظ الاستبيان. يُرجى المحاولة مرة أخرى.',
    'st.survey.notAllowedStatus': 'يمكن فقط للمدير أو المسؤول تغيير حالة الاستبيان.',
    'st.survey.statusFail': 'تعذّر تحديث الحالة',
    'st.survey.notAllowedResults': 'يمكن فقط للمدير أو المسؤول عرض النتائج.',
    'st.survey.resultsFail': 'تعذّر تحميل النتائج',
    'st.survey.manage': 'إدارة الاستبيانات ({count})',
    'st.survey.loading': 'جارٍ تحميل الاستبيانات…',
    'st.survey.empty': 'لا توجد استبيانات بعد. أنشئ واحدًا أعلاه للبدء.',
    'st.survey.qCount': '{count} سؤال',
    'st.survey.responses': '{count} رد',
    'st.survey.results': 'النتائج',
    'st.survey.toggleActive': 'تبديل التفعيل',
    'st.survey.editTitle': 'تعديل الاستبيان',
    'st.survey.editDesc': 'حدّث تفاصيل الاستبيان وأسئلته. يُحفظ عبر واجهة برمجة الاستبيانات ضمن نطاق المؤسسة.',
    'st.survey.fTitle': 'العنوان *',
    'st.survey.fDesc': 'الوصف',
    'st.survey.fType': 'النوع',
    'st.survey.paid': 'مدفوع',
    'st.survey.unpaid': 'غير مدفوع',
    'st.survey.fReward': 'المكافأة',
    'st.survey.fDeadline': 'الموعد النهائي',
    'st.survey.questions': 'الأسئلة ({count})',
    'st.survey.addQuestion': 'إضافة سؤال',
    'st.survey.questionPh': 'نص السؤال',
    'st.survey.optionPh': 'الخيار {n}',
    'st.survey.addOption': 'إضافة خيار',
    'st.survey.required': 'إلزامي',
    'st.survey.resultsTitle': 'نتائج الاستبيان',
    'st.survey.loadingResults': 'جارٍ تحميل النتائج…',
    'st.survey.totalResponses': '{count} رد إجمالًا',
    'st.survey.downloadCsv': 'تنزيل CSV',
    'st.survey.average': 'المتوسط:',
    'st.survey.noResults': 'لا توجد نتائج متاحة.',
    'st.voice.loading': 'جارٍ تحميل مقاييس الصوت...',
    'st.voice.loadError': 'فشل تحميل مقاييس الصوت',
    'st.voice.aiCalls': 'مكالمات الذكاء الاصطناعي',
    'st.voice.aiResolved': 'حلّها الذكاء الاصطناعي',
    'st.voice.ncalls': '{count} مكالمة',
    'st.voice.escalationRate': 'معدل التصعيد',
    'st.voice.avgDuration': 'متوسط المدة',
    'st.voice.perCall': 'لكل مكالمة',
    'st.voice.csat': 'CSAT الصوتي',
    'st.voice.totalAiCalls': 'إجمالي مكالمات الذكاء الاصطناعي',
    'st.voice.aiResRate': 'معدل الحل بالذكاء الاصطناعي',
    'st.voice.callsResolvedByAi': '{count} مكالمة حلّها الذكاء الاصطناعي',
    'st.voice.nEscalated': '{count} مُصعّدة',
    'st.voice.avgCallDuration': 'متوسط مدة المكالمة',
    'st.voice.nRatings': '{count} تقييم',
    'st.voice.noRatings': 'لا توجد تقييمات بعد',
    'st.voice.aiHandled': 'عالجها الذكاء الاصطناعي',
    'st.voice.noHumanTransfer': 'لا يوجد تحويل بشري',
    'st.voice.pendingCallbacks': 'معاودات الاتصال المعلّقة',
    'st.voice.overdueCallbacks': 'معاودات الاتصال المتأخرة',
    'st.voice.past5minSla': 'تجاوز SLA لمدة 5 دقائق',
    'st.voice.avgResTime': 'متوسط وقت الحل',
    'st.voice.operatorAssignments': 'تعيينات المشغّل',
    'st.voice.operatorResolutions': 'حلول المشغّل',
    'st.voice.noData': 'لا توجد بيانات مكالمات صوتية بعد. ستظهر المكالمات الصوتية هنا بمجرد معالجتها.',
    'st.aim.loading': 'جارٍ تحميل مقاييس الذكاء الاصطناعي...',
    'st.aim.loadError': 'فشل تحميل مقاييس الذكاء الاصطناعي',
    'st.aim.subtitle': 'راقب مقاييس الحل التلقائي والتصعيد المدعومة بالذكاء الاصطناعي',
    'st.aim.excellent': 'ممتاز',
    'st.aim.good': 'جيد',
    'st.aim.needsImprovement': 'يحتاج إلى تحسين',
    'st.aim.totalConversations': 'إجمالي المحادثات',
    'st.aim.aiProcessedChats': 'محادثات عالجها الذكاء الاصطناعي',
    'st.aim.autoResRate': 'معدل الحل التلقائي',
    'st.aim.nResolved': '{count} مُحلّة',
    'st.aim.escalationRate': 'معدل التصعيد',
    'st.aim.nEscalated': '{count} مُصعّدة',
    'st.aim.avgConfidence': 'متوسط الثقة',
    'st.aim.intentAccuracy': 'دقة النية',
    'st.aim.languageDistribution': 'توزيع اللغات',
    'st.aim.convByLanguage': 'المحادثات حسب اللغة',
    'st.aim.noLanguageData': 'لا توجد بيانات لغة متاحة',
    'st.aim.intentDistribution': 'توزيع النوايا',
    'st.aim.customerIntents': 'نوايا العملاء التي حدّدها الذكاء الاصطناعي',
    'st.aim.noIntentData': 'لا توجد بيانات نية متاحة',
    'st.aim.escalationBreakdown': 'تفصيل التصعيد',
    'st.aim.escalationByLevel': 'التصعيدات حسب المستوى (Operator → Manager → Admin)',
    'st.aim.aiVoiceAnalytics': 'تحليلات الصوت بالذكاء الاصطناعي',
    'st.aim.totalVoiceCalls': 'إجمالي المكالمات الصوتية',
    'st.aim.allInboundCalls': 'جميع المكالمات الواردة',
    'st.aim.aiHandled': 'عالجها الذكاء الاصطناعي',
    'st.aim.noHumanTransfer': 'لا يوجد تحويل بشري',
    'st.aim.aiResolved': 'حلّها الذكاء الاصطناعي',
    'st.aim.confirmedResolved': 'تم تأكيد الحل',
    'st.aim.humanEscalated': 'صُعّدت إلى موظف بشري',
    'st.aim.escalationRatePct': 'معدل تصعيد {rate}%',
    'st.aim.pendingCallbacks': 'معاودات الاتصال المعلّقة',
    'st.aim.awaitingCallback': 'في انتظار معاودة الاتصال',
    'st.aim.overdueCallbacks': 'معاودات الاتصال المتأخرة',
    'st.aim.pastSlaDeadline': 'تجاوز الموعد النهائي لـ SLA',
    'st.aim.avgCallDuration': 'متوسط مدة المكالمة',
    'st.aim.minutesPerCall': 'دقائق لكل مكالمة',
    'st.aim.avgResTime': 'متوسط وقت الحل',
    'st.aim.createResolve': 'إنشاء ← حل',
    'st.aim.slaBreaches': 'خروقات SLA لمعاودة الاتصال',
    'st.aim.slaBreachesNote': 'معاودات الاتصال التي تجاوزت SLA البالغ 5 دقائق',
    'st.sbm.untitled': 'حل بدون عنوان',
    'st.sbm.approved': 'تمت الموافقة على الحل',
    'st.sbm.approvedDesc': 'أصبح الحل الآن متاحًا لإعادة الاستخدام بواسطة الذكاء الاصطناعي.',
    'st.sbm.approvalFailed': 'فشلت الموافقة',
    'st.sbm.rejected': 'تم رفض الحل',
    'st.sbm.rejectedDesc': 'لن يستخدم الذكاء الاصطناعي هذا الحل.',
    'st.sbm.rejectionFailed': 'فشل الرفض',
    'st.sbm.missingInfo': 'معلومات ناقصة',
    'st.sbm.missingInfoDesc': 'يُرجى تعبئة العنوان والوصف وخطوات الحل.',
    'st.sbm.noBusiness': 'لم يتم اختيار نشاط تجاري',
    'st.sbm.noBusinessDesc': 'يتعذّر الإرسال — لا يوجد سياق نشاط تجاري نشط.',
    'st.sbm.updated': 'تم تحديث الحل',
    'st.sbm.updatedDesc': 'تم حفظ التغييرات بنجاح.',
    'st.sbm.submitted': 'تم إرسال الحل',
    'st.sbm.submittedDesc': 'تم إرسال الحل للحصول على موافقة الإدارة. الحالة: pending_approval.',
    'st.sbm.submitFailed': 'فشل الإرسال',
    'st.sbm.networkError': 'خطأ في الشبكة',
    'st.sbm.confirmDelete': 'حذف "{title}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'st.sbm.deleted': 'تم حذف الحل',
    'st.sbm.deletedDesc': 'تمت إزالة الحل نهائيًا.',
    'st.sbm.deleteFailed': 'فشل الحذف',
    'st.sbm.title': 'إدارة بنك الحلول',
    'st.sbm.subtitle': 'أنشئ وأدر حلولًا مدعومة بالذكاء الاصطناعي للمشكلات الشائعة',
    'st.sbm.editSolution': 'تعديل الحل',
    'st.sbm.structure': 'هيكل الحل',
    'st.sbm.fTitle': 'عنوان الحل *',
    'st.sbm.fTitlePh': 'عنوان موجز ووصفي لهذا الحل',
    'st.sbm.fDesc': 'وصف المشكلة *',
    'st.sbm.fDescPh': 'صِف المشكلة التي يعالجها هذا الحل',
    'st.sbm.fCategory': 'فئة المشكلة *',
    'st.sbm.categoryPh': 'اختر فئة المشكلة',
    'st.sbm.fType': 'نوع المشكلة *',
    'st.sbm.typePh': 'اختر نوع المشكلة',
    'st.sbm.fDifficulty': 'مستوى الصعوبة *',
    'st.sbm.difficultyPh': 'اختر مستوى الصعوبة',
    'st.sbm.diffLow': 'منخفض - حل بسيط وسريع',
    'st.sbm.diffMedium': 'متوسط - تعقيد معتدل',
    'st.sbm.diffHigh': 'عالٍ - حل معقّد وتقني',
    'st.sbm.fTags': 'الوسوم *',
    'st.sbm.tagsPh': 'كلمات مفتاحية مفصولة بفواصل',
    'st.sbm.tagsHelp': 'كلمات مفتاحية قد يستخدمها العملاء (مثل تسجيل الدخول، كلمة المرور، إعادة التعيين)',
    'st.sbm.fResolution': 'خطوات الحل *',
    'st.sbm.resolutionPh': 'أدخل كل خطوة في سطر جديد:\nالخطوة 1: انتقل إلى صفحة تسجيل الدخول\nالخطوة 2: انقر على نسيت كلمة المرور\nالخطوة 3: أدخل عنوان البريد الإلكتروني\nإلخ...',
    'st.sbm.resolutionHelp': 'اكتب تعليمات واضحة خطوة بخطوة. يجب أن تكون كل خطوة في سطر جديد.',
    'st.sbm.updateSolution': 'تحديث الحل',
    'st.sbm.addSolution': 'إضافة حل',
    'st.sbm.pendingApprovals': 'الموافقات المعلّقة',
    'st.sbm.nPending': '{count} معلّقة',
    'st.sbm.uncategorized': 'غير مصنّف',
    'st.sbm.submittedOn': 'أُرسِل في {date}',
    'st.sbm.noSolutions': 'لم يتم إنشاء حلول',
    'st.sbm.noSolutionsDesc': 'ابدأ ببناء قاعدة معرفتك بإضافة حلّك الأول',
    'st.sbm.addFirst': 'إضافة الحل الأول',
    'st.sbm.successRate': 'معدل نجاح {rate}%',
    'st.sbm.uses': '{count} استخدام',
    'st.sbm.keywords': 'الكلمات المفتاحية',
    'st.sbm.resolutionSteps': 'خطوات الحل',
    'st.sbm.lastUpdated': 'آخر تحديث: {date}',
    'st.sbm.addedBy': 'أضافه: {name}',
    'st.sbm.unknown': 'غير معروف',
    'st.conf.tapEnableAudio': 'انقر لتفعيل الصوت',
    'st.conf.inviting': 'جارٍ الدعوة…',
    'st.conf.noAnswer': 'لا يوجد رد',
    'st.conf.declined': 'مرفوضة',
    'st.conf.reconnecting': 'جارٍ إعادة الاتصال…',
    'st.conf.lost': 'انقطع',
    'st.conf.connected': 'متصل',
    'st.conf.noAudio': 'لا يوجد صوت',
    'st.conf.connectingAudio': 'جارٍ توصيل الصوت…',
    'st.conf.connecting': 'جارٍ الاتصال…',
    'st.conf.audioConference': 'مؤتمر صوتي',
    'st.conf.invitingYou': '{host} يدعوك إلى مؤتمر صوتي.',
    'st.conf.decline': 'رفض',
    'st.conf.accept': 'قبول',
    'st.conf.host': 'المضيف',
    'st.conf.participant': 'مشارك',
    'st.conf.you': 'أنت',
    'st.conf.muted': '(مكتوم)',
    'st.conf.unmute': 'إلغاء الكتم',
    'st.conf.mute': 'كتم',
    'st.conf.noOneYet': 'لا يوجد أحد آخر بعد — ادعُ زميلًا أدناه.',
    'st.conf.removeFromConf': 'إزالة من المؤتمر',
    'st.conf.addTeammate': '+ إضافة زميل متصل…',
    'st.conf.noStaffOnline': 'لا يوجد موظفون آخرون متصلون لإضافتهم حاليًا.',
    'st.conf.endConference': 'إنهاء المؤتمر',
    'st.conf.leave': 'مغادرة',
    'st.call.userFallback': 'المستخدم {id}',
    'st.call.shareVideoOnlyMsg': 'مشاركة الشاشة متاحة في مكالمات الفيديو.',
    'st.call.shareCouldNotStart': 'تعذّر بدء مشاركة الشاشة.',
    'st.call.onHold': 'قيد الانتظار • {dur}',
    'st.call.connected': 'متصل • {dur}',
    'st.call.connecting': 'جارٍ الاتصال...',
    'st.call.video': 'فيديو',
    'st.call.tapEnableCallAudio': '🔊 انقر لتفعيل صوت المكالمة',
    'st.call.callDuration': 'مدة المكالمة: {dur}',
    'st.call.resume': 'استئناف المكالمة',
    'st.call.hold': 'تعليق المكالمة',
    'st.call.sharingScreen': 'جارٍ مشاركة الشاشة',
    'st.call.shareScreen': 'مشاركة الشاشة',
    'st.call.shareVideoOnly': 'مشاركة الشاشة متاحة في مكالمات الفيديو',
    'st.call.endCall': 'إنهاء المكالمة',
    'st.call.callVolume': 'مستوى صوت المكالمة',
    'st.trial.errResolveTenant': 'تعذّر تحديد المؤسسة',
    'st.trial.errPortalUnavailable': 'البوابة غير متاحة',
    'st.trial.stripeFail': 'تعذّر فتح بوابة Stripe',
    'st.trial.stripeFailDesc': '{message}. جارٍ إعادة التوجيه إلى صفحة الفوترة.',
    'st.trial.frozenHeadline': 'اشتراكك متوقّف مؤقتًا — الحساب في وضع القراءة فقط',
    'st.trial.frozenSub': 'أعد التفعيل الآن لفتح تذاكر ومحادثات جديدة وإدارة الفريق.',
    'st.trial.reactivate': 'إعادة التفعيل',
    'st.trial.nDays': '{count} يوم',
    'st.trial.nHours': '{count} ساعة',
    'st.trial.nHour': '{count} ساعة',
    'st.trial.pastDueHeadline': 'فشل الدفع — حدّث بطاقتك قبل {remainder}',
    'st.trial.pastDueSub': 'سنعيد المحاولة تلقائيًا (المحاولة {attempt} من {max}). يبقى حسابك نشطًا خلال فترة السماح.',
    'st.trial.openingStripe': 'جارٍ فتح Stripe…',
    'st.trial.updatePayment': 'تحديث طريقة الدفع',
    'st.trial.expiredHeadline': 'انتهت فترتك التجريبية',
    'st.trial.expiredSub': 'قم بالترقية الآن للحفاظ على تواصل فريقك وعملائك.',
    'st.trial.upgradeNow': 'الترقية الآن',
    'st.trial.urgentHeadlineOne': 'تبقّت {count} ساعة فقط في فترتك التجريبية',
    'st.trial.urgentHeadline': 'تبقّت {count} ساعة فقط في فترتك التجريبية',
    'st.trial.soonSub': 'اختر خطة الآن للاحتفاظ بجميع الميزات والبيانات بعد انتهاء فترتك التجريبية.',
    'st.trial.soonHeadline': 'تبقّى {count} يوم في فترتك التجريبية',
    'st.trial.dismiss': 'تجاهل',
  },
};

export default settingsMiscTranslations;
